import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: {
                    description: {
                        "Dashboard": "Dashboard",
                        "Accounts": "Accounts",
                        "LiveAccounts": "Live Accounts",
                        "DemoAccounts": "Demo Accounts",
                        "ChangePassword": "Change Password",
                        "SwapFree": "Swap Free",
                        "passwordType": "Password Type",
                        "Deposit": "Deposit",
                        "Withdrawals": "Withdrawals",
                        "Withdrawal": "Withdrawal",
                        "InternalTransfer": "Internal Transfer",
                        "PaymentHistory": "Payment History",
                        "TradeHistory": "Trade History",
                        "Platforms": "Platforms",
                        // "Platform": "Platform",
                        "Documents": "Documents",
                        "LiveUpdates": "Live Updates",
                        "MarketUpdates": "Market Updates",
                        "MarketOverview": "Market Overview",
                        "EconomyCalander": "Economy Calander",
                        "Webinar": "Webinar",
                        "UpcomingWebinar": "Upcoming Webinar",
                        "Coaching": "Coaching",
                        "KYCStatus": "KYC Status",
                        "Pending": "Pending",
                        "Approved": "Approved",
                        "TradingStatus": "Trading Status",
                        "Disabled": "Disabled",
                        "Enabled": "Enabled",
                        "Profile": "Profile",
                        "SignOut": "Sign Out",
                        "BALANCE": "BALANCE",
                        "EQUITY": "EQUITY",
                        "DEPOSITS": "DEPOSITS",
                        "WITHDRAWAL": "WITHDRAWAL",
                        "TradingAccounts": "Trading Accounts",
                        "TradingPlatform": "Trading Platform",
                        "AccountNumber": "Account Number",
                        "Type": "Platform Type",
                        "Balance": "Balance",
                        "Equity": "Equity",
                        "Stopout": "Stopout",
                        "Leverage": "Leverage",
                        "Action": "Action",
                        "Account": "Account",
                        "GoDo-Live": "GoDo-Live",
                        "GoDo-Server": "GoDo-Server",
                        "GoDo-Demo": "GoDo-Demo",
                        "Currency": "Currency",
                        "FundNow": "Fund Now",
                        "CreateAccount": "Create Account",
                        "NewPassword": "New Password",
                        "ConfirmNewPassword": "Confirm New Password",
                        "Submit": "Submit",
                        "CardPayment": "Card Payment",
                        "BankTransfer": "Bank Transfer",
                        "CryptoDetails": "Crypto Details",
                        "PerfectMoney": "Perfect Money",
                        "SticPayment": "Stic Payment",
                        "Skrill": "Skrill",
                        "Neteller": "Neteller",
                        "Africa": "Africa",
                        "WishMoney": "Wish Money",
                        "LocalDeposit": "Local Deposit",
                        "Morocco": "Morocco",
                        "DepositCurrency": "Deposit Currency",
                        "AmountInUSD": "Amount in USD",
                        "AmountInMAD": "Amount in MAD",
                        "AmountInSYP": "Amount in SYP",
                        "Note": "Note",
                        "TradingAccount": "Trading Account",
                        "AfrAsiaBankUSD": "AfrAsia Bank USD",
                        "AfrAsiaBankEUR": "AfrAsia Bank EUR",
                        "AfrAsiaBankAED": "AfrAsia Bank AED",
                        "CBDBank": "CBD Bank",
                        "EqualsMoney": "Equals Money",
                        "Currencies": "Currencies",
                        "BeneficiaryName": "Beneficiary Name",
                        "BeneficiaryAccount": "Beneficiary Account",
                        "BeneficiaryAddress": "Beneficiary Address",
                        "BankName": "Bank Name",
                        "ID": "ID",
                        "BankAddress": "Bank Address",
                        "IBANNumber": "IBAN Number",
                        "SwiftCode": "Swift Code",
                        "MinimumAmount": "Minimum Amount",
                        "AccountForClient": "Account For Client",
                        "AfrAsiaBankLtd": "AfrAsia Bank Ltd",
                        "GODOLTD-CLIENTACCOUNT": "GODO LTD - CLIENT ACCOUNT",
                        "3rdFloor,StandardCharteredTower,Cybercity,Ebene,72201,Mauritius": "3rd Floor, Standard Chartered Tower, Cybercity, Ebene, 72201, Mauritius",
                        "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius": "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius",
                        "OnlineFunding": "Online Funding",
                        "Pleasenotecrypto": "Please note crypto deposits are accepted in USDT and USDC currencies only with the following conditions to protect the integrity of the transactions",
                        "The customer is responsible for any gas fees applied by the exchange": "The customer is responsible for any gas fees applied by the exchange",
                        "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department": "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department",
                        "All funds to be returned to original funding source": "All funds to be returned to original funding source",
                        "TradingAccountID": "Trading Account ID",
                        "DepositAmountinUSD": "Deposit Amount in USD",
                        "WalletAddress": "Wallet Address",
                        "Iacceptthe": "I accept the",
                        "TermsandConditionsforCreditCardDisclaimer": "Terms and Conditions for Credit Card Disclaimer",
                        "Next": "Next",
                        "PayeeAccount": "Payee Account",
                        "SupportService": "Support Service",
                        "Doyouhaveaquestion": "Do you have a question about deposit? Please contact",
                        "ourFinancialSupportService": "our Financial Support Service.",
                        "Information": "Information",
                        "Exchangeratesandcommission": "Exchange rates and commission",
                        "Paymentagentcontacts": "Payment agent contacts",
                        "AgentName": "Agent Name",
                        "MoroccoPaymentAgent": "Morocco Payment Agent",
                        "Website": "Website",
                        "WorkingHours": "Working Hours",
                        "WhishMoneyPaymentInstructions": "Whish Money Payment Instructions",
                        "Step-by-Step Instructions1. Download and Install the Wish Money App": "Step-by-Step Instructions1. Download and Install the Wish Money App",
                        "Visit the Wish Money App download page.": "Visit the Wish Money App download page.",
                        "Download and install the app on your mobile device.": "Download and install the app on your mobile device.",
                        "Login to the Wish Money App": "Login to the Wish Money App",
                        "Open the app.": "Open the app.",
                        "Enter your login credentials to access your account.": "Enter your login credentials to access your account.",
                        "Navigate to the Finance Category": "Navigate to the Finance Category",
                        "After logging in, choose the 'Finance' category from the menu options.": "After logging in, choose the 'Finance' category from the menu options.",
                        "Enter the Receiver's Phone Number": "Enter the Receiver's Phone Number",
                        "In the designated field, input the receiver's phone number: 71180175.": "In the designated field, input the receiver's phone number: 71180175.",
                        "Specify the Transfer Amount": "Specify the Transfer Amount",
                        "Enter the amount you wish to transfer in USD.": "Enter the amount you wish to transfer in USD.",
                        "Add a Note with Your Trading Account Details": "Add a Note with Your Trading Account Details",
                        "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.": "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.",
                        "Complete the Transaction": "Complete the Transaction",
                        "Review all the details to ensure accuracy.": "Review all the details to ensure accuracy.",
                        "Click the 'Send' button to complete the transaction.": "Click the 'Send' button to complete the transaction.",
                        "WithdrawalMethod": "Withdrawal Method",
                        "Amount": "Amount",
                        "ImportantInformation": "Important Information",
                        "Allfunds": "All funds will be returned to the original funding source.",
                        "Youareentitled": "You are entitled to one free withdrawal per month; after that, a standard withdrawal fee of $25 applies.",
                        "FromAccount": "From Account",
                        "ToAccount": "To Account",
                        "ReportType": "Report Type",
                        "DateFrom": "Date From",
                        "DateTo": "Date To",
                        "Search": "Search",
                        "Time": "Time",
                        "Status": "Status",
                        "PENDING": "PENDING",
                        "REJECTED": "REJECTED",
                        "APPROVED": "APPROVED",
                        "AccountType": "Account Type",
                        "PROCEED": "PROCEED",
                        "ViewTrades": "View Trades",
                        "Open Position": "Open Position",
                        "Close Position": "Close Position",
                        "Symbol": "Symbol",
                        "Ticket": "Ticket",
                        "DealType": "Deal Type",
                        "Volume": "Volume",
                        "Price": "Price",
                        "PriceOpen": "Price Open",
                        "PriceSI": "Price SI",
                        "PriceTP": "Price TP",
                        "PriceCurrent": "Price Current",
                        "Login": "Login",
                        "NoData": "No Data",
                        "DownloadsForMT5": "Downloads For MT5",
                        "DownloadsForMT4": "Downloads For MT4",
                        "DownloadsForCTrader": "Downloads For CTrader",
                        "DownloadNow": "Download Now",
                        "forAndroid": "for Android",
                        "forWindow": "for Window",
                        "forMAC": "for MAC",
                        "forPC": "for PC",
                        "UploadDocuments": "Upload Documents",
                        "ProofofID": "Proof of ID (Front page of passport OR Front and Back side of ID)",
                        "ProofofAddress": "Proof of Address",
                        "SourceofIncome": "Source of Income",
                        "AdditionalDocuments": "Additional Documents",
                        "ProofofIdentity": "Proof of Identity",
                        "CopyofPassport": "Copy of Passport",
                        "CopyofGovernmentIssuedID": "Copy of Government Issued ID",
                        "ProofofResidentialAddress": "Proof of Residential Address",
                        "UtilityBill": "Utility Bill",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "Current Lease/Tenancy Agreement Source Of Income",
                        "Recentbankstatementshowingsalary": "Recent bank statement showing salary",
                        "Payslip": "Payslip",
                        "EmploymentContracttoshowyourincomefunds": "Employment Contract to show your income funds",
                        "NoteDocuments": "Note: Documents must be issued within the last 3 calendar months",
                        "Title": "Title",
                        "UploadedAt": "Uploaded At",
                        "KYCDocuments": "KYC Documents",
                        "OPENANEWDEMOACCOUNT": "OPEN A NEW DEMO ACCOUNT",
                        "OPENANEWLIVEACCOUNT": "OPEN A NEW LIVE ACCOUNT",
                        "File": "File",
                        "WhishMoneyInstructions": "To transfer funds using the Whish Money App, please follow the steps below:",
                        "StepByStepInstructions": "Step-by-Step Instructions",
                        "Step1": "1. Download and Install the Whish Money App:",
                        "Step1Details": "Visit the.",
                        "Step1Details1": "Whish Money App download page.",
                        "Step1Details2": "Download and install the app on your mobile device.",
                        "Step2": "2. Login to the Whish Money App:",
                        "Step2Details": "Open the app.",
                        "Step2Details1": "Enter your login credentials to access your account.",
                        "Step3": "3. Navigate to the Finance Category:",
                        "Step3Details": "After logging in, choose the 'Finance' category from the menu options.",
                        "Step4": "4. Enter the Receiver's Phone Number:",
                        "Step4Details": "In the designated field, input the receiver's phone number: 71180175.",
                        "Step5": "5. Specify the Transfer Amount:",
                        "Step5Details": "Enter the amount you wish to transfer in USD.",
                        "Step6": "6. Add a Note with Your Trading Account Details:",
                        "Step6Details": "In the note field, enter your trading account number followed by - GoDoCM Dubai.",
                        "Step6Details1": "Example: 12345678 - GoDoCM Dubai.",
                        "Step7": "7. Complete the Transaction:",
                        "Step7Details": "Review all the details to ensure accuracy.",
                        "Steps7Details1": "Click the 'Send' button to complete the transaction.",
                        "CryptoCurrency": "Crypto Currency",
                        "Network": "Network",
                        "Address": "Address",
                        "PleaseNoteMinimumWithdrawal": "Please note minimum withdrawal amount is 10$",
                        "AddWallet": "Add Wallet",
                        "Wallet": "Wallet",
                        "AddNewWallet": "Add New Wallet",
                        "Add": "Add",
                        "OpenPosition": "Open Position",
                        "ClosePosition": "Close Position",
                        "Profit": "Profit",
                        "Platform": "Platform",
                        "Iran": "Iran",
                        "DealId": "Deal Id",
                        "Entry": "Entry",
                        "PositionId": "PositionId",
                        "OpenTimeStamp": "OpenTimeStamp",
                        "CloseTimeStamp": "CloseTimeStamp",
                        "EntryPrice": "EntryPrice",
                        "ClosePrice": "ClosePrice",
                        "Direction": "Direction",
                        "Commission": "Commission",
                        "Swap": "Swap",
                        "usedMargin": "usedMargin",
                        "forIso": "for Ios",
                        "Iraq": "Iraq",
                        "Turkey": "Turkey",
                        "Jordan": "Jordan",
                        "Pakistan": "Pakistan",
                        "India": "India",
                        "PayPal": "PayPal",
                        "Russia": "Russia",
                        "mexapay": "MexaPay",
                        "InstructionsforTransferringFundsUsingWhishMoney": "Instructions for Transferring Funds Using Whish Money",
                        "AccesstheWhishMoneyApp": "Access the Whish Money App:",
                        "AccessTheWhishMoneyApp": "Open the Whish Money app on your phone.",
                        "CompleteTheTransfer": "Complete the Transfer",
                        "RecipientsPhoneNumber": "Enter the recipient’s phone number: 70809031.",
                        "TransferAmount": "Enter the transfer amount in USD.",
                        "Fee": "Important Note: Add a 1% fee to the transfer amount.",
                        "Example": "Example If you wish to transfer $100, send $101.",
                        "SendAReceiptImage": "After completing the transaction, take a clear photo of the receipt and send it via WhatsApp to",
                        "SendaReceipt": "Send a Receipt Image:",
                        "ConfirmtheInfo": "4. Confirm the Information:",
                        "ConfirmTheInformation": "Ensure all entered details are correct.",
                        "InstructionsforTransferringFundsUsingOMT": "Instructions for Transferring Funds Using OMT",
                        "AccesstheOMT": "Access the OMT App:",
                        "AccessTheOMTApp": "Open the OMT app on your phone.",
                        "CompleteTransfer": "Complete the Transfer",
                        "RecipientsPhoneNumberOMT": "Enter the recipient’s phone number: 70809031.",
                        "TransferAmountOMT": "Enter the transfer amount in USD.",
                        "SendAReceiptImageOMT": "After completing the transaction, take a clear photo of the receipt and send it via WhatsApp to",
                        "ConfirmtheInfoOMT": "Confirm the Information:",
                        "ProfitWithdrawalProcedures": "Profit Withdrawal Procedures",
                        "RequestAWithdrawal": "Request a Withdrawal:",
                        "ProfitWithdrawalRequest": "Send a profit withdrawal request via WhatsApp to,",
                        "ProfitWithdrawalRequest2": "specifying the amount to be withdrawn.",
                        "CompleteTheProcess": "Complete the Process:",
                        "WithdrawalProcess": "The request will be processed after the details are reviewed.",
                        "InstructionsforDepositingFundsviaInstaPay": "Instructions for Depositing Funds via InstaPay",
                        "OpenInstaPayApp": "Open the InstaPay App",
                        "LaunchtheInstaPayapponyourphone": "Launch the InstaPay app on your phone.",
                        "TransferDetails": "TransferDetails",
                        "EnterRecipientAccountNumber": "Enter the recipient’s account email: mglamie@instapay",
                        "Thetransferrate": "The transfer rate: ",
                        "TransferRate": "1 USD = 49 EGP",
                        "ExampleDeposit": "Example: To Deposit $100, Send 4900 EGP",
                        "CompleteTransaction": "Complete the Transaction",
                        "Confirmthedetailsandfinalizethetransfer": "Confirm the details and finalize the transfer.",
                        "SaveTransactionReceipt": "Save the Transaction Receipt",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "Take a screenshot or note down the transaction ID for future reference.",
                        "InstaPay": "InstaPay",
                        "JordanPay": "Jordan",
                        "RusiaPay": "Russia",
                        "DuitPay": "Duit Now",
                        "TurkeyPay": "Turkey",
                        "IraqPay": "Iraq",
                        "UploadReceipt": "Upload Receipt",
                        "UploadPaymentReceipt": "Upload Payment Receipt",
                        "OrderId": "OrderId",
                        "NetSettle": "Net Settle",
                        "EndTime": "Expiry Time",
                        "TouchNGo": "Touch N Go",
                        "FPXPay": "FPX Pay",
                        "GTNType": "Type",
                        "Exchange": "Exchange",
                        "ISINCode": "ISINCode",
                        "Channel": "Channel",
                        "DownloadsForGTN": "Downloads For GTN",
                        "ImportantNote": "Important Note",
                        "ToChangePassword": "To change GTN password, visit this link",
                        "GTNLogin": "GTN Login",
                        "LoginToGTN": "and log into your GTN account to change password",
                        "ChangingPassword": "Changing password here will (only change client protal) password not GTN trading platform password",
                        "BankAccount": "Bank Account",
                        "ReceiverName": "Receiver Name",
                        "SelectCreditBonus": "Select Your Credit Bonus",
                        "ReviewConditions": "Before choosing you credit bonus, please read the",
                        "BonusTermsConditions": "Bonus Terms & Conditions",
                        "Carefully": "carefully.",
                        "Bonus": "Bonus",
                        "ClaimBonus": "🎁 Claim Bonus",
                        "PreferredBonus": "Choose your preferred bonus percentage from the dropdown with the account number.",
                        "Acknowledgment": "✅ Acknowledgment",
                        "SubmitBonusRequest": "By clicking Submit Bonus Request, you acknowledge that:",
                        "AcceptedTerms": "You have read and accepted the Bonus Terms & Conditions.",
                        "AcceptedTerms1": "You understand that bonus credits are promotional and subject to GODO’s internal policies.",
                        "AcceptedTerms2": "GODO reserves the right to modify or terminate the bonus at any time, without prior notice or explanation",
                        "request": "Request Swap-Free Account",
                        "ImpNote": "Important Notes",
                        "description": "If you wish to request a Swap-Free (Islamic) trading account, please read the",
                        "terms": "terms",
                        "carefully": "carefully before submitting your request.",
                        "swapApproval": "Swap-Free status is subject to approval by GODO's Risk Team.",
                        "swapRights": "GODO reserves the right to revoke or modify Swap-Free status at any time without prior notice.",
                        "swapPurpose": "Swap-Free accounts are meant strictly for clients who follow Islamic finance principles."
                    }
                }
            },
            ar: {
                translation: {
                    description: {
                        "Dashboard": "لوحة التحكم",
                        "Accounts": "الحسابات",
                        "LiveAccounts": "حساب حقيقي",
                        "DemoAccounts": "حساب تجريبي",
                        "passwordType": "نوع كلمة السر",
                        "ChangePassword": "تغيير كلمة المرور",
                        "Deposit": "الإيداع",
                        "Withdrawals": "السحب",
                        "Withdrawal": "السحب",
                        "WITHDRAWAL": "السحب",
                        "InternalTransfer": "تحويل داخلي",
                        "PaymentHistory": "تاريخ المدفوعات",
                        "TradeHistory": "تاريخ التداول",
                        "Platforms": "المنصات",
                        "Documents": "الوثائق",
                        "LiveUpdates": "التحديثات الحية",
                        "MarketUpdates": "تحديثات السوق",
                        "MarketOverview": "نظرة على الأسواق",
                        "EconomyCalander": "التقويم الاقتصادي",
                        "Webinar": "الندوات",
                        "UpcomingWebinar": "الندوة القادمة",
                        "Coaching": "التدريب",
                        "KYCStatus": "حالة KYC",
                        "Pending": "قيد الانتظار",
                        "Approved": "موافق عليه",
                        "TradingStatus": "حالة التداول",
                        "Disabled": "معطل",
                        "Enabled": "نشط",
                        "Profile": "الملف الشخصي",
                        "SignOut": "تسجيل الخروج",
                        "Balance": "رأس المال",
                        "Equity": "رأس المال الحالي",
                        "Deposits": "الودائع",
                        "DEPOSITS": "الودائع",
                        "WithdrawalS": "السحب",
                        "TradingAccounts": "حسابات التداول",
                        "TradingPlatform": "منصة التداول",
                        "AccountNumber": "رقم الحساب",
                        // "Platform": "المنصة",
                        "Type": "نوع المنصة",
                        "BALANCE": "رأس المال",
                        "EQUITY": "رأس المال الحالي",
                        "Stopout": "وقف الخسارة",
                        "Leverage": "الرافعة المالية",
                        "Action": "الإجراء",
                        "Account": "الحساب",
                        "GoDo-Live": "GoDo لايف",
                        "GoDo-Server": "GoDo الخادم",
                        "GoDo-Demo": "GoDo – التجريبي",
                        "Currency": "العملة",
                        "FundNow": "تمويل الحساب",
                        "CreateAccount": "إنشاء حساب جديد",
                        "NewPassword": "إنشاء كلمة مرور جديدة",
                        "ConfirmNewPassword": "تأكيد كلمة المرور الجديدة",
                        "Submit": "إرسال",
                        "CardPayment": "الدفع بالبطاقة",
                        "BankTransfer": "التحويل البنكي",
                        "CryptoDetails": "تفاصيل العملة الرقمية",
                        "PerfectMoney": "بيرفكت موني",
                        "SticPayment": "ستك بايمنت",
                        "Skrill": "سكريل",
                        "Neteller": "نتيلر",
                        "Africa": "أفريقيا",
                        "WishMoney": "ويش موني",
                        "LocalDeposit": "إيداع محلي",
                        "Morocco": "المغرب",
                        "DepositCurrency": "عملة الإيداع",
                        "AmountInUSD": "المبلغ بالدولار الأمريكي",
                        "AmountInMAD": "المبلغ بالدرهم المغربي",
                        "AmountInSYP": "المبلغ بالليرة السورية",
                        "Note": "ملاحظة",
                        "TradingAccount": "حساب التداول",
                        "AfrAsiaBankUSD": "بنك أفراسيا بالدولار الأمريكي",
                        "AfrAsiaBankEUR": "بنك أفراسيا باليورو",
                        "AfrAsiaBankAED": "بنك أفراسيا بالدرهم الإماراتي",
                        "CBDBank": "بنك CBD",
                        "EqualsMoney": "إيكوالز موني",
                        "Currencies": "العملات",
                        "BeneficiaryName": "اسم البنك المستفيد",
                        "BeneficiaryAccount": "الحساب المستفيد",
                        "BeneficiaryAddress": "العنوان المستفيد",
                        "BankName": "اسم البنك",
                        "ID": "الهوية",
                        "BankAddress": "عنوان البنك",
                        "AccountNumbers": "رقم الحساب",
                        "IBANNumber": "رقم الآيبان",
                        "SwiftCode": "كود SWIFT",
                        "MinimumAmount": "الحد الأدنى للمبلغ",
                        "AccountForClient": "حساب العميل",
                        "AfrAsiaBankLtd": "بنك أفراسيا المحدود",
                        "GODOLTD-CLIENTACCOUNT": "GODO LTD - حساب العميل",
                        "3rdFloorStandardCharteredTowerCybercityEbene72201Mauritius": "الطابق الثالث، برج ستاندرد تشارترد، سايبر سيتي، إيبين، 72201، موريشيوس",
                        "BowenSquare10DrFerriereStreetPortLouisMauritius": "ميدان بوين 10، شارع الدكتور فيرير، بورت لويس، موريشيوس",
                        "OnlineFunding": "التمويل عبر الإنترنت",
                        "Pleasenotecrypto": "يرجى ملاحظة أن الودائع بالعملات الرقمية مقبولة فقط بعملتي USDT وUSDC مع الشروط التالية لحماية نزاهة المعاملات",
                        "CryptoDepositNote": "يرجى العلم أنه يتم قبول إيداعات العملات الرقمية بعملتي USDT وUSDC فقط مع الشروط التالية لضمان سلامة المعاملات",
                        "GasFeesNote": "العميل مسؤول عن أي رسوم معاملات يتم تطبيقها.",
                        "WithdrawalBlockNote": "سيتم حظر السحوبات لمدة 15 يومًا ما لم يتم مراجعة الحساب مسبقًا من قبل قسم الامتثال لدينا",
                        "FundsReturnNote": "جميع الأموال سيتم إعادتها إلى مصدر التمويل الأصلي",
                        "TradingAccountID": "معرف حساب التداول",
                        "DepositAmountInUSD": "مبلغ الإيداع بالدولار الأمريكي",
                        "WalletAddress": "عنوان المحفظة",
                        "IAcceptThe": "أوافق على",
                        "TermsAndConditionsForCreditCardDisclaimer": "شروط وأحكام إخلاء المسؤولية عن بطاقة الائتمان",
                        "Next": "التالي",
                        "PayeeAccount": "حساب المستفيد",
                        "SupportService": "خدمة الدعم",
                        "Doyouhaveaquestion": "هل لديك سؤال حول الإيداع؟ يرجى التواصل مع",
                        "ourFinancialSupportService": "خدمة الدعم المالي لدينا.",
                        "DepositQuestion": "هل لديك سؤال حول الإيداع؟ يرجى الاتصال بخدمة الدعم المالي لدينا.",
                        "Information": "معلومات",
                        "Exchangeratesandcommission": "أسعار الصرف والعمولات",
                        "Paymentagentcontacts": "جهات اتصال وكيل الدفع",
                        "ExchangeRatesAndCommission": "أسعار الصرف والعمولة",
                        "PaymentAgentContacts": "جهات اتصال وكيل الدفع",
                        "AgentName": "اسم الوكيل",
                        "MoroccoPaymentAgent": "وكيل الدفع في المغرب",
                        "Website": "الموقع الإلكتروني",
                        "WorkingHours": "ساعات العمل",
                        "WhishMoneyPaymentInstructions": "تعليمات دفع Whish Money",
                        "WishMoneyInstructions": "تعليمات تحميل وتثبيت تطبيق Wish Money",
                        "WishMoneyStep1": "قم بزيارة صفحة تنزيل تطبيق Wish Money",
                        "WishMoneyStep2": "قم بتنزيل التطبيق وتثبيته على جهازك المحمول.",
                        "WishMoneyLogin": "قم بتسجيل الدخول إلى تطبيق Wish Money",
                        "WishMoneyStep3": "افتح التطبيق.",
                        "WishMoneyStep4": "أدخل بيانات تسجيل الدخول الخاصة بك للوصول إلى حسابك.",
                        "WishMoneyFinance": "انتقل إلى الفئة المالية",
                        "WishMoneyStep5": "بعد تسجيل الدخول، اختر الفئة 'المالية' من خيارات القائمة",
                        "WishMoneyReceiverNumber": "أدخل رقم هاتف المستلم",
                        "WishMoneyStep6": "في الحقل المخصص، أدخل رقم هاتف المستلم: 71180175",
                        "WishMoneyTransferAmount": "حدد مبلغ التحويل",
                        "WishMoneyAmountInUSD": "أدخل المبلغ الذي ترغب في تحويله بالدولار الأمريكي.",
                        "WishMoneyNote": "أضف ملاحظة مع تفاصيل حساب التداول الخاص بك",
                        "WishMoneyTradingAccountNote": "في حقل الملاحظة، أدخل رقم حساب التداول الخاص بك متبوعًا بـ - GoDoCM Dubai. مثال: 12345678 - GoDoCM Dubai.",
                        "WishMoneyCompleteTransaction": "أكمل المعاملة",
                        "WishMoneyStep7": "راجع جميع التفاصيل للتأكد من صحتها.",
                        "WishMoneySend": "انقر فوق زر 'إرسال' لإكمال المعاملة.",
                        "WithdrawalMethod": "طريقة السحب",
                        "Amount": "المبلغ",
                        "ImportantInformation": "معلومات هامة",
                        "Allfunds": "سيتم إعادة جميع الأموال إلى مصدر التمويل الأصلي.",
                        "Youareentitled": "يحق لك سحب واحد مجاني شهريًا؛ بعد ذلك، يتم تطبيق رسوم سحب قياسية قدرها 25 دولارًا.",
                        "FundsReturn": "سيتم إعادة جميع الأموال إلى مصدر التمويل الأصلي.",
                        "FreeWithdrawalNote": "يحق لك سحب مجاني واحد شهريًا؛ بعد ذلك، يتم تطبيق رسوم سحب قياسية قدرها 25 دولارًا.",
                        "FromAccount": "من الحساب",
                        "ToAccount": "إلى الحساب",
                        "ReportType": "نوع التقرير",
                        "DateFrom": "التاريخ من",
                        "DateTo": "التاريخ إلى",
                        "Search": "بحث",
                        "Time": "الوقت",
                        "Status": "الحالة",
                        "PENDING": "قيد الانتظار",
                        "Rejected": "مرفوض",
                        "APPROVED": "مقبول",
                        "AccountType": "نوع الحساب",
                        "ViewTrades": "عرض الصفقات",
                        "OpenPosition": "فتح مركز",
                        "ClosePosition": "إغلاق مركز",
                        "Symbol": "الرمز",
                        "Ticket": "التذكرة",
                        "DealType": "نوع الصفقة",
                        "Volume": "الحجم",
                        "Price": "السعر",
                        "PriceOpen": "سعر الفتح",
                        "PriceSI": "وقف الخسارة",
                        "PriceTP": "جني الأرباح",
                        "PriceCurrent": "السعر الحالي",
                        "Login": "تسجيل الدخول",
                        "NoData": "لا توجد بيانات",
                        "DownloadsForMT5": "التنزيلات لـ MT5",
                        "DownloadsForMT4": "التنزيلات لـ MT4",
                        "DownloadsForCTrader": "التنزيلات لـ CTrader",
                        "DownloadNow": "قم بالتنزيل الآن",
                        "forAndroid": "لأجهزة الأندرويد",
                        "forWindow": "لنظام ويندوز",
                        "forMAC": "لنظام ماك",
                        "forPC": "للكمبيوتر الشخصي",
                        "Margin": "الهامش",
                        "FreeMargin": "الهامش المتاح",
                        "MarginLevel": "مستوى الهامش",
                        "PL": "الأرباح/الخسائر",
                        "WhishMoneyInstructions": "لتحويل الأموال باستخدام تطبيق Whish Money، يرجى اتباع الخطوات التالية:",
                        "StepByStepInstructions": "تعليمات خطوة بخطوة",
                        "Step1": "1. قم بتنزيل وتثبيت تطبيق Whish Money:",
                        "Step1Details": "قم بزيارة.",
                        "Step1Details1": "صفحة تنزيل تطبيق Whish Money.",
                        "Step1Details2": "قم بتنزيل التطبيق وتثبيته على جهازك المحمول.",
                        "Step2": "2. تسجيل الدخول إلى تطبيق Whish Money:",
                        "Step2Details": "افتح التطبيق.",
                        "Step2Details1": "أدخل بيانات تسجيل الدخول الخاصة بك للوصول إلى حسابك",
                        "Step3": "3. انتقل إلى فئة المالية:",
                        "Step3Details": "بعد تسجيل الدخول، اختر فئة 'المالية' من خيارات القائمة.",
                        "Step4": "4. أدخل رقم هاتف المستلم:",
                        "Step4Details": "في الحقل المخصص، أدخل رقم هاتف المستلم: 71180175.",
                        "Step5": "5. حدد مبلغ التحويل:",
                        "Step5Details": "أدخل المبلغ الذي ترغب في تحويله بالدولار الأمريكي.",
                        "Step6": "6. أضف ملاحظة تحتوي على تفاصيل حساب التداول الخاص بك:",
                        "Step6Details": "في حقل الملاحظات، أدخل رقم حساب التداول الخاص بك متبوعًا بـ - GoDoCM دبي.",
                        "Step6Details1": "مثال: 12345678 - GoDoCM دبي.",
                        "Step7": "7. أكمل المعاملة:",
                        "Step7Details": "راجع جميع التفاصيل للتأكد من صحتها.",
                        "Steps7Details1": "انقر على زر 'إرسال' لإتمام المعاملة.",
                        "CryptoCurrency": "العملة المشفرة",
                        "Network": "الشبكة",
                        "Address": "العنوان",
                        "PleaseNoteMinimumWithdrawal": "يرجى ملاحظة أن الحد الأدنى لمبلغ السحب هو 10 دولارات.",
                        "AddWallet": "إضافة محفظة",
                        "Wallet": "محفظة",
                        "AddNewWallet": "إضافة محفظة جديدة",
                        "Add": "إضافة",
                        "Profit": "الربح",
                        "KYCDocuments": "مستندات اعرف عميلك",
                        "UploadDocuments": "تحميل المستندات",
                        "ProofofID": "إثبات الهوية (الصفحة الأمامية من جواز السفر أو الجهتان الأمامية والخلفية للهوية)",
                        "ProofofAddress": "إثبات العنوان",
                        "SourceofIncome": "مصدر الدخل",
                        "AdditionalDocuments": "مستندات إضافية",
                        "ProofofIdentity": "إثبات الهوية",
                        "CopyofPassport": "نسخة من جواز السفر",
                        "CopyofGovernmentIssuedID": "نسخة من بطاقة الهوية الصادرة عن الحكومة",
                        "ProofofResidentialAddress": "إثبات العنوان السكني",
                        "UtilityBill": "فاتورة خدمات",
                        "Payslip": "قسيمة الراتب",
                        "NoteDocuments": "ملاحظة: يجب إصدار المستندات في آخر 3 أشهر تقويمية",
                        "EmploymentContracttoshowyourincomefunds": "عقد العمل لإظهار مصادر دخلك",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "عقد الإيجار الحالي / اتفاقية الإيجار - مصدر الدخل",
                        "Recentbankstatementshowingsalary": "كشف حساب بنكي حديث يظهر الراتب",
                        "Platform": "المنصة",
                        "Iran": "إيران",
                        "DealId": "معرف الصفقة",
                        "Entry": "إدخال",
                        "PositionId": "معرف الموضع",
                        "OpenTimeStamp": "وقت الفتح",
                        "EntryPrice": "سعر الدخول",
                        "Direction": "الاتجاه",
                        "Commission": "العمولة",
                        "Swap": "المبادلة",
                        "usedMargin": "الهامش المستخدم",
                        "CloseTimeStamp": "وقت الإغلاق",
                        "ClosePrice": "سعر الإغلاق",
                        "forIso": "لـ ISO",
                        "Iraq": "العراق",
                        "Turkey": "تركيا",
                        "Jordan": "الأردن",
                        "Pakistan": "باكستان",
                        "India": "الهند",
                        "PayPal": "باي بال",
                        "Russia": "روسيا",
                        "mexapay": "مكسا باي",
                        "FPXPay": "FPX Pay",
                        "InstructionsforTransferringFundsUsingWhishMoney": "تعليمات لتحويل الأموال باستخدام Whish Money",
                        "AccesstheWhishMoneyApp": "الوصول إلى تطبيق Whish Money:",
                        "AccessTheWhishMoneyApp": "افتح تطبيق Whish Money على هاتفك.",
                        "CompleteTheTransfer": "إتمام التحويل",
                        "RecipientsPhoneNumber": "أدخل رقم هاتف المستلم: 70809031.",
                        "TransferAmount": "أدخل مبلغ التحويل بالدولار الأمريكي.",
                        "Fee": "ملاحظة هامة: أضف 1٪ كرسوم على مبلغ التحويل.",
                        "Example": "مثال: إذا كنت ترغب في تحويل 100 دولار، أرسل 101 دولار.",
                        "SendAReceiptImage": "بعد إتمام المعاملة، التقط صورة واضحة للإيصال وأرسلها عبر WhatsApp إلى.",
                        "SendaReceipt": "إرسال صورة إيصال:",
                        "ConfirmtheInfo": "4. تأكيد المعلومات:",
                        "ConfirmTheInformation": "تأكد من صحة جميع التفاصيل المدخلة.",
                        "InstructionsforTransferringFundsUsingOMT": "تعليمات لتحويل الأموال باستخدام OMT",
                        "AccesstheOMT": "الوصول إلى تطبيق OMT:",
                        "AccessTheOMTApp": "افتح تطبيق OMT على هاتفك.",
                        "CompleteTransfer": "إتمام التحويل",
                        "RecipientsPhoneNumberOMT": "أدخل رقم هاتف المستلم: 70809031.",
                        "TransferAmountOMT": "أدخل مبلغ التحويل بالدولار الأمريكي.",
                        "SendAReceiptImageOMT": "بعد إتمام المعاملة، التقط صورة واضحة للإيصال وأرسلها عبر WhatsApp إلى",
                        "ConfirmtheInfoOMT": "تأكيد المعلومات:",
                        "ProfitWithdrawalProcedures": "إجراءات سحب الأرباح",
                        "RequestAWithdrawal": "طلب سحب:",
                        "ProfitWithdrawalRequest": "أرسل طلب سحب الأرباح عبر واتساب إلى،",
                        "ProfitWithdrawalRequest2": "محددًا المبلغ الذي ترغب في سحبه.",
                        "CompleteTheProcess": "إتمام العملية:",
                        "WithdrawalProcess": "سيتم معالجة الطلب بعد مراجعة التفاصيل.",
                        "InstructionsforDepositingFundsviaInstaPay": "تعليمات لإيداع الأموال عبر إنستاباي",
                        "OpenInstaPayApp": "افتح تطبيق إنستاباي",
                        "LaunchtheInstaPayapponyourphone": "افتح تطبيق إنستاباي على هاتفك.",
                        "TransferDetails": "تفاصيل التحويل",
                        "EnterRecipientAccountNumber": "أدخل رقم حساب المستلم: mglamie@instapay",
                        "TheTransferRate": "سعر التحويل: ",
                        "TransferRate": "1 دولار أمريكي = 49 جنيه مصري",
                        "ExampleDeposit": "مثال: لإيداع 100 دولار، أرسل 4900 جنيه مصري",
                        "CompleteTransaction": "إكمال المعاملة",
                        "Confirmthedetailsandfinalizethetransfer": "أكد التفاصيل وأكمل التحويل.",
                        "SaveTransactionReceipt": "حفظ إيصال المعاملة",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "خذ لقطة شاشة أو دون معرف المعاملة للرجوع إليها في المستقبل.",
                        "InstaPay": "إنستا باي",
                        "JordanPay": "الأردن",
                        "RusiaPay": "روسيا",
                        "TurkeyPay": "تركيا",
                        "DuitPay": "Duit Now",
                        "IraqPay": "العراق",
                        "UploadReceipt": "تحميل الإيصال",
                        "UploadPaymentReceipt": "تحميل إيصال الدفع",
                        "OrderId": "معرف الطلب",
                        "NetSettle": "التسوية الصافية",
                        "Expiry Time": "وقت انتهاء الصلاحية",
                        "GTNType": "النوع",
                        "Exchange": "البورصة",
                        "ISINCode": "رمز ISIN",
                        "Channel": "القناة",
                        "DownloadsForGTN": "التنزيلات لـ GTN",
                        "ImportantNote": "ملاحظة هامة",
                        "ToChangePassword": "لتغيير كلمة مرور GTN، قم بزيارة هذا الرابط",
                        "GTNLogin": "تسجيل الدخول إلى GTN",
                        "LoginToGTN": "وقم بتسجيل الدخول إلى حساب GTN الخاص بك لتغيير كلمة المرور",
                        "ChangingPassword": "تغيير كلمة المرور هنا سيغير فقط كلمة مرور بوابة العميل، وليس كلمة مرور منصة التداول GTN",
                        "BankAccount": "حساب بنكي",
                        "ReceiverName": "اسم المستلم",
                        "SelectCreditBonus": "اختر مكافأة الائتمان",
                        "ReviewConditions": ":يرجى مراجعة شروط وأحكام المكافأة قبل اختيار مكافأة الائتمان الخاصة بك من خلال النقر على الرابط أدناه.",
                        "BonusTermsConditions": "شروط وأحكام المكافأة",
                        "bonus": "مكافأة",
                        "ClaimBonus": "🎁 المطالبة بالمكافأة",
                        "PreferredBonus": "اختر النسبة المئوية المفضلة للمكافأة من القائمة المنسدلة مع رقم الحساب.",
                        "Acknowledgment": "✅ الإقرار",
                        "SubmitBonusRequest": "بالنقر على إرسال طلب المكافأة، فإنك تقر بأن:",
                        "AcceptedTerms": "لقد قرأت ووافقت على شروط وأحكام المكافأة.",
                        "AcceptedTerms1": "أنت تفهم أن أرصدة المكافأة ترويجية وتخضع لسياسات GODO الداخلية.",
                        "AcceptedTerms2": "تحتفظ GODO بالحق في تعديل أو إنهاء المكافأة في أي وقت، دون إشعار مسبق أو تفسير",
                        "request": "طلب حساب خالي من الفوائد",
                        "ImpNote": "ملاحظات مهمة",
                        "description": "إذا كنت ترغب في طلب حساب تداول خالي من الفوائد (إسلامي)، يرجى قراءة",
                        "terms": "الشروط",
                        "carefully": "بعناية قبل تقديم طلبك.",
                        "swapApproval": "تخضع حالة الحساب الخالي من الفوائد لموافقة فريق المخاطر في GODO.",
                        "swapRights": "تحتفظ GODO بالحق في إلغاء أو تعديل حالة الحساب الخالي من الفوائد في أي وقت دون إشعار مسبق.",
                        "swapPurpose": "حسابات خالية من الفوائد مخصصة فقط للعملاء الذين يتبعون مبادئ التمويل الإسلامي."
                    }
                }
            },
            ir: {
                "translation": {
                    "description": {
                        "Dashboard": "داشبورد",
                        "Accounts": "حساب‌ها",
                        "LiveAccounts": "حساب‌های واقعی",
                        "passwordType": "نوع کلمه عبور",
                        "DemoAccounts": "حساب‌های دمو",
                        "FPXPay": "FPX Pay",
                        "ChangePassword": "تغییر رمز عبور",
                        "Deposit": "واریز",
                        "Withdrawals": "برداشت‌ها",
                        "Withdrawal": "برداشت",
                        "InternalTransfer": "انتقال داخلی",
                        "PaymentHistory": "تاریخچه پرداخت",
                        "TradeHistory": "تاریخچه معاملات",
                        "Platforms": "پلتفرم‌ها",
                        // "Platform": "پلتفرم",
                        "Documents": "اسناد",
                        "LiveUpdates": "به‌روزرسانی‌های زنده",
                        "MarketUpdates": "به‌روزرسانی‌های بازار",
                        "MarketOverview": "نمای کلی بازار",
                        "EconomyCalander": "تقویم اقتصادی",
                        "Webinar": "وبینار",
                        "UpcomingWebinar": "وبینار آینده",
                        "Coaching": "آموزش",
                        "KYCStatus": "وضعیت KYC",
                        "Pending": "در انتظار",
                        "Approved": "تأیید شده",
                        "TradingStatus": "وضعیت معاملاتی",
                        "Disabled": "غیرفعال",
                        "Enabled": "فعال",
                        "Profile": "پروفایل",
                        "SignOut": "خروج",
                        "BALANCE": "موجودی",
                        "EQUITY": "حقوق صاحبان سهام",
                        "DEPOSITS": "واریزی‌ها",
                        "WITHDRAWAL": "برداشت",
                        "TradingAccounts": "حساب‌های معاملاتی",
                        "TradingPlatform": "پلتفرم معاملاتی",
                        "AccountNumber": "شماره حساب",
                        "Type": "نوع پلتفرم",
                        "Balance": "موجودی",
                        "Equity": "حقوق صاحبان سهام",
                        "Stopout": "استاپ‌اوت",
                        "Leverage": "اهرم",
                        "Action": "عملیات",
                        "Account": "حساب",
                        "GoDo-Live": "GoDo-Live",
                        "GoDo-Server": "GoDo-Server",
                        "GoDo-Demo": "GoDo-Demo",
                        "Currency": "ارز",
                        "FundNow": "اکنون شارژ کنید",
                        "CreateAccount": "ایجاد حساب",
                        "NewPassword": "رمز عبور جدید",
                        "ConfirmNewPassword": "تأیید رمز عبور جدید",
                        "Submit": "ارسال",
                        "CardPayment": "پرداخت با کارت",
                        "BankTransfer": "انتقال بانکی",
                        "CryptoDetails": "جزئیات کریپتو",
                        "PerfectMoney": "پرفکت مانی",
                        "SticPayment": "پرداخت Stic",
                        "Skrill": "اسکریل",
                        "Neteller": "نتلر",
                        "Africa": "آفریقا",
                        "WishMoney": "ویش مانی",
                        "LocalDeposit": "واریز محلی",
                        "Morocco": "مراکش",
                        "DepositCurrency": "ارز واریز",
                        "AmountInUSD": "مبلغ به دلار",
                        "AmountInMAD": "مبلغ به درهم مراکش",
                        "AmountInSYP": "مبلغ به لیر سوری",
                        "Note": "یادداشت",
                        "TradingAccount": "حساب معاملاتی",
                        "AfrAsiaBankUSD": "بانک آفرازیای دلار",
                        "AfrAsiaBankEUR": "بانک آفرازیای یورو",
                        "AfrAsiaBankAED": "بانک آفرازیای درهم",
                        "CBDBank": "بانک CBD",
                        "EqualsMoney": "ایکوآلز مانی",
                        "Currencies": "ارزها",
                        "BeneficiaryName": "نام ذینفع",
                        "BeneficiaryAccount": "حساب ذینفع",
                        "BeneficiaryAddress": "آدرس ذینفع",
                        "BankName": "نام بانک",
                        "ID": "شناسه",
                        "BankAddress": "آدرس بانک",
                        "IBANNumber": "شماره IBAN",
                        "SwiftCode": "کد سویفت",
                        "MinimumAmount": "حداقل مبلغ",
                        "AccountForClient": "حساب برای مشتری",
                        "AfrAsiaBankLtd": "بانک آفرازیای Ltd",
                        "GODOLTD-CLIENTACCOUNT": "حساب مشتری GODOLTD",
                        "3rdFloor,StandardCharteredTower,Cybercity,Ebene,72201,Mauritius": "طبقه سوم، برج استاندارد چارتر، سایبرسیتی، ابن، 72201، موریس",
                        "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius": "بوون اسکوئر 10، خیابان دکتر فریر، پورت لوئیس، موریس",
                        "OnlineFunding": "تأمین مالی آنلاین",
                        "Pleasenotecrypto": "لطفاً توجه داشته باشید واریزهای ارز دیجیتال فقط با ارزهای USDT و USDC پذیرفته می‌شود، با شرایط زیر برای حفظ صحت تراکنش‌ها",
                        "The customer is responsible for any gas fees applied by the exchange": "مشتری مسئولیت هزینه‌های گس اعمال شده توسط صرافی را بر عهده دارد",
                        "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department": "برداشت‌ها به مدت 15 روز مسدود می‌شود مگر اینکه حساب قبلاً توسط بخش تطابق ما پاک شده باشد",
                        "All funds to be returned to original funding source": "همه وجوه به منبع تأمین مالی اصلی بازگردانده می‌شود",
                        "TradingAccountID": "شناسه حساب معاملاتی",
                        "DepositAmountinUSD": "مبلغ واریز به دلار",
                        "WalletAddress": "آدرس کیف پول",
                        "Iacceptthe": "من قبول می‌کنم",
                        "TermsandConditionsforCreditCardDisclaimer": "شرایط و ضوابط برای بیانیه سلب مسئولیت کارت اعتباری",
                        "Next": "بعدی",
                        "PayeeAccount": "حساب گیرنده",
                        "SupportService": "خدمات پشتیبانی",
                        "Doyouhaveaquestion": "سؤالی در مورد واریز دارید؟ لطفاً با",
                        "ourFinancialSupportService": "خدمات پشتیبانی مالی ما تماس بگیرید.",
                        "Information": "اطلاعات",
                        "Exchangeratesandcommission": "نرخ‌های تبادل و کمیسیون",
                        "Paymentagentcontacts": "اطلاعات تماس با نماینده پرداخت",
                        "AgentName": "نام نماینده",
                        "MoroccoPaymentAgent": "نماینده پرداخت مراکش",
                        "Website": "وب‌سایت",
                        "WorkingHours": "ساعات کاری",
                        "WhishMoneyPaymentInstructions": "دستورالعمل‌های پرداخت ویش مانی",
                        "Step-by-Step Instructions1. Download and Install the Wish Money App": "دستورالعمل‌های گام به گام 1. دانلود و نصب اپلیکیشن ویش مانی",
                        "Visit the Wish Money App download page.": "از صفحه دانلود اپلیکیشن ویش مانی بازدید کنید.",
                        "Download and install the app on your mobile device.": "اپلیکیشن را بر روی دستگاه موبایل خود دانلود و نصب کنید.",
                        "Login to the Wish Money App": "ورود به اپلیکیشن ویش مانی",
                        "Open the app.": "اپلیکیشن را باز کنید.",
                        "Enter your login credentials to access your account.": "اطلاعات ورود خود را وارد کنید تا به حساب خود دسترسی پیدا کنید.",
                        "Navigate to the Finance Category": "به دسته مالی بروید",
                        "After logging in, choose the 'Finance' category from the menu options.": "پس از ورود، دسته 'مالی' را از منوی گزینه‌ها انتخاب کنید.",
                        "Enter the Receiver's Phone Number": "شماره تلفن گیرنده را وارد کنید",
                        "In the designated field, input the receiver's phone number: 71180175.": "در فیلد تعیین شده، شماره تلفن گیرنده را وارد کنید: 71180175.",
                        "Specify the Transfer Amount": "مبلغ انتقال را مشخص کنید",
                        "Enter the amount you wish to transfer in USD.": "مبلغی که می‌خواهید به دلار منتقل کنید را وارد کنید.",
                        "Add a Note with Your Trading Account Details": "یک یادداشت با جزئیات حساب معاملاتی خود اضافه کنید",
                        "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.": "در فیلد یادداشت، شماره حساب معاملاتی خود را وارد کنید و سپس - GoDoCM Dubai. مثال: 12345678 - GoDoCM Dubai.",
                        "Complete the Transaction": "تراکنش را تکمیل کنید",
                        "Review all the details to ensure accuracy.": "تمام جزئیات را برای اطمینان از صحت بررسی کنید.",
                        "Click the 'Send' button to complete the transaction.": "برای تکمیل تراکنش، دکمه 'ارسال' را کلیک کنید.",
                        "WithdrawalMethod": "روش برداشت",
                        "Amount": "مبلغ",
                        "ImportantInformation": "اطلاعات مهم",
                        "Allfunds": "همه وجوه به منبع تأمین مالی اصلی بازگردانده می‌شوند.",
                        "Youareentitled": "شما حق دارید یک برداشت رایگان در ماه انجام دهید؛ پس از آن، هزینه استاندارد برداشت 25 دلار اعمال می‌شود.",
                        "FromAccount": "از حساب",
                        "ToAccount": "به حساب",
                        "ReportType": "نوع گزارش",
                        "DateFrom": "تاریخ از",
                        "DateTo": "تاریخ تا",
                        "Search": "جستجو",
                        "Time": "زمان",
                        "Status": "وضعیت",
                        "PENDING": "در انتظار",
                        "REJECTED": "رد شده",
                        "APPROVED": "تأیید شده",
                        "AccountType": "نوع حساب",
                        "PROCEED": "ادامه",
                        "ViewTrades": "مشاهده معاملات",
                        "OpenPosition": "باز کردن موقعیت",
                        "ClosePosition": "بستن موقعیت",
                        "Symbol": "نماد",
                        "Ticket": "بلیط",
                        "DealType": "نوع معامله",
                        "Volume": "حجم",
                        "Price": "قیمت",
                        "PriceOpen": "قیمت باز",
                        "PriceSI": "قیمت SI",
                        "PriceTP": "قیمت TP",
                        "PriceCurrent": "قیمت جاری",
                        "Login": "ورود",
                        "NoData": "داده‌ای وجود ندارد",
                        "DownloadsForMT5": "دانلودها برای MT5",
                        "DownloadsForMT4": "دانلودها برای MT4",
                        "DownloadsForCTrader": "دانلودها برای CTrader",
                        "DownloadNow": "همین حالا دانلود کنید",
                        "forAndroid": "برای اندروید",
                        "forWindow": "برای ویندوز",
                        "forMAC": "برای مک",
                        "forPC": "برای رایانه",
                        "UploadDocuments": "بارگذاری اسناد",
                        "ProofofID": "مدرک شناسایی (صفحه اول گذرنامه یا جلو و پشت کارت شناسایی)",
                        "ProofofAddress": "مدرک نشانی",
                        "SourceofIncome": "منبع درآمد",
                        "AdditionalDocuments": "اسناد اضافی",
                        "ProofofIdentity": "مدرک هویت",
                        "CopyofPassport": "کپی گذرنامه",
                        "CopyofGovernmentIssuedID": "کپی کارت شناسایی صادر شده توسط دولت",
                        "ProofofResidentialAddress": "مدرک نشانی مسکونی",
                        "UtilityBill": "قبض خدماتی",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "اجاره نامه فعلی / قرارداد اجاره، منبع درآمد",
                        "Recentbankstatementshowingsalary": "صورت‌حساب بانکی اخیر که حقوق را نشان می‌دهد",
                        "Payslip": "فیش حقوقی",
                        "EmploymentContracttoshowyourincomefunds": "قرارداد کاری برای نشان دادن منابع درآمد شما",
                        "NoteDocuments": "توجه: اسناد باید در سه ماه اخیر صادر شده باشند",
                        "Title": "عنوان",
                        "UploadedAt": "بارگذاری شده در",
                        "KYCDocuments": "اسناد KYC",
                        "OPENANEWDEMOACCOUNT": "باز کردن یک حساب دمو جدید",
                        "OPENANEWLIVEACCOUNT": "باز کردن یک حساب واقعی جدید",
                        "File": "فایل",
                        "WhishMoneyInstructions": "برای انتقال وجوه با استفاده از اپلیکیشن ویش مانی، لطفاً مراحل زیر را دنبال کنید:",
                        "StepByStepInstructions": "دستورالعمل‌های گام به گام",
                        "Step1": "1. دانلود و نصب اپلیکیشن ویش مانی:",
                        "Step1Details": "بازدید از.",
                        "Step1Details1": "صفحه دانلود اپلیکیشن ویش مانی.",
                        "Step1Details2": "اپلیکیشن را بر روی دستگاه موبایل خود دانلود و نصب کنید.",
                        "Step2": "2. ورود به اپلیکیشن ویش مانی:",
                        "Step2Details": "اپلیکیشن را باز کنید.",
                        "Steps2Details1": "اطلاعات ورود خود را وارد کنید تا به حساب خود دسترسی پیدا کنید.",
                        "Step3": "3. به دسته مالی بروید:",
                        "Step3Details": "پس از ورود، دسته 'مالی' را از منوی گزینه‌ها انتخاب کنید.",
                        "Step4": "4. شماره تلفن گیرنده را وارد کنید:",
                        "Step4Details": "در فیلد تعیین شده، شماره تلفن گیرنده را وارد کنید: 71180175.",
                        "Step5": "5. مبلغ انتقال را مشخص کنید:",
                        "Step5Details": "مبلغی که می‌خواهید به دلار منتقل کنید را وارد کنید.",
                        "Step6": "6. یک یادداشت با جزئیات حساب معاملاتی خود اضافه کنید:",
                        "Step6Details": "در فیلد یادداشت، شماره حساب معاملاتی خود را وارد کنید و سپس - GoDoCM Dubai. مثال: 12345678 - GoDoCM Dubai.",
                        "Step6Details1": "اطلاعات ورود خود را وارد کنید تا به حساب خود دسترسی پیدا کنید",
                        "Step7": "7. تراکنش را تکمیل کنید:",
                        "Step7Details": "تمام جزئیات را برای اطمینان از صحت بررسی کنید.",
                        "Steps7Details1": "برای تکمیل تراکنش، دکمه 'ارسال' را کلیک کنید.",
                        "CryptoCurrency": "ارز دیجیتال",
                        "Network": "شبکه",
                        "Address": "آدرس",
                        "PleaseNoteMinimumWithdrawal": "لطفاً توجه داشته باشید حداقل مبلغ برداشت 10 دلار است",
                        "AddWallet": "افزودن کیف پول",
                        "Wallet": "کیف پول",
                        "AddNewWallet": "افزودن کیف پول جدید",
                        "Add": "افزودن",
                        "Profit": "سود",
                        "Platform": "پلتفرم",
                        "Iran": "ایران",
                        "DealId": "شناسه معامله",
                        "Entry": "ورود",
                        "PositionId": "شناسه موقعیت",
                        "OpenTimeStamp": "زمان باز شدن",
                        "EntryPrice": "قیمت ورود",
                        "Direction": "جهت",
                        "Commission": "کارمزد",
                        "Swap": "سواپ",
                        "usedMargin": "مارجین استفاده‌شده",
                        "CloseTimeStamp": "زمان بسته شدن",
                        "ClosePrice": "قیمت بسته شدن",
                        "forIso": "برای ISO",
                        "Iraq": "عراق",
                        "Turkey": "ترکیه",
                        "Jordan": "اردن",
                        "Pakistan": "پاکستان",
                        "India": "هند",
                        "PayPal": "پی پال",
                        "Russia": "روسیه",
                        "mexapay": "مکسا پی",
                        "InstructionsforTransferringFundsUsingWhishMoney": "دستورالعمل‌های انتقال وجه با استفاده از Whish Money",
                        "AccesstheWhishMoneyApp": "دسترسی به اپلیکیشن Whish Money:",
                        "AccessTheWhishMoneyApp": "اپلیکیشن Whish Money را در گوشی خود باز کنید.",
                        "CompleteTheTransfer": "اتمام انتقال",
                        "RecipientsPhoneNumber": "شماره تلفن گیرنده را وارد کنید: 70809031.",
                        "TransferAmount": "مبلغ انتقال را به دلار وارد کنید.",
                        "Fee": "نکته مهم: 1% هزینه به مبلغ انتقال اضافه کنید.",
                        "Example": "مثال: اگر می‌خواهید 100 دلار منتقل کنید، 101 دلار ارسال کنید.",
                        "SendAReceiptImage": "پس از تکمیل تراکنش، یک عکس واضح از رسید بگیرید و آن را از طریق WhatsApp به ارسال کنید.",
                        "SendaReceipt": "ارسال تصویر رسید:",
                        "ConfirmtheInfo": "4. تأیید اطلاعات:",
                        "ConfirmTheInformation": "اطمینان حاصل کنید که تمام جزئیات وارد شده صحیح است.",
                        "InstructionsforTransferringFundsUsingOMT": "دستورالعمل‌های انتقال وجه با استفاده از OMT",
                        "AccesstheOMT": "دسترسی به اپلیکیشن OMT:",
                        "AccessTheOMTApp": "اپلیکیشن OMT را در گوشی خود باز کنید.",
                        "CompleteTransfer": "اتمام انتقال",
                        "RecipientsPhoneNumberOMT": "شماره تلفن گیرنده را وارد کنید: 70809031.",
                        "TransferAmountOMT": "مبلغ انتقال را به دلار وارد کنید.",
                        "SendAReceiptImageOMT": "پس از تکمیل تراکنش، یک عکس واضح از رسید بگیرید و آن را از طریق WhatsApp به ارسال کنید.",
                        "ConfirmtheInfoOMT": "تأیید اطلاعات:",
                        "ProfitWithdrawalProcedures": "دستورالعمل‌های برداشت سود",
                        "RequestAWithdrawal": "درخواست برداشت:",
                        "ProfitWithdrawalRequest": "درخواست برداشت سود را از طریق واتساپ به ارسال کنید،",
                        "ProfitWithdrawalRequest2": "میزان مبلغی که قصد برداشت دارید را مشخص کنید.",
                        "CompleteTheProcess": "اتمام فرآیند:",
                        "WithdrawalProcess": "درخواست پس از بررسی جزئیات پردازش خواهد شد.",
                        "InstructionsforDepositingFundsviaInstaPay": "دستورالعمل‌های واریز وجه از طریق اینستاپی",
                        "OpenInstaPayApp": "برنامه اینستاپی را باز کنید",
                        "LaunchtheInstaPayapponyourphone": "برنامه اینستاپی را در گوشی خود باز کنید.",
                        "TransferDetails": "جزئیات انتقال",
                        "EnterRecipientAccountNumber": "شماره حساب گیرنده را وارد کنید: mglamie@instapay",
                        "Thetransferrate": "نرخ انتقال: ",
                        "TransferRate": "1 دلار = 49 پوند مصری",
                        "ExampleDeposit": "مثال: برای واریز 100 دلار، 4900 پوند مصری ارسال کنید",
                        "CompleteTransaction": "تکمیل تراکنش",
                        "Confirmthedetailsandfinalizethetransfer": "جزئیات را تأیید کرده و انتقال را نهایی کنید.",
                        "SaveTransactionReceipt": "رسید تراکنش را ذخیره کنید",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "از صفحه نمایش عکس بگیرید یا شناسه تراکنش را برای ارجاع در آینده یادداشت کنید.",
                        "InstaPay": "اینستا پی",
                        "JordanPay": "الأردن",
                        "RusiaPay": "روسيا",
                        "TurkeyPay": "تركيا",
                        "DuitPay": "Duit Now",
                        "IraqPay": "العراق",
                        "UploadReceipt": "بارگذاری رسید",
                        "UploadPaymentReceipt": "بارگذاری رسید پرداخت",
                        "OrderId": "شناسه سفارش",
                        "NetSettle": "تسویه خالص",
                        "Expiry Time": "زمان انقضاء",
                        "GTNType": "Type",
                        "Exchange": "Éxhange",
                        "ISINCode": "Code ISIN",
                        "Channel": "Canal",
                        "DownloadsForGTN": "دانلودها برای GTN",
                        "ImportantNote": "نکته مهم",
                        "ToChangePassword": "برای تغییر رمز عبور GTN، به این لینک مراجعه کنید",
                        "GTNLogin": "ورود به GTN",
                        "LoginToGTN": "	و وارد حساب GTN خود شوید تا رمز عبور را تغییر دهید",
                        "ChangingPassword": "تغییر رمز عبور در اینجا فقط رمز عبور پورتال مشتری را تغییر می‌دهد، نه رمز عبور پلتفرم معاملاتی GTN",
                        "BankAccount": "حساب بانکی",
                        "ReceiverName": "نام گیرنده",
                        "SelectCreditBonus": "پاداش اعتباری را انتخاب کنید",
                        "ReviewConditions": ":لطفاً پیش از انتخاب پاداش اعتباری خود، شرایط و ضوابط مربوط به پاداش را از طریق لینک زیر مرور کنید.",
                        "BonusTermsConditions": "شرایط و ضوابط پاداش",
                        "bonus": "پاداش",
                        "ClaimBonus": "🎁 دریافت پاداش",
                        "PreferredBonus": "درصد پاداش مورد نظر خود را از منوی کشویی همراه با شماره حساب انتخاب کنید.",
                        "Acknowledgment": "✅ تأیید",
                        "SubmitBonusRequest": "با کلیک بر روی ارسال درخواست پاداش، شما تأیید می‌کنید که:",
                        "AcceptedTerms": "شما شرایط و ضوابط پاداش را خوانده و پذیرفته‌اید.",
                        "AcceptedTerms1": "شما درک می‌کنید که اعتبارات پاداش تبلیغاتی هستند و تابع سیاست‌های داخلی GODO می‌باشند.",
                        "AcceptedTerms2": "GODO حق تغییر یا لغو پاداش را در هر زمان، بدون اطلاع قبلی یا توضیح محفوظ می‌دارد",
                        "request": "درخواست حساب بدون سوآپ",
                        "ImpNote": "نکات مهم",
                        "description": "اگر مایل به درخواست یک حساب معاملاتی بدون سوآپ (اسلامی) هستید، لطفاً",
                        "terms": "شرایط",
                        "carefully": "را با دقت قبل از ارسال درخواست خود مطالعه کنید.",
                        "swapApproval": "وضعیت بدون سوآپ منوط به تأیید تیم ریسک GODO است.",
                        "swapRights": "GODO این حق را دارد که وضعیت بدون سوآپ را در هر زمانی بدون اطلاع قبلی لغو یا اصلاح کند.",
                        "swapPurpose": "حساب‌های بدون سوآپ منحصراً برای مشتریانی در نظر گرفته شده‌اند که از اصول مالی اسلامی پیروی می‌کنند."
                    }
                }
            },
            es: {
                translation: {
                    description: {
                        "Dashboard": "Panel",
                        "Accounts": "Cuentas",
                        "LiveAccounts": "Cuentas Reales",
                        "DemoAccounts": "Cuentas Demo",
                        "ChangePassword": "Cambiar Contraseña",
                        "SwapFree": "Sin Swap",
                        "FPXPay": "FPX Pay",
                        "passwordType": "Tipo de Contraseña",
                        "Deposit": "Depósito",
                        "Withdrawals": "Retiros",
                        "Withdrawal": "Retiro",
                        "InternalTransfer": "Transferencia Interna",
                        "PaymentHistory": "Historial de Pagos",
                        "TradeHistory": "Historial de Operaciones",
                        "Platforms": "Plataformas",
                        "Documents": "Documentos",
                        "LiveUpdates": "Actualizaciones en Vivo",
                        "MarketUpdates": "Actualizaciones del Mercado",
                        "MarketOverview": "Resumen del Mercado",
                        "EconomyCalander": "Calendario Económico",
                        "Webinar": "Seminario Web",
                        "UpcomingWebinar": "Próximo Seminario Web",
                        "Coaching": "Entrenamiento",
                        "KYCStatus": "Estado KYC",
                        "Pending": "Pendiente",
                        "Approved": "Aprobado",
                        "TradingStatus": "Estado de Trading",
                        "Disabled": "Deshabilitado",
                        "Enabled": "Habilitado",
                        "Profile": "Perfil",
                        "SignOut": "Cerrar Sesión",
                        "BALANCE": "SALDO",
                        "EQUITY": "PATRIMONIO",
                        "DEPOSITS": "DEPÓSITOS",
                        "WITHDRAWAL": "RETIRO",
                        "TradingAccounts": "Cuentas de Trading",
                        "TradingPlatform": "Plataforma de Trading",
                        "AccountNumber": "Número de Cuenta",
                        "Type": "Tipo de Plataforma",
                        "Balance": "Saldo",
                        "Equity": "Patrimonio",
                        "Stopout": "Stopout",
                        "Leverage": "Apalancamiento",
                        "Action": "Acción",
                        "Account": "Cuenta",
                        "GoDo-Live": "GoDo-Live",
                        "GoDo-Server": "GoDo-Servidor",
                        "GoDo-Demo": "GoDo-Demo",
                        "Currency": "Moneda",
                        "FundNow": "Depositar Ahora",
                        "CreateAccount": "Crear Cuenta",
                        "NewPassword": "Nueva Contraseña",
                        "ConfirmNewPassword": "Confirmar Nueva Contraseña",
                        "Submit": "Enviar",
                        "CardPayment": "Pago con Tarjeta",
                        "BankTransfer": "Transferencia Bancaria",
                        "CryptoDetails": "Detalles de Cripto",
                        "PerfectMoney": "Perfect Money",
                        "SticPayment": "Stic Payment",
                        "Skrill": "Skrill",
                        "Neteller": "Neteller",
                        "Africa": "África",
                        "WishMoney": "Wish Money",
                        "LocalDeposit": "Depósito Local",
                        "Morocco": "Marruecos",
                        "DepositCurrency": "Moneda de Depósito",
                        "AmountInUSD": "Cantidad en USD",
                        "AmountInMAD": "Cantidad en MAD",
                        "AmountInSYP": "Cantidad en SYP",
                        "Note": "Nota",
                        "TradingAccount": "Cuenta de Trading",
                        "AfrAsiaBankUSD": "AfrAsia Bank USD",
                        "AfrAsiaBankEUR": "AfrAsia Bank EUR",
                        "AfrAsiaBankAED": "AfrAsia Bank AED",
                        "CBDBank": "Banco CBD",
                        "EqualsMoney": "Equals Money",
                        "Currencies": "Monedas",
                        "BeneficiaryName": "Nombre del Beneficiario",
                        "BeneficiaryAccount": "Cuenta del Beneficiario",
                        "BeneficiaryAddress": "Dirección del Beneficiario",
                        "BankName": "Nombre del Banco",
                        "ID": "ID",
                        "BankAddress": "Dirección del Banco",
                        "IBANNumber": "Número IBAN",
                        "SwiftCode": "Código SWIFT",
                        "MinimumAmount": "Cantidad Mínima",
                        "AccountForClient": "Cuenta para el Cliente",
                        "AfrAsiaBankLtd": "AfrAsia Bank Ltd",
                        "GODOLTD-CLIENTACCOUNT": "GODO LTD - CUENTA DEL CLIENTE",
                        "3rdFloor,StandardCharteredTower,Cybercity,Ebene,72201,Mauritius": "3er Piso, Torre Standard Chartered, Cybercity, Ebene, 72201, Mauricio",
                        "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius": "Bowen Square 10, Calle Dr Ferriere, Port Louis, Mauricio",
                        "OnlineFunding": "Financiamiento en Línea",
                        "Pleasenotecrypto": "Tenga en cuenta que los depósitos en cripto solo se aceptan en monedas USDT y USDC bajo las siguientes condiciones para proteger la integridad de las transacciones",
                        "The customer is responsible for any gas fees applied by the exchange": "El cliente es responsable de cualquier tarifa de gas aplicada por el intercambio",
                        "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department": "Los retiros se bloquearán durante un período de 15 días, a menos que el departamento de Cumplimiento haya aprobado la cuenta antes",
                        "All funds to be returned to original funding source": "Todos los fondos deben devolverse a la fuente de financiamiento original",
                        "TradingAccountID": "ID de Cuenta de Trading",
                        "DepositAmountinUSD": "Monto del Depósito en USD",
                        "WalletAddress": "Dirección de la Billetera",
                        "Iacceptthe": "Acepto los",
                        "TermsandConditionsforCreditCardDisclaimer": "Términos y Condiciones del Aviso Legal para Tarjetas de Crédito",
                        "Next": "Siguiente",
                        "PayeeAccount": "Cuenta del Beneficiario",
                        "SupportService": "Servicio de Soporte",
                        "Doyouhaveaquestion": "¿Tiene una pregunta sobre el depósito? Por favor, contacte a",
                        "ourFinancialSupportService": "nuestro Servicio de Soporte Financiero.",
                        "Information": "Información",
                        "Exchangeratesandcommission": "Tasas de cambio y comisión",
                        "Paymentagentcontacts": "Contactos del agente de pagos",
                        "AgentName": "Nombre del Agente",
                        "MoroccoPaymentAgent": "Agente de Pagos Marruecos",
                        "Website": "Sitio Web",
                        "WorkingHours": "Horario de Atención",
                        "WhishMoneyPaymentInstructions": "Instrucciones de Pago con Wish Money",
                        "Step-by-Step Instructions1. Download and Install the Wish Money App": "Instrucciones Paso a Paso 1. Descargue e Instale la App Wish Money",
                        "Visit the Wish Money App download page.": "Visite la página de descarga de la App Wish Money.",
                        "Download and install the app on your mobile device.": "Descargue e instale la aplicación en su dispositivo móvil.",
                        "Login to the Wish Money App": "Inicie sesión en la App Wish Money",
                        "Open the app.": "Abra la aplicación.",
                        "Enter your login credentials to access your account.": "Ingrese sus credenciales para acceder a su cuenta.",
                        "Navigate to the Finance Category": "Navegue a la Categoría de Finanzas",
                        "After logging in, choose the 'Finance' category from the menu options.": "Después de iniciar sesión, seleccione la categoría 'Finanzas' en el menú.",
                        "Enter the Receiver's Phone Number": "Ingrese el Número de Teléfono del Receptor",
                        "In the designated field, input the receiver's phone number: 71180175.": "En el campo designado, introduzca el número de teléfono del receptor: 71180175.",
                        "Specify the Transfer Amount": "Especifique el Monto de la Transferencia",
                        "Enter the amount you wish to transfer in USD.": "Ingrese la cantidad que desea transferir en USD.",
                        "Add a Note with Your Trading Account Details": "Agregue una Nota con los Detalles de su Cuenta de Trading",
                        "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.": "En el campo de nota, ingrese su número de cuenta de trading seguido de - GoDoCM Dubai. Ejemplo: 12345678 - GoDoCM Dubai.",
                        "Complete the Transaction": "Completar la Transacción",
                        "Review all the details to ensure accuracy.": "Revise todos los detalles para asegurar la precisión.",
                        "Click the 'Send' button to complete the transaction.": "Haga clic en el botón 'Enviar' para completar la transacción.",
                        "WithdrawalMethod": "Método de Retiro",
                        "Amount": "Monto",
                        "ImportantInformation": "Información Importante",
                        "Allfunds": "Todos los fondos serán devueltos a la fuente de financiamiento original.",
                        "Youareentitled": "Tiene derecho a un retiro gratuito por mes; después de eso, se aplica una tarifa estándar de retiro de $25.",
                        "FromAccount": "Desde la Cuenta",
                        "ToAccount": "Hacia la Cuenta",
                        "ReportType": "Tipo de Informe",
                        "DateFrom": "Fecha Desde",
                        "DateTo": "Fecha Hasta",
                        "Search": "Buscar",
                        "Time": "Hora",
                        "Status": "Estado",
                        "PENDING": "PENDIENTE",
                        "REJECTED": "RECHAZADO",
                        "APPROVED": "APROBADO",
                        "AccountType": "Tipo de Cuenta",
                        "PROCEED": "CONTINUAR",
                        "ViewTrades": "Ver Operaciones",
                        "Open Position": "Posición Abierta",
                        "Close Position": "Cerrar Posición",
                        "Symbol": "Símbolo",
                        "Ticket": "Ticket",
                        "DealType": "Tipo de Operación",
                        "Volume": "Volumen",
                        "Price": "Precio",
                        "PriceOpen": "Precio de Apertura",
                        "PriceSI": "Precio SI",
                        "PriceTP": "Precio TP",
                        "PriceCurrent": "Precio Actual",
                        "Login": "Iniciar Sesión",
                        "NoData": "Sin Datos",
                        "DownloadsForMT5": "Descargas para MT5",
                        "DownloadsForMT4": "Descargas para MT4",
                        "DownloadsForCTrader": "Descargas para CTrader",
                        "DownloadNow": "Descargar Ahora",
                        "forAndroid": "para Android",
                        "forWindow": "para Windows",
                        "forMAC": "para MAC",
                        "forPC": "para PC",
                        "UploadDocuments": "Subir Documentos",
                        "ProofofID": "Prueba de Identidad (Página frontal del pasaporte O ambos lados del documento de identidad)",
                        "ProofofAddress": "Prueba de Dirección",
                        "SourceofIncome": "Fuente de Ingresos",
                        "AdditionalDocuments": "Documentos Adicionales",
                        "ProofofIdentity": "Prueba de Identidad",
                        "CopyofPassport": "Copia del Pasaporte",
                        "CopyofGovernmentIssuedID": "Copia del Documento de Identidad emitido por el Gobierno",
                        "ProofofResidentialAddress": "Prueba de Dirección Residencial",
                        "UtilityBill": "Factura de Servicio Público",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "Contrato de Arrendamiento/Vivienda Actual como Fuente de Ingresos",
                        "Recentbankstatementshowingsalary": "Estado de cuenta bancario reciente mostrando salario",
                        "Payslip": "Recibo de Salario",
                        "EmploymentContracttoshowyourincomefunds": "Contrato de Trabajo para mostrar sus ingresos",
                        "NoteDocuments": "Nota: Los documentos deben haber sido emitidos en los últimos 3 meses calendario",
                        "Title": "Título",
                        "UploadedAt": "Subido El",
                        "KYCDocuments": "Documentos KYC",
                        "OPENANEWDEMOACCOUNT": "ABRIR UNA NUEVA CUENTA DEMO",
                        "OPENANEWLIVEACCOUNT": "ABRIR UNA NUEVA CUENTA REAL",
                        "File": "Archivo",
                        "WhishMoneyInstructions": "Para transferir fondos usando la App Wish Money, siga los siguientes pasos:",
                        "StepByStepInstructions": "Instrucciones Paso a Paso",
                        "Step1": "1. Descargue e Instale la App Wish Money:",
                        "Step1Details": "Visite la.",
                        "Step1Details1": "Página de descarga de la App Wish Money.",
                        "Step1Details2": "Descargue e instale la app en su dispositivo móvil.",
                        "Step2": "2. Inicie sesión en la App Wish Money:",
                        "Step2Details": "Abra la app.",
                        "Step2Details1": "Ingrese sus credenciales para acceder a su cuenta.",
                        "Step3": "3. Navegue a la Categoría de Finanzas:",
                        "Step3Details": "Después de iniciar sesión, seleccione la categoría 'Finanzas' en el menú.",
                        "Step4": "4. Ingrese el Número de Teléfono del Receptor:",
                        "Step4Details": "En el campo designado, introduzca el número de teléfono del receptor: 71180175.",
                        "Step5": "5. Especifique el Monto de la Transferencia:",
                        "Step5Details": "Ingrese la cantidad que desea transferir en USD.",
                        "Step6": "6. Agregue una Nota con los Detalles de su Cuenta de Trading:",
                        "Step6Details": "En el campo de nota, ingrese su número de cuenta de trading seguido de - GoDoCM Dubai.",
                        "Step6Details1": "Ejemplo: 12345678 - GoDoCM Dubai.",
                        "Step7": "7. Complete la Transacción:",
                        "Step7Details": "Revise todos los detalles para asegurar la precisión.",
                        "Steps7Details1": "Haga clic en el botón 'Enviar' para completar la transacción.",
                        "CryptoCurrency": "Criptomoneda",
                        "Network": "Red",
                        "Address": "Dirección",
                        "PleaseNoteMinimumWithdrawal": "Tenga en cuenta que el retiro mínimo es de 10$",
                        "AddWallet": "Agregar Billetera",
                        "Wallet": "Billetera",
                        "AddNewWallet": "Agregar Nueva Billetera",
                        "Add": "Agregar",
                        "OpenPosition": "Posición Abierta",
                        "ClosePosition": "Cerrar Posición",
                        "Profit": "Ganancia",
                        "Platform": "Plataforma",
                        "Iran": "Irán",
                        "DealId": "ID de Operación",
                        "Entry": "Entrada",
                        "PositionId": "ID de Posición",
                        "OpenTimeStamp": "Marca de Tiempo de Apertura",
                        "CloseTimeStamp": "Marca de Tiempo de Cierre",
                        "EntryPrice": "Precio de Entrada",
                        "ClosePrice": "Precio de Cierre",
                        "Direction": "Dirección",
                        "Commission": "Comisión",
                        "Swap": "Swap",
                        "usedMargin": "Margen Usado",
                        "forIso": "para iOS",
                        "Iraq": "Irak",
                        "Turkey": "Turquía",
                        "Jordan": "Jordania",
                        "Pakistan": "Pakistán",
                        "India": "India",
                        "PayPal": "PayPal",
                        "Russia": "Rusia",
                        "mexapay": "MexaPay",
                        "InstructionsforTransferringFundsUsingWhishMoney": "Instrucciones para Transferir Fondos Usando Whish Money",
                        "AccesstheWhishMoneyApp": "Acceder a la App Whish Money:",
                        "AccessTheWhishMoneyApp": "Abra la aplicación Whish Money en su teléfono.",
                        "CompleteTheTransfer": "Completar la Transferencia",
                        "RecipientsPhoneNumber": "Ingrese el número de teléfono del destinatario: 70809031.",
                        "TransferAmount": "Ingrese el monto a transferir en USD.",
                        "Fee": "Nota Importante: Agregue un 1% de comisión al monto de la transferencia.",
                        "Example": "Ejemplo: Si desea transferir $100, envíe $101.",
                        "SendAReceiptImage": "Después de completar la transacción, tome una foto clara del recibo y envíela por WhatsApp a",
                        "SendaReceipt": "Enviar Imagen del Recibo:",
                        "ConfirmtheInfo": "4. Confirmar la Información:",
                        "ConfirmTheInformation": "Asegúrese de que todos los datos ingresados sean correctos.",
                        "InstructionsforTransferringFundsUsingOMT": "Instrucciones para Transferir Fondos Usando OMT",
                        "AccesstheOMT": "Acceder a la App OMT:",
                        "AccessTheOMTApp": "Abra la aplicación OMT en su teléfono.",
                        "CompleteTransfer": "Completar la Transferencia",
                        "RecipientsPhoneNumberOMT": "Ingrese el número de teléfono del destinatario: 70809031.",
                        "TransferAmountOMT": "Ingrese el monto a transferir en USD.",
                        "SendAReceiptImageOMT": "Después de completar la transacción, tome una foto clara del recibo y envíela por WhatsApp a",
                        "ConfirmtheInfoOMT": "Confirmar la Información:",
                        "ProfitWithdrawalProcedures": "Procedimientos para Retiros de Ganancias",
                        "RequestAWithdrawal": "Solicitar un Retiro:",
                        "ProfitWithdrawalRequest": "Envíe una solicitud de retiro de ganancias por WhatsApp a,",
                        "ProfitWithdrawalRequest2": "especificando el monto a retirar.",
                        "CompleteTheProcess": "Completar el Proceso:",
                        "WithdrawalProcess": "La solicitud será procesada después de revisar los detalles.",
                        "InstructionsforDepositingFundsviaInstaPay": "Instrucciones para Depositar Fondos vía InstaPay",
                        "OpenInstaPayApp": "Abra la App InstaPay",
                        "LaunchtheInstaPayapponyourphone": "Inicie la aplicación InstaPay en su teléfono.",
                        "TransferDetails": "Detalles de la Transferencia",
                        "EnterRecipientAccountNumber": "Ingrese el correo de la cuenta del destinatario: mglamie@instapay",
                        "Thetransferrate": "La tasa de cambio:",
                        "TransferRate": "1 USD = 49 EGP",
                        "ExampleDeposit": "Ejemplo: Para depositar $100, envíe 4900 EGP",
                        "CompleteTransaction": "Completar la Transacción",
                        "Confirmthedetailsandfinalizethetransfer": "Confirme los detalles y finalice la transferencia.",
                        "SaveTransactionReceipt": "Guardar el Recibo de la Transacción",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "Tome una captura de pantalla o anote el ID de la transacción para referencia futura.",
                        "InstaPay": "InstaPay",
                        "JordanPay": "Jordania",
                        "RusiaPay": "Rusia",
                        "MobiPay": "MobiPay",
                        "TurkeyPay": "Turquía",
                        "IraqPay": "Irak",
                        "UploadReceipt": "Subir Recibo",
                        "UploadPaymentReceipt": "Subir Comprobante de Pago",
                        "OrderId": "ID de Pedido",
                        "NetSettle": "Liquidación Neta",
                        "EndTime": "Hora de Expiración",
                        "GTNType": "Tipo",
                        "Exchange": "Intercambio",
                        "ISINCode": "Código ISIN",
                        "Channel": "Canal",
                        "DownloadsForGTN": "Descargas para GTN",
                        "ImportantNote": "Nota Importante",
                        "ToChangePassword": "Para cambiar la contraseña de GTN, visite este enlace",
                        "GTNLogin": "Inicio de sesión de GTN",
                        "LoginToGTN": "e inicia sesión en tu cuenta de GTN para cambiar la contraseña",
                        "ChangingPassword": "Cambiar la contraseña aquí solo cambiará la del portal del cliente, no la de la plataforma de trading de GTN",
                        "BankAccount": "Cuenta bancaria",
                        "ReceiverName": "Nombre del receptor",
                        "SelectCreditBonus": "Seleccione el bono de crédito",
                        "ReviewConditions": "Por favor, revise los Términos y Condiciones del bono antes de seleccionar su bono de crédito haciendo clic en el enlace a continuación:",
                        "BonusTermsConditions": "Términos y condiciones del bono",
                        "bonus": "Bono",
                        "ClaimBonus": "🎁 Reclamar Bono",
                        "PreferredBonus": "Elija su porcentaje de bono preferido del menú desplegable con el número de cuenta.",
                        "Acknowledgment": "✅ Reconocimiento",
                        "SubmitBonusRequest": "Al hacer clic en Enviar Solicitud de Bono, usted reconoce que:",
                        "AcceptedTerms": "Ha leído y aceptado los Términos y Condiciones del Bono.",
                        "AcceptedTerms1": "Usted entiende que los créditos de bono son promocionales y están sujetos a las políticas internas de GODO.",
                        "AcceptedTerms2": "GODO se reserva el derecho de modificar o terminar el bono en cualquier momento, sin previo aviso o explicación",
                        "request": "Solicitud de cuenta sin swap",
                        "ImpNote": "Notas importantes",
                        "description": "Si desea solicitar una cuenta de trading sin swap (islámica), por favor lea los",
                        "terms": "términos",
                        "carefully": "cuidadosamente antes de enviar su solicitud.",
                        "swapApproval": "El estado sin swap está sujeto a la aprobación del equipo de riesgos de GODO.",
                        "swapRights": "GODO se reserva el derecho de revocar o modificar el estado sin swap en cualquier momento sin previo aviso.",
                        "swapPurpose": "Las cuentas sin swap están destinadas estrictamente a clientes que siguen los principios de las finanzas islámicas."
                    }
                }
            },
            ru: {
                translation: {
                    description: {
                        "FPXPay": "FPX Pay",
                        "Dashboard": "Панель управления",
                        "Accounts": "Счета",
                        "LiveAccounts": "Реальные счета",
                        "DemoAccounts": "Демо-счета",
                        "ChangePassword": "Сменить пароль",
                        "SwapFree": "Без свопов",
                        "passwordType": "Тип пароля",
                        "Deposit": "Пополнение",
                        "Withdrawals": "Вывод средств",
                        "Withdrawal": "Вывод",
                        "InternalTransfer": "Внутренний перевод",
                        "PaymentHistory": "История платежей",
                        "TradeHistory": "История сделок",
                        "Platforms": "Платформы",
                        "Documents": "Документы",
                        "LiveUpdates": "Обновления в реальном времени",
                        "MarketUpdates": "Обновления рынка",
                        "MarketOverview": "Обзор рынка",
                        "EconomyCalander": "Экономический календарь",
                        "Webinar": "Вебинар",
                        "UpcomingWebinar": "Предстоящий вебинар",
                        "Coaching": "Обучение",
                        "KYCStatus": "Статус KYC",
                        "Pending": "В ожидании",
                        "Approved": "Одобрено",
                        "TradingStatus": "Статус торговли",
                        "Disabled": "Отключено",
                        "Enabled": "Включено",
                        "Profile": "Профиль",
                        "SignOut": "Выход",
                        "BALANCE": "БАЛАНС",
                        "EQUITY": "КАПИТАЛ",
                        "DEPOSITS": "ДЕПОЗИТЫ",
                        "WITHDRAWAL": "ВЫВОД",
                        "TradingAccounts": "Торговые счета",
                        "TradingPlatform": "Торговая платформа",
                        "AccountNumber": "Номер счета",
                        "Type": "Тип платформы",
                        "Balance": "Баланс",
                        "Equity": "Капитал",
                        "Stopout": "Стоп-аут",
                        "Leverage": "Кредитное плечо",
                        "Action": "Действие",
                        "Account": "Счет",
                        "GoDo-Live": "GoDo-Live",
                        "GoDo-Server": "GoDo-Сервер",
                        "GoDo-Demo": "GoDo-Демо",
                        "Currency": "Валюта",
                        "FundNow": "Пополнить сейчас",
                        "CreateAccount": "Создать счет",
                        "NewPassword": "Новый пароль",
                        "ConfirmNewPassword": "Подтвердите новый пароль",
                        "Submit": "Отправить",
                        "CardPayment": "Оплата картой",
                        "BankTransfer": "Банковский перевод",
                        "CryptoDetails": "Детали криптовалюты",
                        "PerfectMoney": "Perfect Money",
                        "SticPayment": "Stic Payment",
                        "Skrill": "Skrill",
                        "Neteller": "Neteller",
                        "Africa": "Африка",
                        "WishMoney": "Wish Money",
                        "LocalDeposit": "Локальный депозит",
                        "Morocco": "Марокко",
                        "DepositCurrency": "Валюта депозита",
                        "AmountInUSD": "Сумма в USD",
                        "AmountInMAD": "Сумма в MAD",
                        "AmountInSYP": "Сумма в SYP",
                        "Note": "Примечание",
                        "TradingAccount": "Торговый счет",
                        "AfrAsiaBankUSD": "AfrAsia Банк USD",
                        "AfrAsiaBankEUR": "AfrAsia Банк EUR",
                        "AfrAsiaBankAED": "AfrAsia Банк AED",
                        "CBDBank": "CBD Банк",
                        "EqualsMoney": "Equals Money",
                        "Currencies": "Валюты",
                        "BeneficiaryName": "Имя получателя",
                        "BeneficiaryAccount": "Счет получателя",
                        "BeneficiaryAddress": "Адрес получателя",
                        "BankName": "Название банка",
                        "ID": "Идентификатор",
                        "BankAddress": "Адрес банка",
                        "IBANNumber": "Номер IBAN",
                        "SwiftCode": "Код SWIFT",
                        "MinimumAmount": "Минимальная сумма",
                        "AccountForClient": "Счет для клиента",
                        "AfrAsiaBankLtd": "AfrAsia Bank Ltd",
                        "GODOLTD-CLIENTACCOUNT": "GODO LTD - СЧЕТ КЛИЕНТА",
                        "3rdFloor,StandardCharteredTower,Cybercity,Ebene,72201,Mauritius": "3 этаж, башня Standard Chartered, Cybercity, Ebene, 72201, Маврикий",
                        "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius": "Bowen Square 10, ул. Доктора Ферьера, Порт-Луи, Маврикий",
                        "OnlineFunding": "Онлайн финансирование",
                        "Pleasenotecrypto": "Обратите внимание: криптовалютные депозиты принимаются только в USDT и USDC при соблюдении следующих условий для защиты целостности транзакций",
                        "The customer is responsible for any gas fees applied by the exchange": "Клиент несет ответственность за все комиссии сети, применяемые биржей",
                        "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department": "Вывод средств будет заблокирован на 15 дней, если только счет не будет одобрен раньше нашим отделом комплаенса",
                        "All funds to be returned to original funding source": "Все средства будут возвращены на исходный источник",
                        "TradingAccountID": "ID торгового счета",
                        "DepositAmountinUSD": "Сумма депозита в USD",
                        "WalletAddress": "Адрес кошелька",
                        "Iacceptthe": "Я принимаю",
                        "TermsandConditionsforCreditCardDisclaimer": "Условия и положения отказа от ответственности по кредитной карте",
                        "Next": "Далее",
                        "PayeeAccount": "Счет получателя",
                        "SupportService": "Служба поддержки",
                        "Doyouhaveaquestion": "У вас есть вопрос о депозите? Пожалуйста, свяжитесь с",
                        "ourFinancialSupportService": "нашей финансовой службой поддержки.",
                        "Information": "Информация",
                        "Exchangeratesandcommission": "Курсы обмена и комиссия",
                        "Paymentagentcontacts": "Контакты платежных агентов",
                        "AgentName": "Имя агента",
                        "MoroccoPaymentAgent": "Платежный агент в Марокко",
                        "Website": "Веб-сайт",
                        "WorkingHours": "Часы работы",
                        "WhishMoneyPaymentInstructions": "Инструкции по оплате через Wish Money",
                        "Step-by-Step Instructions1. Download and Install the Wish Money App": "Пошаговая инструкция 1. Скачайте и установите приложение Wish Money",
                        "Visit the Wish Money App download page.": "Перейдите на страницу загрузки приложения Wish Money.",
                        "Download and install the app on your mobile device.": "Скачайте и установите приложение на свое мобильное устройство.",
                        "Login to the Wish Money App": "Войдите в приложение Wish Money",
                        "Open the app.": "Откройте приложение.",
                        "Enter your login credentials to access your account.": "Введите свои учетные данные для входа в аккаунт.",
                        "Navigate to the Finance Category": "Перейдите в категорию Финансы",
                        "After logging in, choose the 'Finance' category from the menu options.": "После входа выберите категорию 'Финансы' в меню.",
                        "Enter the Receiver's Phone Number": "Введите номер телефона получателя",
                        "In the designated field, input the receiver's phone number: 71180175.": "В указанное поле введите номер телефона получателя: 71180175.",
                        "Specify the Transfer Amount": "Укажите сумму перевода",
                        "Enter the amount you wish to transfer in USD.": "Введите сумму, которую вы хотите перевести, в долларах США.",
                        "Add a Note with Your Trading Account Details": "Добавьте примечание с данными вашего торгового счета",
                        "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.": "В поле примечания введите номер вашего торгового счета, а затем - GoDoCM Dubai. Пример: 12345678 - GoDoCM Dubai.",
                        "Complete the Transaction": "Завершите транзакцию",
                        "Review all the details to ensure accuracy.": "Проверьте все данные для точности.",
                        "Click the 'Send' button to complete the transaction.": "Нажмите кнопку 'Отправить' для завершения транзакции.",
                        "WithdrawalMethod": "Метод вывода",
                        "Amount": "Сумма",
                        "ImportantInformation": "Важная информация",
                        "Allfunds": "Все средства будут возвращены на исходный источник.",
                        "Youareentitled": "Вы имеете право на один бесплатный вывод в месяц; затем применяется стандартная комиссия в размере 25 долларов США.",
                        "FromAccount": "Счет отправителя",
                        "ToAccount": "Счет получателя",
                        "ReportType": "Тип отчета",
                        "DateFrom": "Дата начала",
                        "DateTo": "Дата окончания",
                        "Search": "Поиск",
                        "Time": "Время",
                        "Status": "Статус",
                        "PENDING": "В ОЖИДАНИИ",
                        "REJECTED": "ОТКЛОНЕНО",
                        "APPROVED": "ОДОБРЕНО",
                        "AccountType": "Тип счета",
                        "PROCEED": "ПРОДОЛЖИТЬ",
                        "ViewTrades": "Просмотреть сделки",
                        "Open Position": "Открытая позиция",
                        "Close Position": "Закрытая позиция",
                        "Symbol": "Символ",
                        "Ticket": "Тикет",
                        "DealType": "Тип сделки",
                        "Volume": "Объем",
                        "Price": "Цена",
                        "PriceOpen": "Цена открытия",
                        "PriceSI": "Цена SL",
                        "PriceTP": "Цена TP",
                        "PriceCurrent": "Текущая цена",
                        "Login": "Вход",
                        "NoData": "Нет данных",
                        "DownloadsForMT5": "Загрузки для MT5",
                        "DownloadsForMT4": "Загрузки для MT4",
                        "DownloadsForCTrader": "Загрузки для cTrader",
                        "DownloadNow": "Скачать сейчас",
                        "forAndroid": "для Android",
                        "forWindow": "для Windows",
                        "forMAC": "для MAC",
                        "forPC": "для ПК",
                        "UploadDocuments": "Загрузить документы",
                        "ProofofID": "Удостоверение личности (первый разворот паспорта ИЛИ обе стороны удостоверения)",
                        "ProofofAddress": "Подтверждение адреса",
                        "SourceofIncome": "Источник дохода",
                        "AdditionalDocuments": "Дополнительные документы",
                        "ProofofIdentity": "Подтверждение личности",
                        "CopyofPassport": "Копия паспорта",
                        "CopyofGovernmentIssuedID": "Копия государственного удостоверения личности",
                        "ProofofResidentialAddress": "Подтверждение места жительства",
                        "UtilityBill": "Счет за коммунальные услуги",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "Текущий договор аренды как источник дохода",
                        "Recentbankstatementshowingsalary": "Недавняя выписка из банка, подтверждающая зарплату",
                        "Payslip": "Расчетный лист",
                        "EmploymentContracttoshowyourincomefunds": "Трудовой договор для подтверждения источника дохода",
                        "NoteDocuments": "Примечание: документы должны быть выданы в течение последних 3 календарных месяцев",
                        "Title": "Заголовок",
                        "UploadedAt": "Загружено",
                        "KYCDocuments": "Документы KYC",
                        "OPENANEWDEMOACCOUNT": "ОТКРЫТЬ НОВЫЙ ДЕМО-СЧЕТ",
                        "OPENANEWLIVEACCOUNT": "ОТКРЫТЬ НОВЫЙ РЕАЛЬНЫЙ СЧЕТ",
                        "File": "Файл",
                        "WhishMoneyInstructions": "Для перевода средств через приложение Wish Money выполните следующие действия:",
                        "StepByStepInstructions": "Пошаговые инструкции",
                        "Step1": "1. Скачайте и установите приложение Wish Money:",
                        "Step1Details": "Посетите",
                        "Step1Details1": "страницу загрузки приложения Wish Money.",
                        "Step1Details2": "Скачайте и установите приложение на ваше мобильное устройство.",
                        "Step2": "2. Войдите в приложение Wish Money:",
                        "Step2Details": "Откройте приложение.",
                        "Step2Details1": "Введите ваши учетные данные для доступа к аккаунту.",
                        "Step3": "3. Перейдите в раздел Финансы:",
                        "Step3Details": "После входа выберите раздел 'Финансы' в меню.",
                        "Step4": "4. Введите номер телефона получателя:",
                        "Step4Details": "В соответствующее поле введите номер: 71180175.",
                        "Step5": "5. Укажите сумму перевода:",
                        "Step5Details": "Введите сумму, которую вы хотите перевести, в долларах США.",
                        "Step6": "6. Добавьте примечание с данными вашего счета:",
                        "Step6Details": "В примечании укажите номер торгового счета, затем - GoDoCM Dubai.",
                        "Step6Details1": "Пример: 12345678 - GoDoCM Dubai.",
                        "Step7": "7. Завершите транзакцию:",
                        "Step7Details": "Проверьте все данные для точности.",
                        "Steps7Details1": "Нажмите 'Отправить' для завершения перевода.",
                        "CryptoCurrency": "Криптовалюта",
                        "Network": "Сеть",
                        "Address": "Адрес",
                        "PleaseNoteMinimumWithdrawal": "Минимальная сумма вывода составляет 10$",
                        "AddWallet": "Добавить кошелек",
                        "Wallet": "Кошелек",
                        "AddNewWallet": "Добавить новый кошелек",
                        "Add": "Добавить",
                        "OpenPosition": "Открытая позиция",
                        "ClosePosition": "Закрыть позицию",
                        "Profit": "Прибыль",
                        "Platform": "Платформа",
                        "Iran": "Иран",
                        "DealId": "ID сделки",
                        "Entry": "Вход",
                        "PositionId": "ID позиции",
                        "OpenTimeStamp": "Время открытия",
                        "CloseTimeStamp": "Время закрытия",
                        "EntryPrice": "Цена входа",
                        "ClosePrice": "Цена закрытия",
                        "Direction": "Направление",
                        "Commission": "Комиссия",
                        "Swap": "Своп",
                        "usedMargin": "Используемая маржа",
                        "forIso": "для iOS",
                        "Iraq": "Ирак",
                        "Turkey": "Турция",
                        "Jordan": "Иордания",
                        "Pakistan": "Пакистан",
                        "India": "Индия",
                        "PayPal": "PayPal",
                        "Russia": "Россия",
                        "mexapay": "MexaPay",
                        "InstructionsforTransferringFundsUsingWhishMoney": "Инструкция по переводу средств через Wish Money",
                        "AccesstheWhishMoneyApp": "Откройте приложение Wish Money:",
                        "AccessTheWhishMoneyApp": "Откройте приложение Wish Money на вашем телефоне.",
                        "CompleteTheTransfer": "Завершите перевод",
                        "RecipientsPhoneNumber": "Введите номер телефона получателя: 70809031.",
                        "TransferAmount": "Введите сумму перевода в долларах США.",
                        "Fee": "Важно: добавьте 1% к сумме перевода.",
                        "Example": "Пример: если вы хотите перевести 100$, отправьте 101$.",
                        "SendAReceiptImage": "После завершения транзакции отправьте фото чека в WhatsApp на номер",
                        "SendaReceipt": "Отправьте изображение чека:",
                        "ConfirmtheInfo": "4. Подтвердите информацию:",
                        "ConfirmTheInformation": "Убедитесь, что все введенные данные верны.",
                        "InstructionsforTransferringFundsUsingOMT": "Инструкция по переводу средств через OMT",
                        "AccesstheOMT": "Откройте приложение OMT:",
                        "AccessTheOMTApp": "Откройте приложение OMT на вашем телефоне.",
                        "CompleteTransfer": "Завершите перевод",
                        "RecipientsPhoneNumberOMT": "Введите номер телефона получателя: 70809031.",
                        "TransferAmountOMT": "Введите сумму перевода в долларах США.",
                        "SendAReceiptImageOMT": "После завершения транзакции отправьте фото чека в WhatsApp на номер",
                        "ConfirmtheInfoOMT": "Подтвердите информацию:",
                        "ProfitWithdrawalProcedures": "Процедура вывода прибыли",
                        "RequestAWithdrawal": "Запрос на вывод:",
                        "ProfitWithdrawalRequest": "Отправьте запрос на вывод прибыли через WhatsApp на номер,",
                        "ProfitWithdrawalRequest2": "указав сумму к выводу.",
                        "CompleteTheProcess": "Завершите процесс:",
                        "WithdrawalProcess": "Запрос будет обработан после проверки данных.",
                        "InstructionsforDepositingFundsviaInstaPay": "Инструкция по внесению средств через InstaPay",
                        "OpenInstaPayApp": "Откройте приложение InstaPay",
                        "LaunchtheInstaPayapponyourphone": "Запустите приложение InstaPay на вашем телефоне.",
                        "TransferDetails": "Детали перевода",
                        "EnterRecipientAccountNumber": "Введите адрес получателя: mglamie@instapay",
                        "Thetransferrate": "Курс перевода:",
                        "TransferRate": "1 USD = 49 EGP",
                        "ExampleDeposit": "Пример: чтобы пополнить 100$, отправьте 4900 EGP",
                        "CompleteTransaction": "Завершите транзакцию",
                        "Confirmthedetailsandfinalizethetransfer": "Проверьте данные и завершите перевод.",
                        "SaveTransactionReceipt": "Сохраните квитанцию о транзакции",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "Сделайте снимок экрана или запишите ID транзакции для справки.",
                        "InstaPay": "InstaPay",
                        "JordanPay": "Jordan Pay",
                        "RusiaPay": "Russia Pay",
                        "MobiPay": "MobiPay",
                        "TurkeyPay": "Turkey Pay",
                        "IraqPay": "Iraq Pay",
                        "UploadReceipt": "Загрузить квитанцию",
                        "UploadPaymentReceipt": "Загрузить квитанцию об оплате",
                        "OrderId": "ID заказа",
                        "NetSettle": "Чистая сумма",
                        "EndTime": "Время истечения",
                        "GTNType": "Тип",
                        "Exchange": "Биржа",
                        "ISINCode": "Код ISIN",
                        "Channel": "Канал",
                        "DownloadsForGTN": "Загрузки для GTN",
                        "ImportantNote": "Важная заметка",
                        "ToChangePassword": "Чтобы изменить пароль GTN, перейдите по этой ссылке",
                        "GTNLogin": "Вход в GTN",
                        "LoginToGTN": "и войдите в свою учетную запись GTN, чтобы изменить пароль",
                        "ChangingPassword": "Изменение пароля здесь изменит только пароль клиентского портала, но не пароль торговой платформы GTN",
                        "BankAccount": "Банковский счёт",
                        "ReceiverName": "Имя получателя",
                        "SelectCreditBonus": "Выберите кредитный бонус",
                        "ReviewConditions": "Пожалуйста, ознакомьтесь с условиями бонуса перед выбором кредитного бонуса, нажав на ссылку ниже:",
                        "BonusTermsConditions": "Условия бонуса",
                        "bonus": "Бонус",
                        "ClaimBonus": "🎁 Получить Бонус",
                        "PreferredBonus": "Выберите предпочтительный процент бонуса из выпадающего списка с номером счета.",
                        "Acknowledgment": "✅ Подтверждение",
                        "SubmitBonusRequest": "Нажимая \"Отправить запрос на бонус\", вы подтверждаете, что:",
                        "AcceptedTerms": "Вы прочитали и приняли Условия и Положения о Бонусах.",
                        "AcceptedTerms1": "Вы понимаете, что бонусные кредиты являются рекламными и подчиняются внутренним политикам GODO.",
                        "AcceptedTerms2": "GODO оставляет за собой право изменить или прекратить бонус в любое время, без предварительного уведомления или объяснения",
                        "request": "Запрос счета без свопов",
                        "ImpNote": "Важные заметки",
                        "description": "Если вы хотите запросить счет для торговли без свопов (исламский), пожалуйста, прочитайте",
                        "terms": "условия",
                        "carefully": "внимательно перед подачей заявки.",
                        "swapApproval": "Статус без свопов подлежит одобрению Командой по рискам GODO.",
                        "swapRights": "GODO оставляет за собой право в любое время без предварительного уведомления отменить или изменить статус без свопов.",
                        "swapPurpose": "Счета без свопов предназначены исключительно для клиентов, следующих принципам исламских финансов."
                    }
                }
            },
            vt: {
                translation: {
                    description: {
                        "FPXPay": "FPX Pay",
                        "Dashboard": "Bảng điều khiển",
                        "Accounts": "Tài khoản",
                        "LiveAccounts": "Tài khoản thực",
                        "DemoAccounts": "Tài khoản demo",
                        "ChangePassword": "Đổi mật khẩu",
                        "SwapFree": "Miễn phí Swap",
                        "passwordType": "Loại mật khẩu",
                        "Deposit": "Nạp tiền",
                        "Withdrawals": "Rút tiền",
                        "Withdrawal": "Rút tiền",
                        "InternalTransfer": "Chuyển khoản nội bộ",
                        "PaymentHistory": "Lịch sử thanh toán",
                        "TradeHistory": "Lịch sử giao dịch",
                        "Platforms": "Nền tảng",
                        "Documents": "Tài liệu",
                        "LiveUpdates": "Cập nhật trực tiếp",
                        "MarketUpdates": "Cập nhật thị trường",
                        "MarketOverview": "Tổng quan thị trường",
                        "EconomyCalander": "Lịch kinh tế",
                        "Webinar": "Hội thảo trực tuyến",
                        "UpcomingWebinar": "Hội thảo sắp tới",
                        "Coaching": "Huấn luyện",
                        "KYCStatus": "Trạng thái KYC",
                        "Pending": "Đang chờ xử lý",
                        "Approved": "Đã phê duyệt",
                        "TradingStatus": "Trạng thái giao dịch",
                        "Disabled": "Vô hiệu hóa",
                        "Enabled": "Kích hoạt",
                        "Profile": "Hồ sơ",
                        "SignOut": "Đăng xuất",
                        "BALANCE": "SỐ DƯ",
                        "EQUITY": "VỐN",
                        "DEPOSITS": "TIỀN NẠP",
                        "WITHDRAWAL": "RÚT TIỀN",
                        "TradingAccounts": "Tài khoản giao dịch",
                        "TradingPlatform": "Nền tảng giao dịch",
                        "AccountNumber": "Số tài khoản",
                        "Type": "Loại",
                        "Balance": "Số dư",
                        "Equity": "Vốn",
                        "Stopout": "Mức dừng",
                        "Leverage": "Đòn bẩy",
                        "Action": "Hành động",
                        "Account": "Tài khoản",
                        "GoDo-Live": "GoDo-Thực",
                        "GoDo-Server": "GoDo-Máy chủ",
                        "GoDo-Demo": "GoDo-Demo",
                        "Currency": "Tiền tệ",
                        "FundNow": "Nạp tiền ngay",
                        "CreateAccount": "Tạo tài khoản",
                        "NewPassword": "Mật khẩu mới",
                        "ConfirmNewPassword": "Xác nhận mật khẩu mới",
                        "Submit": "Gửi",
                        "CardPayment": "Thanh toán bằng thẻ",
                        "BankTransfer": "Chuyển khoản ngân hàng",
                        "CryptoDetails": "Chi tiết tiền điện tử",
                        "PerfectMoney": "Perfect Money",
                        "SticPayment": "Thanh toán Stic",
                        "Skrill": "Skrill",
                        "Neteller": "Neteller",
                        "Africa": "Châu Phi",
                        "WishMoney": "Wish Money",
                        "LocalDeposit": "Nạp tiền địa phương",
                        "Morocco": "Ma-rốc",
                        "DepositCurrency": "Tiền tệ nạp",
                        "AmountInUSD": "Số tiền bằng USD",
                        "AmountInMAD": "Số tiền bằng MAD",
                        "AmountInSYP": "Số tiền bằng SYP",
                        "Note": "Ghi chú",
                        "TradingAccount": "Tài khoản giao dịch",
                        "AfrAsiaBankUSD": "Ngân hàng AfrAsia USD",
                        "AfrAsiaBankEUR": "Ngân hàng AfrAsia EUR",
                        "AfrAsiaBankAED": "Ngân hàng AfrAsia AED",
                        "CBDBank": "Ngân hàng CBD",
                        "EqualsMoney": "Equals Money",
                        "Currencies": "Các loại tiền tệ",
                        "BeneficiaryName": "Tên người thụ hưởng",
                        "BeneficiaryAccount": "Tài khoản người thụ hưởng",
                        "BeneficiaryAddress": "Địa chỉ người thụ hưởng",
                        "BankName": "Tên ngân hàng",
                        "ID": "ID",
                        "BankAddress": "Địa chỉ ngân hàng",
                        "IBANNumber": "Số IBAN",
                        "SwiftCode": "Mã Swift",
                        "MinimumAmount": "Số tiền tối thiểu",
                        "AccountForClient": "Tài khoản cho khách hàng",
                        "AfrAsiaBankLtd": "Ngân hàng AfrAsia Ltd",
                        "GODOLTD-CLIENTACCOUNT": "GODO LTD - TÀI KHOẢN KHÁCH HÀNG",
                        "3rdFloor,StandardCharteredTower,Cybercity,Ebene,72201,Mauritius": "Tầng 3, Tháp Standard Chartered, Cybercity, Ebene, 72201, Mauritius",
                        "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius": "Bowen Square 10, Đường Dr Ferriere, Port Louis, Mauritius",
                        "OnlineFunding": "Nạp tiền trực tuyến",
                        "Pleasenotecrypto": "Vui lòng lưu ý rằng nạp tiền bằng tiền điện tử chỉ chấp nhận USDT và USDC với các điều kiện sau để đảm bảo tính bảo mật của giao dịch",
                        "The customer is responsible for any gas fees applied by the exchange": "Khách hàng tự chịu trách nhiệm các phí gas do sàn giao dịch áp dụng",
                        "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department": "Rút tiền sẽ bị khóa trong 15 ngày trừ khi tài khoản được phê duyệt trước bởi bộ phận tuân thủ",
                        "All funds to be returned to original funding source": "Tất cả tiền sẽ được hoàn trả về nguồn gốc ban đầu",
                        "TradingAccountID": "ID tài khoản giao dịch",
                        "DepositAmountinUSD": "Số tiền nạp bằng USD",
                        "WalletAddress": "Địa chỉ ví",
                        "Iacceptthe": "Tôi chấp nhận",
                        "TermsandConditionsforCreditCardDisclaimer": "Điều khoản và điều kiện miễn trừ trách nhiệm thẻ tín dụng",
                        "Next": "Tiếp theo",
                        "PayeeAccount": "Tài khoản người nhận",
                        "SupportService": "Dịch vụ hỗ trợ",
                        "Doyouhaveaquestion": "Bạn có câu hỏi về việc nạp tiền? Vui lòng liên hệ",
                        "ourFinancialSupportService": "Dịch vụ hỗ trợ tài chính của chúng tôi",
                        "Information": "Thông tin",
                        "Exchangeratesandcommission": "Tỷ giá và hoa hồng",
                        "Paymentagentcontacts": "Thông tin liên hệ đại lý thanh toán",
                        "AgentName": "Tên đại lý",
                        "MoroccoPaymentAgent": "Đại lý thanh toán Morocco",
                        "Website": "Trang web",
                        "WorkingHours": "Giờ làm việc",
                        "WhishMoneyPaymentInstructions": "Hướng dẫn thanh toán bằng Wish Money",
                        "Step-by-Step Instructions1. Download and Install the Wish Money App": "Hướng dẫn từng bước 1. Tải xuống và cài đặt ứng dụng Wish Money",
                        "Visit the Wish Money App download page.": "Truy cập trang tải ứng dụng Wish Money",
                        "Download and install the app on your mobile device.": "Tải và cài đặt ứng dụng trên thiết bị di động của bạn",
                        "Login to the Wish Money App": "Đăng nhập vào ứng dụng Wish Money",
                        "Open the app.": "Mở ứng dụng",
                        "Enter your login credentials to access your account.": "Nhập thông tin đăng nhập để truy cập tài khoản của bạn",
                        "Navigate to the Finance Category": "Đi đến mục Tài chính",
                        "After logging in, choose the 'Finance' category from the menu options.": "Sau khi đăng nhập, chọn danh mục 'Tài chính' từ menu",
                        "Enter the Receiver's Phone Number": "Nhập số điện thoại người nhận",
                        "In the designated field, input the receiver's phone number: 71180175.": "Trong trường được chỉ định, nhập số điện thoại người nhận: 71180175.",
                        "Specify the Transfer Amount": "Chỉ định số tiền chuyển",
                        "Enter the amount you wish to transfer in USD.": "Nhập số tiền bạn muốn chuyển bằng USD",
                        "Add a Note with Your Trading Account Details": "Thêm ghi chú với chi tiết tài khoản giao dịch của bạn",
                        "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.": "Trong trường ghi chú, nhập số tài khoản giao dịch của bạn theo sau là - GoDoCM Dubai. Ví dụ: 12345678 - GoDoCM Dubai.",
                        "Complete the Transaction": "Hoàn tất giao dịch",
                        "Review all the details to ensure accuracy.": "Xem lại tất cả chi tiết để đảm bảo chính xác",
                        "Click the 'Send' button to complete the transaction.": "Nhấn nút 'Gửi' để hoàn tất giao dịch",
                        "WithdrawalMethod": "Phương thức rút tiền",
                        "Amount": "Số tiền",
                        "ImportantInformation": "Thông tin quan trọng",
                        "Allfunds": "Toàn bộ số tiền sẽ được hoàn trả về nguồn gốc nạp ban đầu",
                        "Youareentitled": "Bạn được miễn phí rút tiền một lần mỗi tháng; sau đó phí tiêu chuẩn là 25 USD",
                        "FromAccount": "Từ tài khoản",
                        "ToAccount": "Đến tài khoản",
                        "ReportType": "Loại báo cáo",
                        "DateFrom": "Từ ngày",
                        "DateTo": "Đến ngày",
                        "Search": "Tìm kiếm",
                        "Time": "Thời gian",
                        "Status": "Trạng thái",
                        "PENDING": "ĐANG CHỜ",
                        "REJECTED": "BỊ TỪ CHỐI",
                        "APPROVED": "ĐÃ DUYỆT",
                        "AccountType": "Loại tài khoản",
                        "PROCEED": "TIẾP TỤC",
                        "ViewTrades": "Xem giao dịch",
                        "Open Position": "Lệnh mở",
                        "Close Position": "Lệnh đóng",
                        "Symbol": "Ký hiệu",
                        "Ticket": "Vé",
                        "DealType": "Loại giao dịch",
                        "Volume": "Khối lượng",
                        "Price": "Giá",
                        "PriceOpen": "Giá mở",
                        "PriceSI": "Giá SL",
                        "PriceTP": "Giá TP",
                        "PriceCurrent": "Giá hiện tại",
                        "Login": "Đăng nhập",
                        "NoData": "Không có dữ liệu",
                        "DownloadsForMT5": "Tải xuống cho MT5",
                        "DownloadsForMT4": "Tải xuống cho MT4",
                        "DownloadsForCTrader": "Tải xuống cho cTrader",
                        "DownloadNow": "Tải xuống ngay",
                        "forAndroid": "cho Android",
                        "forWindow": "cho Windows",
                        "forMAC": "cho MAC",
                        "forPC": "cho PC",
                        "UploadDocuments": "Tải lên tài liệu",
                        "ProofofID": "Giấy tờ tùy thân (mặt trước hộ chiếu hoặc 2 mặt của CMND)",
                        "ProofofAddress": "Giấy tờ xác minh địa chỉ",
                        "SourceofIncome": "Nguồn thu nhập",
                        "AdditionalDocuments": "Tài liệu bổ sung",
                        "ProofofIdentity": "Giấy tờ xác minh danh tính",
                        "CopyofPassport": "Bản sao hộ chiếu",
                        "CopyofGovernmentIssuedID": "Bản sao giấy tờ tùy thân do chính phủ cấp",
                        "ProofofResidentialAddress": "Giấy tờ chứng minh địa chỉ cư trú",
                        "UtilityBill": "Hóa đơn tiện ích",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "Hợp đồng thuê nhà hiện tại là nguồn thu nhập",
                        "Recentbankstatementshowingsalary": "Sao kê tài khoản ngân hàng gần đây thể hiện lương",
                        "Payslip": "Phiếu lương",
                        "EmploymentContracttoshowyourincomefunds": "Hợp đồng lao động thể hiện nguồn thu nhập",
                        "NoteDocuments": "Lưu ý: Tài liệu phải được cấp trong vòng 3 tháng gần nhất",
                        "Title": "Tiêu đề",
                        "UploadedAt": "Đã tải lên lúc",
                        "KYCDocuments": "Tài liệu KYC",
                        "OPENANEWDEMOACCOUNT": "MỞ TÀI KHOẢN DEMO MỚI",
                        "OPENANEWLIVEACCOUNT": "MỞ TÀI KHOẢN LIVE MỚI",
                        "File": "Tập tin",
                        "WhishMoneyInstructions": "Để chuyển tiền bằng ứng dụng Wish Money, vui lòng làm theo các bước sau:",
                        "StepByStepInstructions": "Hướng dẫn từng bước",
                        "Step1": "1. Tải xuống và cài đặt ứng dụng Wish Money:",
                        "Step1Details": "Truy cập vào",
                        "Step1Details1": "trang tải xuống ứng dụng Wish Money",
                        "Step1Details2": "Tải và cài đặt ứng dụng trên thiết bị di động của bạn",
                        "Step2": "2. Đăng nhập vào ứng dụng Wish Money:",
                        "Step2Details": "Mở ứng dụng",
                        "Step2Details1": "Nhập thông tin đăng nhập của bạn để truy cập tài khoản",
                        "Step3": "3. Chuyển đến danh mục Tài chính:",
                        "Step3Details": "Sau khi đăng nhập, chọn danh mục 'Tài chính' từ menu",
                        "Step4": "4. Nhập số điện thoại người nhận:",
                        "Step4Details": "Trong trường được chỉ định, nhập số điện thoại người nhận: 71180175.",
                        "Step5": "5. Chỉ định số tiền chuyển:",
                        "Step5Details": "Nhập số tiền bạn muốn chuyển bằng USD",
                        "Step6": "6. Thêm ghi chú với số tài khoản giao dịch của bạn:",
                        "Step6Details": "Trong ghi chú, hãy ghi số tài khoản giao dịch của bạn theo sau là - GoDoCM Dubai",
                        "Step6Details1": "Ví dụ: 12345678 - GoDoCM Dubai",
                        "Step7": "7. Hoàn tất giao dịch:",
                        "Step7Details": "Xác minh tất cả thông tin để đảm bảo tính chính xác",
                        "Steps7Details1": "Nhấn 'Gửi' để hoàn tất giao dịch",
                        "CryptoCurrency": "Tiền điện tử",
                        "Network": "Mạng",
                        "Address": "Địa chỉ",
                        "PleaseNoteMinimumWithdrawal": "Vui lòng lưu ý: số tiền rút tối thiểu là 10$",
                        "AddWallet": "Thêm ví",
                        "Wallet": "Ví",
                        "AddNewWallet": "Thêm ví mới",
                        "Add": "Thêm",
                        "OpenPosition": "Vị thế mở",
                        "ClosePosition": "Vị thế đóng",
                        "Profit": "Lợi nhuận",
                        "Platform": "Nền tảng",
                        "Iran": "Iran",
                        "DealId": "Mã giao dịch",
                        "Entry": "Lệnh vào",
                        "PositionId": "ID vị thế",
                        "OpenTimeStamp": "Thời gian mở",
                        "CloseTimeStamp": "Thời gian đóng",
                        "EntryPrice": "Giá vào",
                        "ClosePrice": "Giá đóng",
                        "Direction": "Hướng",
                        "Commission": "Hoa hồng",
                        "Swap": "Phí qua đêm",
                        "usedMargin": "Ký quỹ đã dùng",
                        "forIso": "cho iOS",
                        "Iraq": "Iraq",
                        "Turkey": "Thổ Nhĩ Kỳ",
                        "Jordan": "Jordan",
                        "Pakistan": "Pakistan",
                        "India": "Ấn Độ",
                        "PayPal": "PayPal",
                        "Russia": "Nga",
                        "mexapay": "MexaPay",
                        "InstructionsforTransferringFundsUsingWhishMoney": "Hướng dẫn chuyển tiền bằng Wish Money",
                        "AccesstheWhishMoneyApp": "Truy cập ứng dụng Wish Money:",
                        "AccessTheWhishMoneyApp": "Mở ứng dụng Wish Money trên điện thoại của bạn",
                        "CompleteTheTransfer": "Hoàn tất chuyển tiền",
                        "RecipientsPhoneNumber": "Nhập số điện thoại người nhận: 70809031",
                        "TransferAmount": "Nhập số tiền chuyển bằng USD",
                        "Fee": "Lưu ý: Cộng thêm 1% phí vào số tiền chuyển",
                        "Example": "Ví dụ: nếu muốn chuyển 100$, hãy gửi 101$",
                        "SendAReceiptImage": "Sau khi hoàn tất giao dịch, chụp ảnh biên nhận rõ ràng và gửi qua WhatsApp đến",
                        "SendaReceipt": "Gửi ảnh biên nhận:",
                        "ConfirmtheInfo": "4. Xác nhận thông tin:",
                        "ConfirmTheInformation": "Đảm bảo mọi chi tiết đã nhập là chính xác",
                        "InstructionsforTransferringFundsUsingOMT": "Hướng dẫn chuyển tiền bằng OMT",
                        "AccesstheOMT": "Truy cập ứng dụng OMT:",
                        "AccessTheOMTApp": "Mở ứng dụng OMT trên điện thoại của bạn",
                        "CompleteTransfer": "Hoàn tất chuyển tiền",
                        "RecipientsPhoneNumberOMT": "Nhập số điện thoại người nhận: 70809031",
                        "TransferAmountOMT": "Nhập số tiền chuyển bằng USD",
                        "SendAReceiptImageOMT": "Sau khi hoàn tất giao dịch, gửi ảnh biên nhận qua WhatsApp đến",
                        "ConfirmtheInfoOMT": "Xác nhận thông tin:",
                        "ProfitWithdrawalProcedures": "Quy trình rút lợi nhuận",
                        "RequestAWithdrawal": "Yêu cầu rút tiền:",
                        "ProfitWithdrawalRequest": "Gửi yêu cầu rút lợi nhuận qua WhatsApp đến",
                        "ProfitWithdrawalRequest2": "ghi rõ số tiền cần rút",
                        "CompleteTheProcess": "Hoàn tất quy trình:",
                        "WithdrawalProcess": "Yêu cầu sẽ được xử lý sau khi thông tin được xác minh",
                        "InstructionsforDepositingFundsviaInstaPay": "Hướng dẫn nạp tiền qua InstaPay",
                        "OpenInstaPayApp": "Mở ứng dụng InstaPay",
                        "LaunchtheInstaPayapponyourphone": "Khởi chạy ứng dụng InstaPay trên điện thoại của bạn",
                        "TransferDetails": "Chi tiết chuyển khoản",
                        "EnterRecipientAccountNumber": "Nhập email tài khoản người nhận: mglamie@instapay",
                        "Thetransferrate": "Tỷ giá chuyển đổi:",
                        "TransferRate": "1 USD = 49 EGP",
                        "ExampleDeposit": "Ví dụ: Nạp $100, chuyển 4900 EGP",
                        "CompleteTransaction": "Hoàn tất giao dịch",
                        "Confirmthedetailsandfinalizethetransfer": "Xác nhận thông tin và hoàn tất giao dịch",
                        "SaveTransactionReceipt": "Lưu lại biên nhận giao dịch",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "Chụp màn hình hoặc ghi lại mã giao dịch để tham khảo sau này",
                        "InstaPay": "InstaPay",
                        "JordanPay": "Jordan Pay",
                        "RusiaPay": "Russia Pay",
                        "MobiPay": "MobiPay",
                        "TurkeyPay": "Turkey Pay",
                        "IraqPay": "Iraq Pay",
                        "UploadReceipt": "Tải lên biên nhận",
                        "UploadPaymentReceipt": "Tải lên biên nhận thanh toán",
                        "OrderId": "Mã đơn hàng",
                        "NetSettle": "Số dư ròng",
                        "EndTime": "Thời gian hết hạn",
                        "GTNType": "Loại",
                        "Exchange": "Sàn giao dịch",
                        "ISINCode": "Mã ISIN",
                        "Channel": "Kênh",
                        "DownloadsForGTN": "Tải xuống cho GTN",
                        "ImportantNote": "Lưu ý quan trọng",
                        "ToChangePassword": "Để thay đổi mật khẩu GTN, vui lòng truy cập liên kết này",
                        "GTNLogin": "Đăng nhập GTN",
                        "LoginToGTN": "và đăng nhập vào tài khoản GTN của bạn để thay đổi mật khẩu",
                        "ChangingPassword": "Việc thay đổi mật khẩu tại đây chỉ thay đổi mật khẩu cổng thông tin khách hàng, không phải mật khẩu nền tảng giao dịch GTN",
                        "BankAccount": "Tài khoản ngân hàng",
                        "ReceiverName": "Tên người nhận",
                        "SelectCreditBonus": "Chọn tiền thưởng tín dụng",
                        "ReviewConditions": "Vui lòng xem qua Điều khoản & Điều kiện về tiền thưởng trước khi chọn tiền thưởng tín dụng của bạn bằng cách nhấp vào liên kết bên dưới:",
                        "BonusTermsConditions": "Điều khoản & Điều kiện về tiền thưởng",
                        "bonus": "Tiền thưởng",
                        "ClaimBonus": "🎁 Nhận Thưởng",
                        "PreferredBonus": "Chọn tỷ lệ phần trăm thưởng ưa thích từ menu thả xuống với số tài khoản.",
                        "Acknowledgment": "✅ Xác nhận",
                        "SubmitBonusRequest": "Bằng cách nhấp vào Gửi Yêu cầu Thưởng, bạn xác nhận rằng:",
                        "AcceptedTerms": "Bạn đã đọc và chấp nhận Điều khoản & Điều kiện Thưởng.",
                        "AcceptedTerms1": "Bạn hiểu rằng tín dụng thưởng là khuyến mại và tuân theo các chính sách nội bộ của GODO.",
                        "AcceptedTerms2": "GODO bảo lưu quyền sửa đổi hoặc chấm dứt thưởng bất cứ lúc nào, không cần thông báo trước hoặc giải thích",
                        "request": "Yêu cầu Tài khoản không hoán đổi",
                        "ImpNote": "Lưu ý quan trọng",
                        "description": "Nếu bạn muốn yêu cầu tài khoản giao dịch không hoán đổi (Hồi giáo), vui lòng đọc",
                        "terms": "các điều khoản",
                        "carefully": "cẩn thận trước khi gửi yêu cầu của bạn.",
                        "swapApproval": "Tình trạng không hoán đổi phụ thuộc vào sự chấp thuận của Đội Nguy cơ GODO.",
                        "swapRights": "GODO có quyền thu hồi hoặc thay đổi trạng thái không hoán đổi bất cứ lúc nào mà không cần thông báo trước.",
                        "swapPurpose": "Tài khoản không hoán đổi chỉ dành riêng cho khách hàng tuân thủ các nguyên tắc tài chính Hồi giáo."
                    }
                }
            },
            th: {
                translation: {
                    description: {
                        "FPXPay": "FPX Pay",
                        "Dashboard": "แดชบอร์ด",
                        "Accounts": "บัญชี",
                        "LiveAccounts": "บัญชีจริง",
                        "DemoAccounts": "บัญชีทดลอง",
                        "ChangePassword": "เปลี่ยนรหัสผ่าน",
                        "SwapFree": "ไม่มี Swap",
                        "passwordType": "ประเภทของรหัสผ่าน",
                        "Deposit": "ฝากเงิน",
                        "Withdrawals": "ถอนเงิน",
                        "Withdrawal": "การถอนเงิน",
                        "InternalTransfer": "การโอนภายใน",
                        "PaymentHistory": "ประวัติการชำระเงิน",
                        "TradeHistory": "ประวัติการซื้อขาย",
                        "Platforms": "แพลตฟอร์ม",
                        "Documents": "เอกสาร",
                        "LiveUpdates": "อัปเดตสด",
                        "MarketUpdates": "อัปเดตตลาด",
                        "MarketOverview": "ภาพรวมตลาด",
                        "EconomyCalander": "ปฏิทินเศรษฐกิจ",
                        "Webinar": "สัมมนาออนไลน์",
                        "UpcomingWebinar": "สัมมนาออนไลน์ที่กำลังจะมาถึง",
                        "Coaching": "การฝึกสอน",
                        "KYCStatus": "สถานะ KYC",
                        "Pending": "รอดำเนินการ",
                        "Approved": "อนุมัติแล้ว",
                        "TradingStatus": "สถานะการซื้อขาย",
                        "Disabled": "ปิดใช้งาน",
                        "Enabled": "เปิดใช้งาน",
                        "Profile": "โปรไฟล์",
                        "SignOut": "ออกจากระบบ",
                        "BALANCE": "ยอดคงเหลือ",
                        "EQUITY": "ส่วนของผู้ถือหุ้น",
                        "DEPOSITS": "เงินฝาก",
                        "WITHDRAWAL": "การถอนเงิน",
                        "TradingAccounts": "บัญชีซื้อขาย",
                        "TradingPlatform": "แพลตฟอร์มการซื้อขาย",
                        "AccountNumber": "หมายเลขบัญชี",
                        "Type": "ประเภท",
                        "Balance": "ยอดคงเหลือ",
                        "Equity": "ส่วนของผู้ถือหุ้น",
                        "Stopout": "ระดับหยุดออก",
                        "Leverage": "เลเวอเรจ",
                        "Action": "การดำเนินการ",
                        "Account": "บัญชี",
                        "GoDo-Live": "GoDo-สด",
                        "GoDo-Server": "GoDo-เซิร์ฟเวอร์",
                        "GoDo-Demo": "GoDo-ทดลอง",
                        "Currency": "สกุลเงิน",
                        "FundNow": "เติมเงินตอนนี้",
                        "CreateAccount": "สร้างบัญชี",
                        "NewPassword": "รหัสผ่านใหม่",
                        "ConfirmNewPassword": "ยืนยันรหัสผ่านใหม่",
                        "Submit": "ส่ง",
                        "CardPayment": "ชำระเงินด้วยบัตร",
                        "BankTransfer": "โอนเงินผ่านธนาคาร",
                        "CryptoDetails": "รายละเอียดคริปโต",
                        "PerfectMoney": "Perfect Money",
                        "SticPayment": "Stic Payment",
                        "Skrill": "Skrill",
                        "Neteller": "Neteller",
                        "Africa": "แอฟริกา",
                        "WishMoney": "Wish Money",
                        "LocalDeposit": "ฝากเงินในประเทศ",
                        "Morocco": "โมร็อกโก",
                        "DepositCurrency": "สกุลเงินฝาก",
                        "AmountInUSD": "จำนวนเงินเป็น USD",
                        "AmountInMAD": "จำนวนเงินเป็น MAD",
                        "AmountInSYP": "จำนวนเงินเป็น SYP",
                        "Note": "หมายเหตุ",
                        "TradingAccount": "บัญชีซื้อขาย",
                        "AfrAsiaBankUSD": "AfrAsia Bank USD",
                        "AfrAsiaBankEUR": "AfrAsia Bank EUR",
                        "AfrAsiaBankAED": "AfrAsia Bank AED",
                        "CBDBank": "ธนาคาร CBD",
                        "EqualsMoney": "Equals Money",
                        "Currencies": "สกุลเงิน",
                        "BeneficiaryName": "ชื่อผู้รับผลประโยชน์",
                        "BeneficiaryAccount": "บัญชีผู้รับผลประโยชน์",
                        "BeneficiaryAddress": "ที่อยู่ผู้รับผลประโยชน์",
                        "BankName": "ชื่อธนาคาร",
                        "ID": "รหัสประจำตัว",
                        "BankAddress": "ที่อยู่ธนาคาร",
                        "IBANNumber": "หมายเลข IBAN",
                        "SwiftCode": "รหัส SWIFT",
                        "MinimumAmount": "จำนวนเงินขั้นต่ำ",
                        "AccountForClient": "บัญชีสำหรับลูกค้า",
                        "AfrAsiaBankLtd": "AfrAsia Bank Ltd",
                        "GODOLTD-CLIENTACCOUNT": "GODO LTD - บัญชีลูกค้า",
                        "3rdFloor,StandardCharteredTower,Cybercity,Ebene,72201,Mauritius": "ชั้น 3, อาคาร Standard Chartered, Cybercity, Ebene, 72201, มอริเชียส",
                        "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius": "Bowen Square 10, ถนน Dr Ferriere, Port Louis, มอริเชียส",
                        "OnlineFunding": "การเติมเงินออนไลน์",
                        "Pleasenotecrypto": "โปรดทราบว่าการฝากเงินคริปโตจะรองรับเฉพาะสกุลเงิน USDT และ USDC เท่านั้น พร้อมเงื่อนไขเพื่อความปลอดภัยของธุรกรรม",
                        "The customer is responsible for any gas fees applied by the exchange": "ลูกค้าจะต้องรับผิดชอบค่าธรรมเนียม gas ที่เกิดจากการแลกเปลี่ยน",
                        "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department": "การถอนเงินจะถูกระงับเป็นเวลา 15 วัน เว้นแต่บัญชีจะได้รับการตรวจสอบก่อนหน้านั้นโดยฝ่ายกำกับดูแลของเรา",
                        "All funds to be returned to original funding source": "เงินทั้งหมดจะถูกคืนกลับไปยังแหล่งที่มาของเงินเดิม",
                        "TradingAccountID": "รหัสบัญชีซื้อขาย",
                        "DepositAmountinUSD": "จำนวนเงินฝากเป็น USD",
                        "WalletAddress": "ที่อยู่กระเป๋าเงิน",
                        "Iacceptthe": "ฉันยอมรับ",
                        "TermsandConditionsforCreditCardDisclaimer": "ข้อกำหนดและเงื่อนไขสำหรับการสละสิทธิ์บัตรเครดิต",
                        "Next": "ถัดไป",
                        "PayeeAccount": "บัญชีผู้รับเงิน",
                        "SupportService": "ฝ่ายบริการลูกค้า",
                        "Doyouhaveaquestion": "คุณมีคำถามเกี่ยวกับการฝากเงินใช่หรือไม่? กรุณาติดต่อ",
                        "ourFinancialSupportService": "ฝ่ายสนับสนุนด้านการเงินของเรา",
                        "Information": "ข้อมูล",
                        "Exchangeratesandcommission": "อัตราแลกเปลี่ยนและค่าธรรมเนียม",
                        "Paymentagentcontacts": "ข้อมูลติดต่อของตัวแทนการชำระเงิน",
                        "AgentName": "ชื่อตัวแทน",
                        "MoroccoPaymentAgent": "ตัวแทนการชำระเงินโมร็อกโก",
                        "Website": "เว็บไซต์",
                        "WorkingHours": "เวลาทำการ",
                        "WhishMoneyPaymentInstructions": "คำแนะนำการชำระเงินด้วย Wish Money",
                        "Step-by-Step Instructions1. Download and Install the Wish Money App": "คำแนะนำทีละขั้นตอน 1. ดาวน์โหลดและติดตั้งแอป Wish Money",
                        "Visit the Wish Money App download page.": "ไปที่หน้าดาวน์โหลดแอป Wish Money",
                        "Download and install the app on your mobile device.": "ดาวน์โหลดและติดตั้งแอปในอุปกรณ์มือถือของคุณ",
                        "Login to the Wish Money App": "เข้าสู่ระบบแอป Wish Money",
                        "Open the app.": "เปิดแอป",
                        "Enter your login credentials to access your account.": "กรอกรายละเอียดการเข้าสู่ระบบเพื่อเข้าถึงบัญชีของคุณ",
                        "Navigate to the Finance Category": "ไปที่หมวดการเงิน",
                        "After logging in, choose the 'Finance' category from the menu options.": "หลังจากเข้าสู่ระบบ ให้เลือกหมวด 'การเงิน' จากเมนู",
                        "Enter the Receiver's Phone Number": "กรอกหมายเลขโทรศัพท์ของผู้รับ",
                        "In the designated field, input the receiver's phone number: 71180175.": "ในช่องที่กำหนด ให้ป้อนหมายเลขผู้รับ: 71180175.",
                        "Specify the Transfer Amount": "ระบุจำนวนเงินที่ต้องการโอน",
                        "Enter the amount you wish to transfer in USD.": "กรอกจำนวนเงินที่คุณต้องการโอนเป็นดอลลาร์สหรัฐ",
                        "Add a Note with Your Trading Account Details": "เพิ่มบันทึกพร้อมรายละเอียดบัญชีซื้อขายของคุณ",
                        "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.": "ในช่องหมายเหตุ ให้กรอกหมายเลขบัญชีซื้อขายของคุณตามด้วย - GoDoCM Dubai เช่น: 12345678 - GoDoCM Dubai",
                        "Complete the Transaction": "ดำเนินการทำธุรกรรมให้เสร็จสิ้น",
                        "Review all the details to ensure accuracy.": "ตรวจสอบรายละเอียดทั้งหมดเพื่อความถูกต้อง",
                        "Click the 'Send' button to complete the transaction.": "คลิกปุ่ม 'ส่ง' เพื่อดำเนินการธุรกรรมให้เสร็จสมบูรณ์",
                        "WithdrawalMethod": "วิธีการถอนเงิน",
                        "Amount": "จำนวนเงิน",
                        "ImportantInformation": "ข้อมูลสำคัญ",
                        "Allfunds": "เงินทั้งหมดจะถูกคืนกลับไปยังแหล่งที่มาของเงินเดิม",
                        "Youareentitled": "คุณมีสิทธิ์ถอนเงินฟรี 1 ครั้งต่อเดือน หลังจากนั้นจะมีค่าธรรมเนียมการถอนมาตรฐาน $25",
                        "FromAccount": "จากบัญชี",
                        "ToAccount": "ไปยังบัญชี",
                        "ReportType": "ประเภทของรายงาน",
                        "DateFrom": "วันที่เริ่มต้น",
                        "DateTo": "วันที่สิ้นสุด",
                        "Search": "ค้นหา",
                        "Time": "เวลา",
                        "Status": "สถานะ",
                        "PENDING": "รอดำเนินการ",
                        "REJECTED": "ถูกปฏิเสธ",
                        "APPROVED": "ได้รับการอนุมัติ",
                        "AccountType": "ประเภทบัญชี",
                        "PROCEED": "ดำเนินการต่อ",
                        "ViewTrades": "ดูการซื้อขาย",
                        "Open Position": "สถานะที่เปิดอยู่",
                        "Close Position": "ปิดสถานะ",
                        "Symbol": "สัญลักษณ์",
                        "Ticket": "หมายเลขตั๋ว",
                        "DealType": "ประเภทดีล",
                        "Volume": "ปริมาณ",
                        "Price": "ราคา",
                        "PriceOpen": "ราคาเปิด",
                        "PriceSI": "ราคา SI",
                        "PriceTP": "ราคา TP",
                        "PriceCurrent": "ราคาปัจจุบัน",
                        "Login": "เข้าสู่ระบบ",
                        "NoData": "ไม่มีข้อมูล",
                        "DownloadsForMT5": "ดาวน์โหลดสำหรับ MT5",
                        "DownloadsForMT4": "ดาวน์โหลดสำหรับ MT4",
                        "DownloadsForCTrader": "ดาวน์โหลดสำหรับ cTrader",
                        "DownloadNow": "ดาวน์โหลดตอนนี้",
                        "forAndroid": "สำหรับ Android",
                        "forWindow": "สำหรับ Windows",
                        "forMAC": "สำหรับ MAC",
                        "forPC": "สำหรับ PC",
                        "UploadDocuments": "อัปโหลดเอกสาร",
                        "ProofofID": "หลักฐานยืนยันตัวตน (หน้าหนังสือเดินทางหรือด้านหน้าและหลังของบัตรประจำตัว)",
                        "ProofofAddress": "หลักฐานที่อยู่",
                        "SourceofIncome": "แหล่งรายได้",
                        "AdditionalDocuments": "เอกสารเพิ่มเติม",
                        "ProofofIdentity": "หลักฐานยืนยันตัวตน",
                        "CopyofPassport": "สำเนาหนังสือเดินทาง",
                        "CopyofGovernmentIssuedID": "สำเนาบัตรประชาชน",
                        "ProofofResidentialAddress": "หลักฐานแสดงที่อยู่ปัจจุบัน",
                        "UtilityBill": "ใบแจ้งค่าสาธารณูปโภค",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "สัญญาเช่าปัจจุบันที่แสดงแหล่งรายได้",
                        "Recentbankstatementshowingsalary": "รายการเดินบัญชีธนาคารล่าสุดที่แสดงเงินเดือน",
                        "Payslip": "สลิปเงินเดือน",
                        "EmploymentContracttoshowyourincomefunds": "สัญญาจ้างงานเพื่อแสดงแหล่งรายได้",
                        "NoteDocuments": "หมายเหตุ: เอกสารต้องออกภายใน 3 เดือนปฏิทินล่าสุด",
                        "Title": "หัวข้อ",
                        "UploadedAt": "อัปโหลดเมื่อ",
                        "KYCDocuments": "เอกสาร KYC",
                        "OPENANEWDEMOACCOUNT": "เปิดบัญชีทดลองใหม่",
                        "OPENANEWLIVEACCOUNT": "เปิดบัญชีจริงใหม่",
                        "File": "ไฟล์",
                        "WhishMoneyInstructions": "ในการโอนเงินด้วยแอป Wish Money กรุณาทำตามขั้นตอนด้านล่าง",
                        "StepByStepInstructions": "คำแนะนำทีละขั้นตอน",
                        "Step1": "1. ดาวน์โหลดและติดตั้งแอป Wish Money:",
                        "Step1Details": "ไปที่",
                        "Step1Details1": "หน้าดาวน์โหลดแอป Wish Money",
                        "Step1Details2": "ดาวน์โหลดและติดตั้งแอปในอุปกรณ์มือถือของคุณ",
                        "Step2": "2. เข้าสู่ระบบแอป Wish Money:",
                        "Step2Details": "เปิดแอป",
                        "Step2Details1": "กรอกข้อมูลเข้าสู่ระบบเพื่อเข้าถึงบัญชีของคุณ",
                        "Step3": "3. ไปที่หมวดหมู่การเงิน:",
                        "Step3Details": "หลังจากเข้าสู่ระบบ ให้เลือก 'การเงิน' จากเมนู",
                        "Step4": "4. ป้อนหมายเลขโทรศัพท์ของผู้รับ:",
                        "Step4Details": "ในช่องที่กำหนด ให้ป้อนหมายเลขโทรศัพท์: 71180175",
                        "Step5": "5. ระบุจำนวนเงินที่โอน:",
                        "Step5Details": "ใส่จำนวนเงินที่คุณต้องการโอนเป็น USD",
                        "Step6": "6. เพิ่มหมายเหตุพร้อมหมายเลขบัญชีของคุณ:",
                        "Step6Details": "ในช่องหมายเหตุ ให้พิมพ์หมายเลขบัญชีซื้อขายของคุณตามด้วย - GoDoCM Dubai",
                        "Step6Details1": "เช่น: 12345678 - GoDoCM Dubai",
                        "Step7": "7. ดำเนินการทำธุรกรรม:",
                        "Step7Details": "ตรวจสอบข้อมูลให้ถูกต้อง",
                        "Steps7Details1": "กดปุ่ม 'ส่ง' เพื่อดำเนินการโอน",
                        "CryptoCurrency": "สกุลเงินดิจิทัล",
                        "Network": "เครือข่าย",
                        "Address": "ที่อยู่",
                        "PleaseNoteMinimumWithdrawal": "โปรดทราบ: จำนวนเงินถอนขั้นต่ำคือ 10 ดอลลาร์",
                        "AddWallet": "เพิ่มกระเป๋าเงิน",
                        "Wallet": "กระเป๋าเงิน",
                        "AddNewWallet": "เพิ่มกระเป๋าเงินใหม่",
                        "Add": "เพิ่ม",
                        "OpenPosition": "เปิดสถานะ",
                        "ClosePosition": "ปิดสถานะ",
                        "Profit": "กำไร",
                        "Platform": "แพลตฟอร์ม",
                        "Iran": "อิหร่าน",
                        "DealId": "รหัสดีล",
                        "Entry": "จุดเข้า",
                        "PositionId": "รหัสตำแหน่ง",
                        "OpenTimeStamp": "เวลาเปิด",
                        "CloseTimeStamp": "เวลาปิด",
                        "EntryPrice": "ราคาจุดเข้า",
                        "ClosePrice": "ราคาปิด",
                        "Direction": "ทิศทาง",
                        "Commission": "ค่าคอมมิชชั่น",
                        "Swap": "สวอป",
                        "usedMargin": "มาร์จิ้นที่ใช้",
                        "forIso": "สำหรับ iOS",
                        "Iraq": "อิรัก",
                        "Turkey": "ตุรกี",
                        "Jordan": "จอร์แดน",
                        "Pakistan": "ปากีสถาน",
                        "India": "อินเดีย",
                        "PayPal": "PayPal",
                        "Russia": "รัสเซีย",
                        "mexapay": "MexaPay",
                        "InstructionsforTransferringFundsUsingWhishMoney": "คำแนะนำในการโอนเงินโดยใช้ Wish Money",
                        "AccesstheWhishMoneyApp": "เข้าสู่แอป Wish Money:",
                        "AccessTheWhishMoneyApp": "เปิดแอป Wish Money บนโทรศัพท์ของคุณ",
                        "CompleteTheTransfer": "ดำเนินการโอนให้เสร็จสิ้น",
                        "RecipientsPhoneNumber": "ป้อนหมายเลขโทรศัพท์ของผู้รับ: 70809031",
                        "TransferAmount": "ป้อนจำนวนเงินที่ต้องการโอนเป็นดอลลาร์สหรัฐ",
                        "Fee": "หมายเหตุ: โปรดเพิ่มค่าธรรมเนียม 1% ในการโอน",
                        "Example": "ตัวอย่าง: หากต้องการโอน 100 ดอลลาร์ ให้โอน 101 ดอลลาร์",
                        "SendAReceiptImage": "หลังจากทำธุรกรรมเสร็จแล้ว ให้ถ่ายภาพใบเสร็จและส่งผ่าน WhatsApp ไปยัง",
                        "SendaReceipt": "ส่งภาพใบเสร็จ:",
                        "ConfirmtheInfo": "4. ยืนยันข้อมูล:",
                        "ConfirmTheInformation": "ตรวจสอบรายละเอียดให้ถูกต้องทั้งหมด",
                        "InstructionsforTransferringFundsUsingOMT": "คำแนะนำในการโอนเงินโดยใช้ OMT",
                        "AccesstheOMT": "เข้าสู่แอป OMT:",
                        "AccessTheOMTApp": "เปิดแอป OMT บนโทรศัพท์ของคุณ",
                        "CompleteTransfer": "ดำเนินการโอนให้เสร็จสิ้น",
                        "RecipientsPhoneNumberOMT": "ป้อนหมายเลขโทรศัพท์ของผู้รับ: 70809031",
                        "TransferAmountOMT": "ป้อนจำนวนเงินที่ต้องการโอนเป็น USD",
                        "SendAReceiptImageOMT": "หลังจากทำธุรกรรมเสร็จแล้ว ส่งภาพใบเสร็จผ่าน WhatsApp ไปยัง",
                        "ConfirmtheInfoOMT": "ยืนยันข้อมูล:",
                        "ProfitWithdrawalProcedures": "ขั้นตอนการถอนกำไร",
                        "RequestAWithdrawal": "ส่งคำขอถอน:",
                        "ProfitWithdrawalRequest": "ส่งคำขอถอนกำไรผ่าน WhatsApp ไปยัง",
                        "ProfitWithdrawalRequest2": "พร้อมระบุจำนวนเงินที่ต้องการถอน",
                        "CompleteTheProcess": "ดำเนินการให้เสร็จสมบูรณ์:",
                        "WithdrawalProcess": "คำขอจะได้รับการดำเนินการหลังจากตรวจสอบข้อมูลเรียบร้อยแล้ว",
                        "InstructionsforDepositingFundsviaInstaPay": "คำแนะนำในการฝากเงินผ่าน InstaPay",
                        "OpenInstaPayApp": "เปิดแอป InstaPay",
                        "LaunchtheInstaPayapponyourphone": "เปิดแอป InstaPay บนอุปกรณ์ของคุณ",
                        "TransferDetails": "รายละเอียดการโอน",
                        "EnterRecipientAccountNumber": "ป้อนอีเมลบัญชีของผู้รับ: mglamie@instapay",
                        "Thetransferrate": "อัตราแลกเปลี่ยน:",
                        "TransferRate": "1 USD = 49 EGP",
                        "ExampleDeposit": "ตัวอย่าง: หากต้องการฝาก $100 ให้ส่ง 4900 EGP",
                        "CompleteTransaction": "ดำเนินการธุรกรรมให้เสร็จสิ้น",
                        "Confirmthedetailsandfinalizethetransfer": "ยืนยันรายละเอียดและดำเนินการโอน",
                        "SaveTransactionReceipt": "บันทึกใบเสร็จการทำธุรกรรม",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "ถ่ายภาพหน้าจอหรือจดรหัสธุรกรรมไว้ใช้ในอนาคต",
                        "InstaPay": "InstaPay",
                        "JordanPay": "Jordan Pay",
                        "RusiaPay": "Russia Pay",
                        "MobiPay": "MobiPay",
                        "TurkeyPay": "Turkey Pay",
                        "IraqPay": "Iraq Pay",
                        "UploadReceipt": "อัปโหลดใบเสร็จ",
                        "UploadPaymentReceipt": "อัปโหลดใบเสร็จการชำระเงิน",
                        "OrderId": "รหัสคำสั่งซื้อ",
                        "NetSettle": "ยอดสุทธิ",
                        "EndTime": "เวลาสิ้นสุด",
                        "GTNType": "ประเภท",
                        "Exchange": "ตลาดแลกเปลี่ยน",
                        "ISINCode": "รหัส ISIN",
                        "Channel": "ช่องทาง",
                        "DownloadsForGTN": "ดาวน์โหลดสำหรับ GTN",
                        "ImportantNote": "หมายเหตุสำคัญ",
                        "ToChangePassword": "หากต้องการเปลี่ยนรหัสผ่าน GTN โปรดไปที่ลิงก์นี้",
                        "GTNLogin": "เข้าสู่ระบบ GTN",
                        "LoginToGTN": "	และเข้าสู่บัญชี GTN ของคุณเพื่อเปลี่ยนรหัสผ่าน",
                        "ChangingPassword": "การเปลี่ยนรหัสผ่านที่นี่จะเปลี่ยนเฉพาะรหัสผ่านของพอร์ทัลลูกค้า ไม่ใช่รหัสผ่านของแพลตฟอร์มการซื้อขาย GTN",
                        "BankAccount": "บัญชีธนาคาร",
                        "ReceiverName": "ชื่อผู้รับ",
                        "SelectCreditBonus": "เลือกโบนัสเครดิต",
                        "ReviewConditions": "กรุณาอ่านข้อกำหนดและเงื่อนไขของโบนัสก่อนเลือกโบนัสเครดิตของคุณโดยคลิกที่ลิงก์ด้านล่าง:",
                        "BonusTermsConditions": "ข้อกำหนดและเงื่อนไขของโบนัส",
                        "bonus": "โบนัส",
                        "ClaimBonus": "🎁 รับโบนัส",
                        "PreferredBonus": "เลือกเปอร์เซ็นต์โบนัสที่คุณต้องการจากรายการแบบเลื่อนลงพร้อมหมายเลขบัญชี",
                        "Acknowledgment": "✅ การรับทราบ",
                        "SubmitBonusRequest": "โดยการคลิกส่งคำขอโบนัส คุณรับทราบว่า:",
                        "AcceptedTerms": "คุณได้อ่านและยอมรับข้อกำหนดและเงื่อนไขของโบนัสแล้ว",
                        "AcceptedTerms1": "คุณเข้าใจว่าเครดิตโบนัสเป็นการส่งเสริมการขายและอยู่ภายใต้นโยบายภายในของ GODO",
                        "AcceptedTerms2": "GODO ขอสงวนสิทธิ์ในการแก้ไขหรือยกเลิกโบนัสได้ตลอดเวลา โดยไม่ต้องแจ้งล่วงหน้าหรือให้คำอธิบาย",
                        "request": "ขอเปิดบัญชีปราศจากสว็อป",
                        "ImpNote": "หมายเหตุสำคัญ",
                        "description": "หากคุณต้องการขอบัญชีเทรดแบบปราศจากสว็อป (อิสลาม) กรุณาอ่าน",
                        "terms": "ข้อกำหนด",
                        "carefully": "อย่างระมัดระวังก่อนส่งคำขอของคุณ",
                        "swapApproval": "สถานะปราศจากสว็อปขึ้นอยู่กับการอนุมัติจากทีมความเสี่ยงของ GODO",
                        "swapRights": "GODO สงวนสิทธิ์ในการเพิกถอนหรือแก้ไขสถานะปราศจากสว็อปได้ทุกเมื่อโดยไม่ต้องแจ้งล่วงหน้า",
                        "swapPurpose": "บัญชีปราศจากสว็อปมีไว้สำหรับลูกค้าที่ปฏิบัติตามหลักการทางการเงินอิสลามเท่านั้น"
                    }
                }
            },
            it: {
                translation: {
                    description: {
                        "FPXPay": "FPX Pay",
                        "Dashboard": "Dashboard",
                        "Accounts": "Conti",
                        "LiveAccounts": "Conti Reali",
                        "DemoAccounts": "Conti Demo",
                        "ChangePassword": "Cambia Password",
                        "SwapFree": "Senza Swap",
                        "passwordType": "Tipo di Password",
                        "Deposit": "Deposito",
                        "Withdrawals": "Prelievi",
                        "Withdrawal": "Prelievo",
                        "InternalTransfer": "Trasferimento Interno",
                        "PaymentHistory": "Storico Pagamenti",
                        "TradeHistory": "Storico Operazioni",
                        "Platforms": "Piattaforme",
                        "Documents": "Documenti",
                        "LiveUpdates": "Aggiornamenti Live",
                        "MarketUpdates": "Aggiornamenti di Mercato",
                        "MarketOverview": "Panoramica del Mercato",
                        "EconomyCalander": "Calendario Economico",
                        "Webinar": "Webinar",
                        "UpcomingWebinar": "Webinar in Arrivo",
                        "Coaching": "Coaching",
                        "KYCStatus": "Stato KYC",
                        "Pending": "In Attesa",
                        "Approved": "Approvato",
                        "TradingStatus": "Stato del Trading",
                        "Disabled": "Disabilitato",
                        "Enabled": "Abilitato",
                        "Profile": "Profilo",
                        "SignOut": "Esci",
                        "BALANCE": "SALDO",
                        "EQUITY": "CAPITALE",
                        "DEPOSITS": "DEPOSITI",
                        "WITHDRAWAL": "PRELIEVO",
                        "TradingAccounts": "Conti di Trading",
                        "TradingPlatform": "Piattaforma di Trading",
                        "AccountNumber": "Numero di Conto",
                        "Type": "Tipo di Piattaforma",
                        "Balance": "Saldo",
                        "Equity": "Capitale",
                        "Stopout": "Stopout",
                        "Leverage": "Leva",
                        "Action": "Azione",
                        "Account": "Conto",
                        "GoDo-Live": "GoDo-Live",
                        "GoDo-Server": "GoDo-Server",
                        "GoDo-Demo": "GoDo-Demo",
                        "Currency": "Valuta",
                        "FundNow": "Deposita Ora",
                        "CreateAccount": "Crea Account",
                        "NewPassword": "Nuova Password",
                        "ConfirmNewPassword": "Conferma Nuova Password",
                        "Submit": "Invia",
                        "CardPayment": "Pagamento con Carta",
                        "BankTransfer": "Bonifico Bancario",
                        "CryptoDetails": "Dettagli Cripto",
                        "PerfectMoney": "Perfect Money",
                        "SticPayment": "Stic Payment",
                        "Skrill": "Skrill",
                        "Neteller": "Neteller",
                        "Africa": "Africa",
                        "WishMoney": "Wish Money",
                        "LocalDeposit": "Deposito Locale",
                        "Morocco": "Marocco",
                        "DepositCurrency": "Valuta di Deposito",
                        "AmountInUSD": "Importo in USD",
                        "AmountInMAD": "Importo in MAD",
                        "AmountInSYP": "Importo in SYP",
                        "Note": "Nota",
                        "TradingAccount": "Conto di Trading",
                        "AfrAsiaBankUSD": "AfrAsia Bank USD",
                        "AfrAsiaBankEUR": "AfrAsia Bank EUR",
                        "AfrAsiaBankAED": "AfrAsia Bank AED",
                        "CBDBank": "Banca CBD",
                        "EqualsMoney": "Equals Money",
                        "Currencies": "Valute",
                        "BeneficiaryName": "Nome del Beneficiario",
                        "BeneficiaryAccount": "Conto del Beneficiario",
                        "BeneficiaryAddress": "Indirizzo del Beneficiario",
                        "BankName": "Nome della Banca",
                        "ID": "ID",
                        "BankAddress": "Indirizzo della Banca",
                        "IBANNumber": "Numero IBAN",
                        "SwiftCode": "Codice SWIFT",
                        "MinimumAmount": "Importo Minimo",
                        "AccountForClient": "Conto per il Cliente",
                        "AfrAsiaBankLtd": "AfrAsia Bank Ltd",
                        "GODOLTD-CLIENTACCOUNT": "GODO LTD - CONTO CLIENTE",
                        "3rdFloor,StandardCharteredTower,Cybercity,Ebene,72201,Mauritius": "3° Piano, Torre Standard Chartered, Cybercity, Ebene, 72201, Mauritius",
                        "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius": "Bowen Square 10, Via Dr Ferriere, Port Louis, Mauritius",
                        "OnlineFunding": "Finanziamento Online",
                        "Pleasenotecrypto": "Si prega di notare che i depositi in cripto sono accettati solo in valute USDT e USDC con le seguenti condizioni per proteggere l'integrità delle transazioni",
                        "The customer is responsible for any gas fees applied by the exchange": "Il cliente è responsabile per qualsiasi commissione gas applicata dalla piattaforma",
                        "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department": "I prelievi saranno bloccati per un periodo di 15 giorni, a meno che il conto non venga approvato prima dal nostro dipartimento di conformità",
                        "All funds to be returned to original funding source": "Tutti i fondi verranno restituiti alla fonte di finanziamento originale",
                        "TradingAccountID": "ID del Conto di Trading",
                        "DepositAmountinUSD": "Importo del Deposito in USD",
                        "WalletAddress": "Indirizzo del Wallet",
                        "Iacceptthe": "Accetto le",
                        "TermsandConditionsforCreditCardDisclaimer": "Termini e Condizioni per la Dichiarazione di Esclusione di Responsabilità della Carta di Credito",
                        "Next": "Avanti",
                        "PayeeAccount": "Conto del Beneficiario",
                        "SupportService": "Servizio di Supporto",
                        "Doyouhaveaquestion": "Hai una domanda sul deposito? Contatta",
                        "ourFinancialSupportService": "il nostro Servizio di Supporto Finanziario.",
                        "Information": "Informazioni",
                        "Exchangeratesandcommission": "Tassi di cambio e commissioni",
                        "Paymentagentcontacts": "Contatti degli Agenti di Pagamento",
                        "AgentName": "Nome dell’Agente",
                        "MoroccoPaymentAgent": "Agente di Pagamento in Marocco",
                        "Website": "Sito Web",
                        "WorkingHours": "Orari di Lavoro",
                        "WhishMoneyPaymentInstructions": "Istruzioni di Pagamento con Wish Money",
                        "Step-by-Step Instructions1. Download and Install the Wish Money App": "Istruzioni Passo dopo Passo 1. Scarica e Installa l’App Wish Money",
                        "Visit the Wish Money App download page.": "Visita la pagina di download dell’app Wish Money.",
                        "Download and install the app on your mobile device.": "Scarica e installa l’app sul tuo dispositivo mobile.",
                        "Login to the Wish Money App": "Accedi all’app Wish Money",
                        "Open the app.": "Apri l’app.",
                        "Enter your login credentials to access your account.": "Inserisci le tue credenziali per accedere al tuo account.",
                        "Navigate to the Finance Category": "Naviga alla categoria Finanza",
                        "After logging in, choose the 'Finance' category from the menu options.": "Dopo aver effettuato l’accesso, scegli la categoria 'Finanza' dal menu.",
                        "Enter the Receiver's Phone Number": "Inserisci il numero di telefono del destinatario",
                        "In the designated field, input the receiver's phone number: 71180175.": "Nel campo designato, inserisci il numero del destinatario: 71180175.",
                        "Specify the Transfer Amount": "Specifica l'importo del trasferimento",
                        "Enter the amount you wish to transfer in USD.": "Inserisci l'importo che desideri trasferire in USD.",
                        "Add a Note with Your Trading Account Details": "Aggiungi una nota con i dettagli del tuo conto di trading",
                        "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.": "Nel campo note, inserisci il numero del tuo conto di trading seguito da - GoDoCM Dubai. Esempio: 12345678 - GoDoCM Dubai.",
                        "Complete the Transaction": "Completa la transazione",
                        "Review all the details to ensure accuracy.": "Controlla tutti i dettagli per assicurarti che siano corretti.",
                        "Click the 'Send' button to complete the transaction.": "Clicca su 'Invia' per completare la transazione.",
                        "WithdrawalMethod": "Metodo di Prelievo",
                        "Amount": "Importo",
                        "ImportantInformation": "Informazioni Importanti",
                        "Allfunds": "Tutti i fondi verranno restituiti alla fonte di deposito originale.",
                        "Youareentitled": "Hai diritto a un prelievo gratuito al mese; successivamente verrà applicata una commissione standard di $25.",
                        "FromAccount": "Dal Conto",
                        "ToAccount": "Al Conto",
                        "ReportType": "Tipo di Report",
                        "DateFrom": "Data Inizio",
                        "DateTo": "Data Fine",
                        "Search": "Cerca",
                        "Time": "Ora",
                        "Status": "Stato",
                        "PENDING": "IN ATTESA",
                        "REJECTED": "RIFIUTATO",
                        "APPROVED": "APPROVATO",
                        "AccountType": "Tipo di Conto",
                        "PROCEED": "PROCEDI",
                        "ViewTrades": "Visualizza Operazioni",
                        "Open Position": "Posizione Aperta",
                        "Close Position": "Posizione Chiusa",
                        "Symbol": "Simbolo",
                        "Ticket": "Biglietto",
                        "DealType": "Tipo di Operazione",
                        "Volume": "Volume",
                        "Price": "Prezzo",
                        "PriceOpen": "Prezzo di Apertura",
                        "PriceSI": "Prezzo SI",
                        "PriceTP": "Prezzo TP",
                        "PriceCurrent": "Prezzo Attuale",
                        "Login": "Accesso",
                        "NoData": "Nessun Dato",
                        "DownloadsForMT5": "Download per MT5",
                        "DownloadsForMT4": "Download per MT4",
                        "DownloadsForCTrader": "Download per cTrader",
                        "DownloadNow": "Scarica Ora",
                        "forAndroid": "per Android",
                        "forWindow": "per Windows",
                        "forMAC": "per MAC",
                        "forPC": "per PC",
                        "UploadDocuments": "Carica Documenti",
                        "ProofofID": "Prova di Identità (pagina frontale del passaporto O entrambi i lati del documento d'identità)",
                        "ProofofAddress": "Prova di Residenza",
                        "SourceofIncome": "Fonte di Reddito",
                        "AdditionalDocuments": "Documenti Aggiuntivi",
                        "ProofofIdentity": "Prova di Identità",
                        "CopyofPassport": "Copia del Passaporto",
                        "CopyofGovernmentIssuedID": "Copia del Documento d'Identità Rilasciato dal Governo",
                        "ProofofResidentialAddress": "Prova dell'Indirizzo di Residenza",
                        "UtilityBill": "Bolletta",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "Contratto di Locazione Attuale come Fonte di Reddito",
                        "Recentbankstatementshowingsalary": "Estratto conto bancario recente che mostra lo stipendio",
                        "Payslip": "Busta paga",
                        "EmploymentContracttoshowyourincomefunds": "Contratto di Lavoro per mostrare le tue fonti di reddito",
                        "NoteDocuments": "Nota: i documenti devono essere emessi negli ultimi 3 mesi di calendario",
                        "Title": "Titolo",
                        "UploadedAt": "Caricato il",
                        "KYCDocuments": "Documenti KYC",
                        "OPENANEWDEMOACCOUNT": "APRI UN NUOVO CONTO DEMO",
                        "OPENANEWLIVEACCOUNT": "APRI UN NUOVO CONTO REALE",
                        "File": "File",
                        "WhishMoneyInstructions": "Per trasferire fondi utilizzando l'app Wish Money, segui i passaggi seguenti:",
                        "StepByStepInstructions": "Istruzioni passo dopo passo",
                        "Step1": "1. Scarica e installa l'app Wish Money:",
                        "Step1Details": "Visita la",
                        "Step1Details1": "pagina di download dell'app Wish Money.",
                        "Step1Details2": "Scarica e installa l'app sul tuo dispositivo mobile.",
                        "Step2": "2. Accedi all'app Wish Money:",
                        "Step2Details": "Apri l'app.",
                        "Step2Details1": "Inserisci le tue credenziali per accedere al tuo account.",
                        "Step3": "3. Vai alla categoria Finanza:",
                        "Step3Details": "Dopo aver effettuato l'accesso, scegli la categoria 'Finanza' dal menu.",
                        "Step4": "4. Inserisci il numero di telefono del destinatario:",
                        "Step4Details": "Nel campo designato, inserisci il numero di telefono del destinatario: 71180175.",
                        "Step5": "5. Specifica l'importo del trasferimento:",
                        "Step5Details": "Inserisci l'importo che desideri trasferire in USD.",
                        "Step6": "6. Aggiungi una nota con i dettagli del tuo conto:",
                        "Step6Details": "Nel campo note, inserisci il numero del tuo conto di trading seguito da - GoDoCM Dubai.",
                        "Step6Details1": "Esempio: 12345678 - GoDoCM Dubai.",
                        "Step7": "7. Completa la transazione:",
                        "Step7Details": "Controlla tutti i dettagli per assicurarti che siano corretti.",
                        "Steps7Details1": "Clicca su 'Invia' per completare la transazione.",
                        "CryptoCurrency": "Criptovaluta",
                        "Network": "Rete",
                        "Address": "Indirizzo",
                        "PleaseNoteMinimumWithdrawal": "Nota: il prelievo minimo è di 10$",
                        "AddWallet": "Aggiungi Wallet",
                        "Wallet": "Wallet",
                        "AddNewWallet": "Aggiungi Nuovo Wallet",
                        "Add": "Aggiungi",
                        "OpenPosition": "Apri Posizione",
                        "ClosePosition": "Chiudi Posizione",
                        "Profit": "Profitto",
                        "Platform": "Piattaforma",
                        "Iran": "Iran",
                        "DealId": "ID Operazione",
                        "Entry": "Ingresso",
                        "PositionId": "ID Posizione",
                        "OpenTimeStamp": "Data/Ora Apertura",
                        "CloseTimeStamp": "Data/Ora Chiusura",
                        "EntryPrice": "Prezzo di Ingresso",
                        "ClosePrice": "Prezzo di Chiusura",
                        "Direction": "Direzione",
                        "Commission": "Commissione",
                        "Swap": "Swap",
                        "usedMargin": "Margine Utilizzato",
                        "forIso": "per iOS",
                        "Iraq": "Iraq",
                        "Turkey": "Turchia",
                        "Jordan": "Giordania",
                        "Pakistan": "Pakistan",
                        "India": "India",
                        "PayPal": "PayPal",
                        "Russia": "Russia",
                        "mexapay": "MexaPay",
                        "InstructionsforTransferringFundsUsingWhishMoney": "Istruzioni per il Trasferimento di Fondi con Wish Money",
                        "AccesstheWhishMoneyApp": "Accedi all'App Wish Money:",
                        "AccessTheWhishMoneyApp": "Apri l'app Wish Money sul tuo telefono.",
                        "CompleteTheTransfer": "Completa il Trasferimento",
                        "RecipientsPhoneNumber": "Inserisci il numero di telefono del destinatario: 70809031.",
                        "TransferAmount": "Inserisci l'importo del trasferimento in USD.",
                        "Fee": "Nota Importante: aggiungi una commissione dell'1% all'importo del trasferimento.",
                        "Example": "Esempio: se desideri trasferire $100, invia $101.",
                        "SendAReceiptImage": "Dopo aver completato la transazione, scatta una foto chiara della ricevuta e inviala via WhatsApp a",
                        "SendaReceipt": "Invia un’Immagine della Ricevuta:",
                        "ConfirmtheInfo": "4. Conferma le Informazioni:",
                        "ConfirmTheInformation": "Verifica che tutti i dettagli inseriti siano corretti.",
                        "InstructionsforTransferringFundsUsingOMT": "Istruzioni per il Trasferimento di Fondi con OMT",
                        "AccesstheOMT": "Accedi all'App OMT:",
                        "AccessTheOMTApp": "Apri l'app OMT sul tuo telefono.",
                        "CompleteTransfer": "Completa il Trasferimento",
                        "RecipientsPhoneNumberOMT": "Inserisci il numero del destinatario: 70809031.",
                        "TransferAmountOMT": "Inserisci l'importo del trasferimento in USD.",
                        "SendAReceiptImageOMT": "Dopo aver completato la transazione, invia una foto della ricevuta via WhatsApp a",
                        "ConfirmtheInfoOMT": "Conferma le Informazioni:",
                        "ProfitWithdrawalProcedures": "Procedure di Prelievo dei Profitti",
                        "RequestAWithdrawal": "Richiedi un Prelievo:",
                        "ProfitWithdrawalRequest": "Invia una richiesta di prelievo via WhatsApp a,",
                        "ProfitWithdrawalRequest2": "specificando l'importo da prelevare.",
                        "CompleteTheProcess": "Completa il Processo:",
                        "WithdrawalProcess": "La richiesta verrà elaborata dopo la verifica dei dettagli.",
                        "InstructionsforDepositingFundsviaInstaPay": "Istruzioni per il Deposito Tramite InstaPay",
                        "OpenInstaPayApp": "Apri l'app InstaPay",
                        "LaunchtheInstaPayapponyourphone": "Avvia l'app InstaPay sul tuo telefono.",
                        "TransferDetails": "Dettagli del Trasferimento",
                        "EnterRecipientAccountNumber": "Inserisci l'e-mail del conto destinatario: mglamie@instapay",
                        "Thetransferrate": "Tasso di Cambio:",
                        "TransferRate": "1 USD = 49 EGP",
                        "ExampleDeposit": "Esempio: per depositare $100, invia 4900 EGP",
                        "CompleteTransaction": "Completa la Transazione",
                        "Confirmthedetailsandfinalizethetransfer": "Conferma i dettagli e completa il trasferimento.",
                        "SaveTransactionReceipt": "Salva la Ricevuta della Transazione",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "Fai uno screenshot o annota l'ID della transazione per riferimento futuro.",
                        "InstaPay": "InstaPay",
                        "JordanPay": "Jordan Pay",
                        "RusiaPay": "Russia Pay",
                        "MobiPay": "MobiPay",
                        "TurkeyPay": "Turkey Pay",
                        "IraqPay": "Iraq Pay",
                        "UploadReceipt": "Carica la Ricevuta",
                        "UploadPaymentReceipt": "Carica la Ricevuta di Pagamento",
                        "OrderId": "ID Ordine",
                        "NetSettle": "Liquidazione Netta",
                        "EndTime": "Ora di Scadenza",
                        "GTNType": "Tipo",
                        "Exchange": "Borsa",
                        "ISINCode": "Codice ISIN",
                        "Channel": "Canale",
                        "DownloadsForGTN": "Download per GTN",
                        "ImportantNote": "Nota Importante",
                        "ToChangePassword": "Per cambiare la password GTN, visita questo link",
                        "GTNLogin": "Accesso GTN",
                        "LoginToGTN": "e accedi al tuo account GTN per cambiare la password",
                        "ChangingPassword": "Cambiare la password qui cambierà solo la password del portale clienti, non quella della piattaforma di trading GTN",
                        "BankAccount": "Conto bancario",
                        "ReceiverName": "Nome del destinatario",
                        "SelectCreditBonus": "Seleziona il bonus di credito",
                        "ReviewConditions": "Si prega di leggere i Termini e Condizioni del bonus prima di selezionare il proprio bonus di credito cliccando sul link qui sotto:",
                        "BonusTermsConditions": "Termini e condizioni del bonus",
                        "bonus": "Bonus",
                        "ClaimBonus": "🎁 Richiedi Bonus",
                        "PreferredBonus": "Scegli la percentuale di bonus preferita dal menu a discesa con il numero di conto.",
                        "Acknowledgment": "✅ Riconoscimento",
                        "SubmitBonusRequest": "Cliccando su Invia Richiesta Bonus, riconosci che:",
                        "AcceptedTerms": "Hai letto e accettato i Termini e Condizioni del Bonus.",
                        "AcceptedTerms1": "Comprendi che i crediti bonus sono promozionali e soggetti alle politiche interne di GODO.",
                        "AcceptedTerms2": "GODO si riserva il diritto di modificare o terminare il bonus in qualsiasi momento, senza preavviso o spiegazione",
                        "request": "Richiesta conto Swap-Free",
                        "ImpNote": "Note importanti",
                        "description": "Se desideri richiedere un conto di trading Swap-Free (Islamico), ti preghiamo di leggere i",
                        "terms": "termini",
                        "carefully": "con attenzione prima di inviare la tua richiesta.",
                        "swapApproval": "Lo status Swap-Free è soggetto all'approvazione del Team Rischi di GODO.",
                        "swapRights": "GODO si riserva il diritto di revocare o modificare lo status Swap-Free in qualsiasi momento senza preavviso.",
                        "swapPurpose": "I conti Swap-Free sono destinati esclusivamente ai clienti che seguono i principi della finanza islamica."
                    }
                }
            },
            fr: {
                translation: {
                    description: {
                        "FPXPay": "FPX Pay",
                        "Dashboard": "Tableau de bord",
                        "Accounts": "Comptes",
                        "LiveAccounts": "Comptes réels",
                        "DemoAccounts": "Comptes démo",
                        "ChangePassword": "Changer le mot de passe",
                        "SwapFree": "Sans swap",
                        "passwordType": "Type de mot de passe",
                        "Deposit": "Dépôt",
                        "Withdrawals": "Retraits",
                        "Withdrawal": "Retrait",
                        "InternalTransfer": "Transfert interne",
                        "PaymentHistory": "Historique des paiements",
                        "TradeHistory": "Historique des transactions",
                        "Platforms": "Plateformes",
                        "Documents": "Documents",
                        "LiveUpdates": "Mises à jour en direct",
                        "MarketUpdates": "Mises à jour du marché",
                        "MarketOverview": "Aperçu du marché",
                        "EconomyCalander": "Calendrier économique",
                        "Webinar": "Webinaire",
                        "UpcomingWebinar": "Webinaire à venir",
                        "Coaching": "Coaching",
                        "KYCStatus": "Statut KYC",
                        "Pending": "En attente",
                        "Approved": "Approuvé",
                        "TradingStatus": "Statut de trading",
                        "Disabled": "Désactivé",
                        "Enabled": "Activé",
                        "Profile": "Profil",
                        "SignOut": "Déconnexion",
                        "BALANCE": "SOLDE",
                        "EQUITY": "CAPITAL",
                        "DEPOSITS": "DÉPÔTS",
                        "WITHDRAWAL": "RETRAIT",
                        "TradingAccounts": "Comptes de trading",
                        "TradingPlatform": "Plateforme de trading",
                        "AccountNumber": "Numéro de compte",
                        "Type": "Type de plateforme",
                        "Balance": "Solde",
                        "Equity": "Capitaux propres",
                        "Stopout": "Stop out",
                        "Leverage": "Effet de levier",
                        "Action": "Action",
                        "Account": "Compte",
                        "GoDo-Live": "GoDo-Live",
                        "GoDo-Server": "Serveur GoDo",
                        "GoDo-Demo": "GoDo-Démo",
                        "Currency": "Devise",
                        "FundNow": "Approvisionner maintenant",
                        "CreateAccount": "Créer un compte",
                        "NewPassword": "Nouveau mot de passe",
                        "ConfirmNewPassword": "Confirmer le nouveau mot de passe",
                        "Submit": "Soumettre",
                        "CardPayment": "Paiement par carte",
                        "BankTransfer": "Virement bancaire",
                        "CryptoDetails": "Détails Crypto",
                        "PerfectMoney": "Perfect Money",
                        "SticPayment": "Stic Payment",
                        "Skrill": "Skrill",
                        "Neteller": "Neteller",
                        "Africa": "Afrique",
                        "WishMoney": "Wish Money",
                        "LocalDeposit": "Dépôt local",
                        "Morocco": "Maroc",
                        "DepositCurrency": "Devise du dépôt",
                        "AmountInUSD": "Montant en USD",
                        "AmountInMAD": "Montant en MAD",
                        "AmountInSYP": "Montant en SYP",
                        "Note": "Remarque",
                        "TradingAccount": "Compte de trading",
                        "AfrAsiaBankUSD": "Banque AfrAsia USD",
                        "AfrAsiaBankEUR": "Banque AfrAsia EUR",
                        "AfrAsiaBankAED": "Banque AfrAsia AED",
                        "CBDBank": "Banque CBD",
                        "EqualsMoney": "Equals Money",
                        "Currencies": "Devises",
                        "BeneficiaryName": "Nom du bénéficiaire",
                        "BeneficiaryAccount": "Compte du bénéficiaire",
                        "BeneficiaryAddress": "Adresse du bénéficiaire",
                        "BankName": "Nom de la banque",
                        "ID": "Identifiant",
                        "BankAddress": "Adresse de la banque",
                        "IBANNumber": "Numéro IBAN",
                        "SwiftCode": "Code SWIFT",
                        "MinimumAmount": "Montant minimum",
                        "AccountForClient": "Compte pour le client",
                        "AfrAsiaBankLtd": "AfrAsia Bank Ltd",
                        "GODOLTD-CLIENTACCOUNT": "GODO LTD - COMPTE CLIENT",
                        "3rdFloor,StandardCharteredTower,Cybercity,Ebene,72201,Mauritius": "3ème étage, Tour Standard Chartered, Cybercity, Ébène, 72201, Maurice",
                        "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius": "Bowen Square 10, Rue Dr Ferriere, Port-Louis, Maurice",
                        "OnlineFunding": "Financement en ligne",
                        "Pleasenotecrypto": "Veuillez noter que les dépôts en crypto sont acceptés uniquement en USDT et USDC avec les conditions suivantes pour garantir l'intégrité des transactions",
                        "The customer is responsible for any gas fees applied by the exchange": "Le client est responsable des frais de gaz appliqués par la plateforme",
                        "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department": "Les retraits seront bloqués pendant 15 jours sauf si le compte est validé plus tôt par notre département de conformité",
                        "All funds to be returned to original funding source": "Tous les fonds seront retournés à la source de financement d'origine",
                        "TradingAccountID": "ID du compte de trading",
                        "DepositAmountinUSD": "Montant du dépôt en USD",
                        "WalletAddress": "Adresse du portefeuille",
                        "Iacceptthe": "J'accepte les",
                        "TermsandConditionsforCreditCardDisclaimer": "Termes et conditions de la décharge de responsabilité pour carte de crédit",
                        "Next": "Suivant",
                        "PayeeAccount": "Compte du bénéficiaire",
                        "SupportService": "Service d’assistance",
                        "Doyouhaveaquestion": "Vous avez une question concernant le dépôt ? Veuillez contacter",
                        "ourFinancialSupportService": "notre service d'assistance financière.",
                        "Information": "Informations",
                        "Exchangeratesandcommission": "Taux de change et commission",
                        "Paymentagentcontacts": "Contacts des agents de paiement",
                        "AgentName": "Nom de l’agent",
                        "MoroccoPaymentAgent": "Agent de paiement au Maroc",
                        "Website": "Site web",
                        "WorkingHours": "Heures de travail",
                        "WhishMoneyPaymentInstructions": "Instructions de paiement avec Wish Money",
                        "Step-by-Step Instructions1. Download and Install the Wish Money App": "Instructions pas à pas 1. Téléchargez et installez l’application Wish Money",
                        "Visit the Wish Money App download page.": "Visitez la page de téléchargement de l'application Wish Money.",
                        "Download and install the app on your mobile device.": "Téléchargez et installez l'application sur votre appareil mobile.",
                        "Login to the Wish Money App": "Connectez-vous à l'application Wish Money",
                        "Open the app.": "Ouvrez l'application.",
                        "Enter your login credentials to access your account.": "Entrez vos identifiants pour accéder à votre compte.",
                        "Navigate to the Finance Category": "Naviguez vers la catégorie Finance",
                        "After logging in, choose the 'Finance' category from the menu options.": "Après connexion, sélectionnez la catégorie 'Finance' dans le menu.",
                        "Enter the Receiver's Phone Number": "Entrez le numéro de téléphone du destinataire",
                        "In the designated field, input the receiver's phone number: 71180175.": "Dans le champ prévu, saisissez le numéro du destinataire : 71180175.",
                        "Specify the Transfer Amount": "Spécifiez le montant du transfert",
                        "Enter the amount you wish to transfer in USD.": "Entrez le montant que vous souhaitez transférer en USD.",
                        "Add a Note with Your Trading Account Details": "Ajoutez une note avec les détails de votre compte de trading",
                        "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.": "Dans le champ de note, entrez votre numéro de compte de trading suivi de - GoDoCM Dubaï. Exemple : 12345678 - GoDoCM Dubaï.",
                        "Complete the Transaction": "Finalisez la transaction",
                        "Review all the details to ensure accuracy.": "Vérifiez tous les détails pour garantir leur exactitude.",
                        "Click the 'Send' button to complete the transaction.": "Cliquez sur le bouton 'Envoyer' pour finaliser la transaction.",
                        "WithdrawalMethod": "Méthode de retrait",
                        "Amount": "Montant",
                        "ImportantInformation": "Informations importantes",
                        "Allfunds": "Tous les fonds seront retournés à la source de financement initiale.",
                        "Youareentitled": "Vous avez droit à un retrait gratuit par mois ; ensuite, des frais standard de 25 $ s’appliquent.",
                        "FromAccount": "Depuis le compte",
                        "ToAccount": "Vers le compte",
                        "ReportType": "Type de rapport",
                        "DateFrom": "Date de début",
                        "DateTo": "Date de fin",
                        "Search": "Rechercher",
                        "Time": "Heure",
                        "Status": "Statut",
                        "PENDING": "EN ATTENTE",
                        "REJECTED": "REJETÉ",
                        "APPROVED": "APPROUVÉ",
                        "AccountType": "Type de compte",
                        "PROCEED": "CONTINUER",
                        "ViewTrades": "Voir les transactions",
                        "Open Position": "Position ouverte",
                        "Close Position": "Position fermée",
                        "Symbol": "Symbole",
                        "Ticket": "Ticket",
                        "DealType": "Type d'opération",
                        "Volume": "Volume",
                        "Price": "Prix",
                        "PriceOpen": "Prix d'ouverture",
                        "PriceSI": "Prix SL",
                        "PriceTP": "Prix TP",
                        "PriceCurrent": "Prix actuel",
                        "Login": "Connexion",
                        "NoData": "Aucune donnée",
                        "DownloadsForMT5": "Téléchargements pour MT5",
                        "DownloadsForMT4": "Téléchargements pour MT4",
                        "DownloadsForCTrader": "Téléchargements pour cTrader",
                        "DownloadNow": "Télécharger maintenant",
                        "forAndroid": "pour Android",
                        "forWindow": "pour Windows",
                        "forMAC": "pour Mac",
                        "forPC": "pour PC",
                        "UploadDocuments": "Téléverser des documents",
                        "ProofofID": "Preuve d'identité (page de passeport ou recto-verso de la carte d'identité)",
                        "ProofofAddress": "Justificatif de domicile",
                        "SourceofIncome": "Source de revenus",
                        "AdditionalDocuments": "Documents supplémentaires",
                        "ProofofIdentity": "Justificatif d'identité",
                        "CopyofPassport": "Copie du passeport",
                        "CopyofGovernmentIssuedID": "Copie de la carte d'identité délivrée par le gouvernement",
                        "ProofofResidentialAddress": "Justificatif de résidence",
                        "UtilityBill": "Facture de services publics",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "Contrat de location actuel comme source de revenus",
                        "Recentbankstatementshowingsalary": "Relevé bancaire récent indiquant le salaire",
                        "Payslip": "Fiche de paie",
                        "EmploymentContracttoshowyourincomefunds": "Contrat de travail pour montrer vos revenus",
                        "NoteDocuments": "Remarque : les documents doivent dater des 3 derniers mois calendaires",
                        "Title": "Titre",
                        "UploadedAt": "Téléversé le",
                        "KYCDocuments": "Documents KYC",
                        "OPENANEWDEMOACCOUNT": "OUVRIR UN NOUVEAU COMPTE DÉMO",
                        "OPENANEWLIVEACCOUNT": "OUVRIR UN NOUVEAU COMPTE RÉEL",
                        "File": "Fichier",
                        "WhishMoneyInstructions": "Pour transférer des fonds via l’application Wish Money, veuillez suivre les étapes ci-dessous :",
                        "StepByStepInstructions": "Instructions étape par étape",
                        "Step1": "1. Téléchargez et installez l’application Wish Money :",
                        "Step1Details": "Visitez la",
                        "Step1Details1": "page de téléchargement de l’application Wish Money.",
                        "Step1Details2": "Téléchargez et installez l’application sur votre appareil mobile.",
                        "Step2": "2. Connectez-vous à l’application Wish Money :",
                        "Step2Details": "Ouvrez l’application.",
                        "Step2Details1": "Entrez vos identifiants pour accéder à votre compte.",
                        "Step3": "3. Allez dans la catégorie Finance :",
                        "Step3Details": "Après connexion, sélectionnez la catégorie 'Finance' dans le menu.",
                        "Step4": "4. Entrez le numéro de téléphone du destinataire :",
                        "Step4Details": "Dans le champ prévu, entrez le numéro : 71180175.",
                        "Step5": "5. Spécifiez le montant du transfert :",
                        "Step5Details": "Saisissez le montant que vous souhaitez transférer en USD.",
                        "Step6": "6. Ajoutez une note avec votre numéro de compte de trading :",
                        "Step6Details": "Dans le champ de note, entrez votre numéro suivi de - GoDoCM Dubaï.",
                        "Step6Details1": "Exemple : 12345678 - GoDoCM Dubaï.",
                        "Step7": "7. Terminez la transaction :",
                        "Step7Details": "Vérifiez tous les détails pour vous assurer qu’ils sont exacts.",
                        "Steps7Details1": "Cliquez sur le bouton 'Envoyer' pour finaliser la transaction.",

                        "CryptoCurrency": "Cryptomonnaie",
                        "Network": "Réseau",
                        "Address": "Adresse",
                        "PleaseNoteMinimumWithdrawal": "Veuillez noter que le montant minimum de retrait est de 10 $",
                        "AddWallet": "Ajouter un portefeuille",
                        "Wallet": "Portefeuille",
                        "AddNewWallet": "Ajouter un nouveau portefeuille",
                        "Add": "Ajouter",
                        "OpenPosition": "Ouvrir une position",
                        "ClosePosition": "Fermer la position",
                        "Profit": "Profit",
                        "Platform": "Plateforme",
                        "Iran": "Iran",
                        "DealId": "ID de transaction",
                        "Entry": "Entrée",
                        "PositionId": "ID de position",
                        "OpenTimeStamp": "Horodatage d'ouverture",
                        "CloseTimeStamp": "Horodatage de clôture",
                        "EntryPrice": "Prix d'entrée",
                        "ClosePrice": "Prix de clôture",
                        "Direction": "Direction",
                        "Commission": "Commission",
                        "Swap": "Swap",
                        "usedMargin": "Marge utilisée",
                        "forIso": "pour iOS",
                        "Iraq": "Irak",
                        "Turkey": "Turquie",
                        "Jordan": "Jordanie",
                        "Pakistan": "Pakistan",
                        "India": "Inde",
                        "PayPal": "PayPal",
                        "Russia": "Russie",
                        "mexapay": "MexaPay",
                        "InstructionsforTransferringFundsUsingWhishMoney": "Instructions pour transférer des fonds avec Wish Money",
                        "AccesstheWhishMoneyApp": "Accédez à l'application Wish Money :",
                        "AccessTheWhishMoneyApp": "Ouvrez l'application Wish Money sur votre téléphone.",
                        "CompleteTheTransfer": "Effectuer le transfert",
                        "RecipientsPhoneNumber": "Entrez le numéro de téléphone du destinataire : 70809031.",
                        "TransferAmount": "Entrez le montant du transfert en USD.",
                        "Fee": "Remarque importante : ajoutez 1 % de frais au montant du transfert.",
                        "Example": "Exemple : si vous souhaitez transférer 100 $, envoyez 101 $.",
                        "SendAReceiptImage": "Après avoir effectué la transaction, prenez une photo claire du reçu et envoyez-la via WhatsApp à",
                        "SendaReceipt": "Envoyer une image du reçu :",
                        "ConfirmtheInfo": "4. Confirmez les informations :",
                        "ConfirmTheInformation": "Assurez-vous que toutes les informations saisies sont correctes.",
                        "InstructionsforTransferringFundsUsingOMT": "Instructions pour transférer des fonds avec OMT",
                        "AccesstheOMT": "Accédez à l'application OMT :",
                        "AccessTheOMTApp": "Ouvrez l'application OMT sur votre téléphone.",
                        "CompleteTransfer": "Effectuez le transfert",
                        "RecipientsPhoneNumberOMT": "Entrez le numéro de téléphone du destinataire : 70809031.",
                        "TransferAmountOMT": "Entrez le montant du transfert en USD.",
                        "SendAReceiptImageOMT": "Après avoir effectué la transaction, envoyez une photo du reçu via WhatsApp à",
                        "ConfirmtheInfoOMT": "Confirmez les informations :",
                        "ProfitWithdrawalProcedures": "Procédures de retrait de profits",
                        "RequestAWithdrawal": "Demander un retrait :",
                        "ProfitWithdrawalRequest": "Envoyez une demande de retrait via WhatsApp à,",
                        "ProfitWithdrawalRequest2": "en précisant le montant à retirer.",
                        "CompleteTheProcess": "Terminez le processus :",
                        "WithdrawalProcess": "La demande sera traitée après vérification des informations.",
                        "InstructionsforDepositingFundsviaInstaPay": "Instructions pour déposer des fonds via InstaPay",
                        "OpenInstaPayApp": "Ouvrez l'application InstaPay",
                        "LaunchtheInstaPayapponyourphone": "Lancez l'application InstaPay sur votre téléphone.",
                        "TransferDetails": "Détails du transfert",
                        "EnterRecipientAccountNumber": "Saisissez l'e-mail du compte destinataire : mglamie@instapay",
                        "Thetransferrate": "Taux de change :",
                        "TransferRate": "1 USD = 49 EGP",
                        "ExampleDeposit": "Exemple : pour déposer 100 $, envoyez 4900 EGP",
                        "CompleteTransaction": "Finalisez la transaction",
                        "Confirmthedetailsandfinalizethetransfer": "Confirmez les détails et finalisez le transfert.",
                        "SaveTransactionReceipt": "Enregistrez le reçu de la transaction",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "Prenez une capture d'écran ou notez l'ID de la transaction pour référence future.",
                        "InstaPay": "InstaPay",
                        "JordanPay": "Paiement Jordanie",
                        "RusiaPay": "Paiement Russie",
                        "MobiPay": "MobiPay",
                        "TurkeyPay": "Paiement Turquie",
                        "IraqPay": "Paiement Irak",
                        "UploadReceipt": "Téléverser le reçu",
                        "UploadPaymentReceipt": "Téléverser le reçu de paiement",
                        "OrderId": "ID de commande",
                        "NetSettle": "Règlement net",
                        "EndTime": "Heure d'expiration",
                        "GTNType": "Type",
                        "Exchange": "Échange",
                        "ISINCode": "Code ISIN",
                        "Channel": "Canal",
                        "DownloadsForGTN": "Téléchargements pour GTN",
                        "ImportantNote": "Remarque importante",
                        "ToChangePassword": "Pour changer le mot de passe GTN, visitez ce lien",
                        "GTNLogin": "Connexion GTN",
                        "LoginToGTN": "et connectez-vous à votre compte GTN pour changer le mot de passe",
                        "ChangingPassword": "Changer le mot de passe ici ne changera que celui du portail client, pas celui de la plateforme de trading GTN",
                        "BankAccount": "Compte bancaire",
                        "ReceiverName": "Nom du bénéficiaire",
                        "SelectCreditBonus": "Sélectionnez un bonus de crédit",
                        "ReviewConditions": "Veuillez consulter les conditions générales du bonus avant de sélectionner votre bonus de crédit en cliquant sur le lien ci-dessous:",
                        "BonusTermsConditions": "Conditions générales du bonus",
                        "bonus": "Bonus",
                        "ClaimBonus": "🎁 Réclamer le Bonus",
                        "PreferredBonus": "Choisissez votre pourcentage de bonus préféré dans le menu déroulant avec le numéro de compte.",
                        "Acknowledgment": "✅ Reconnaissance",
                        "SubmitBonusRequest": "En cliquant sur Soumettre la Demande de Bonus, vous reconnaissez que :",
                        "AcceptedTerms": "Vous avez lu et accepté les Termes et Conditions du Bonus.",
                        "AcceptedTerms1": "Vous comprenez que les crédits bonus sont promotionnels et soumis aux politiques internes de GODO.",
                        "AcceptedTerms2": "GODO se réserve le droit de modifier ou de résilier le bonus à tout moment, sans préavis ni explication",
                        "request": "Demande de compte sans swap",
                        "ImpNote": "Notes importantes",
                        "description": "Si vous souhaitez demander un compte de trading sans swap (islamique), veuillez lire les",
                        "terms": "conditions",
                        "carefully": "attentivement avant de soumettre votre demande.",
                        "swapApproval": "Le statut sans swap est soumis à l'approbation de l'équipe des risques de GODO.",
                        "swapRights": "GODO se réserve le droit de révoquer ou de modifier le statut sans swap à tout moment sans préavis.",
                        "swapPurpose": "Les comptes sans swap sont strictement destinés aux clients qui suivent les principes de la finance islamique."
                    }
                }
            },
            cn: {
                translation: {
                    description: {
                        "FPXPay": "FPX Pay",
                        "Dashboard": "仪表板",
                        "Accounts": "账户",
                        "LiveAccounts": "真实账户",
                        "DemoAccounts": "模拟账户",
                        "ChangePassword": "更改密码",
                        "SwapFree": "免掉期",
                        "passwordType": "密码类型",
                        "Deposit": "存款",
                        "Withdrawals": "提款",
                        "Withdrawal": "提款",
                        "InternalTransfer": "内部转账",
                        "PaymentHistory": "支付历史",
                        "TradeHistory": "交易历史",
                        "Platforms": "平台",
                        "Documents": "文件",
                        "LiveUpdates": "实时更新",
                        "MarketUpdates": "市场更新",
                        "MarketOverview": "市场概览",
                        "EconomyCalander": "经济日历",
                        "Webinar": "网络研讨会",
                        "UpcomingWebinar": "即将举行的网络研讨会",
                        "Coaching": "辅导",
                        "KYCStatus": "KYC 状态",
                        "Pending": "待处理",
                        "Approved": "已批准",
                        "TradingStatus": "交易状态",
                        "Disabled": "已禁用",
                        "Enabled": "已启用",
                        "Profile": "个人资料",
                        "SignOut": "登出",
                        "BALANCE": "余额",
                        "EQUITY": "净值",
                        "DEPOSITS": "存款",
                        "WITHDRAWAL": "提款",
                        "TradingAccounts": "交易账户",
                        "TradingPlatform": "交易平台",
                        "AccountNumber": "账户号码",
                        "Type": "平台类型",
                        "Balance": "余额",
                        "Equity": "净值",
                        "Stopout": "强平",
                        "Leverage": "杠杆",
                        "Action": "操作",
                        "Account": "账户",
                        "GoDo-Live": "GoDo-Live",
                        "GoDo-Server": "GoDo-服务器",
                        "GoDo-Demo": "GoDo-模拟",
                        "Currency": "货币",
                        "FundNow": "立即入金",
                        "CreateAccount": "创建账户",
                        "NewPassword": "新密码",
                        "ConfirmNewPassword": "确认新密码",
                        "Submit": "提交",
                        "CardPayment": "信用卡支付",
                        "BankTransfer": "银行转账",
                        "CryptoDetails": "加密货币详情",
                        "PerfectMoney": "Perfect Money",
                        "SticPayment": "Stic Payment",
                        "Skrill": "Skrill",
                        "Neteller": "Neteller",
                        "Africa": "非洲",
                        "WishMoney": "Wish Money",
                        "LocalDeposit": "本地入金",
                        "Morocco": "摩洛哥",
                        "DepositCurrency": "存款货币",
                        "AmountInUSD": "金额（美元）",
                        "AmountInMAD": "金额（摩洛哥迪拉姆）",
                        "AmountInSYP": "金额（叙利亚镑）",
                        "Note": "备注",
                        "TradingAccount": "交易账户",
                        "AfrAsiaBankUSD": "AfrAsia 银行（美元）",
                        "AfrAsiaBankEUR": "AfrAsia 银行（欧元）",
                        "AfrAsiaBankAED": "AfrAsia 银行（迪拉姆）",
                        "CBDBank": "CBD 银行",
                        "EqualsMoney": "Equals Money",
                        "Currencies": "货币",
                        "BeneficiaryName": "收款人姓名",
                        "BeneficiaryAccount": "收款人账户",
                        "BeneficiaryAddress": "收款人地址",
                        "BankName": "银行名称",
                        "ID": "身份证件",
                        "BankAddress": "银行地址",
                        "IBANNumber": "IBAN号码",
                        "SwiftCode": "SWIFT代码",
                        "MinimumAmount": "最低金额",
                        "AccountForClient": "客户账户",
                        "AfrAsiaBankLtd": "AfrAsia Bank Ltd",
                        "GODOLTD-CLIENTACCOUNT": "GODO有限公司 - 客户账户",
                        "3rdFloor,StandardCharteredTower,Cybercity,Ebene,72201,Mauritius": "毛里求斯埃本Cybercity渣打大厦三楼，邮编72201",
                        "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius": "毛里求斯路易港Dr Ferriere街，Bowen广场10号",
                        "OnlineFunding": "在线入金",
                        "Pleasenotecrypto": "请注意，加密货币仅接受USDT和USDC，并须满足以下条件以确保交易安全",
                        "The customer is responsible for any gas fees applied by the exchange": "客户需承担交易所产生的Gas费用",
                        "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department": "除非合规部门提前批准，提款将在15天内被冻结",
                        "All funds to be returned to original funding source": "所有资金将退回原始入金来源",
                        "TradingAccountID": "交易账户ID",
                        "DepositAmountinUSD": "存款金额（美元）",
                        "WalletAddress": "钱包地址",
                        "Iacceptthe": "我接受",
                        "TermsandConditionsforCreditCardDisclaimer": "信用卡免责声明条款和条件",
                        "Next": "下一步",
                        "PayeeAccount": "收款账户",
                        "SupportService": "客服服务",
                        "Doyouhaveaquestion": "您有关于存款的问题吗？请联系",
                        "ourFinancialSupportService": "我们的财务支持服务。",
                        "Information": "信息",
                        "Exchangeratesandcommission": "汇率与手续费",
                        "Paymentagentcontacts": "支付代理联系方式",
                        "AgentName": "代理名称",
                        "MoroccoPaymentAgent": "摩洛哥支付代理",
                        "Website": "网站",
                        "WorkingHours": "工作时间",
                        "WhishMoneyPaymentInstructions": "Wish Money支付说明",
                        "Step-by-Step Instructions1. Download and Install the Wish Money App": "第一步：下载并安装Wish Money应用",
                        "Visit the Wish Money App download page.": "访问Wish Money应用下载页面。",
                        "Download and install the app on your mobile device.": "在您的移动设备上下载安装该应用。",
                        "Login to the Wish Money App": "登录Wish Money应用",
                        "Open the app.": "打开应用。",
                        "Enter your login credentials to access your account.": "输入您的登录信息访问账户。",
                        "Navigate to the Finance Category": "进入金融分类",
                        "After logging in, choose the 'Finance' category from the menu options.": "登录后，从菜单中选择“金融”分类。",
                        "Enter the Receiver's Phone Number": "输入收款人手机号",
                        "In the designated field, input the receiver's phone number: 71180175.": "在指定字段中输入收款人手机号：71180175。",
                        "Specify the Transfer Amount": "指定转账金额",
                        "Enter the amount you wish to transfer in USD.": "输入您要转账的美元金额。",
                        "Add a Note with Your Trading Account Details": "添加备注并填写您的交易账户信息",
                        "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.": "在备注栏中输入您的交易账户号码，后跟 - GoDoCM Dubai。例如：12345678 - GoDoCM Dubai。",
                        "Complete the Transaction": "完成交易",
                        "Review all the details to ensure accuracy.": "请检查所有信息以确保无误。",
                        "Click the 'Send' button to complete the transaction.": "点击“发送”按钮以完成交易。",
                        "WithdrawalMethod": "提款方式",
                        "Amount": "金额",
                        "ImportantInformation": "重要信息",
                        "Allfunds": "所有资金将退回原始入金来源。",
                        "Youareentitled": "您每月可享受一次免费提款，之后每次提款将收取25美元手续费。",
                        "FromAccount": "从账户",
                        "ToAccount": "到账户",
                        "ReportType": "报告类型",
                        "DateFrom": "开始日期",
                        "DateTo": "结束日期",
                        "Search": "搜索",
                        "Time": "时间",
                        "Status": "状态",
                        "PENDING": "待处理",
                        "REJECTED": "已拒绝",
                        "APPROVED": "已批准",
                        "AccountType": "账户类型",
                        "PROCEED": "继续",
                        "ViewTrades": "查看交易",
                        "Open Position": "开仓",
                        "Close Position": "平仓",
                        "Symbol": "交易品种",
                        "Ticket": "订单编号",
                        "DealType": "交易类型",
                        "Volume": "交易量",
                        "Price": "价格",
                        "PriceOpen": "开仓价",
                        "PriceSI": "止损价",
                        "PriceTP": "止盈价",
                        "PriceCurrent": "当前价格",
                        "Login": "登录",
                        "NoData": "无数据",
                        "DownloadsForMT5": "MT5 下载",
                        "DownloadsForMT4": "MT4 下载",
                        "DownloadsForCTrader": "cTrader 下载",
                        "DownloadNow": "立即下载",
                        "forAndroid": "适用于安卓",
                        "forWindow": "适用于 Windows",
                        "forMAC": "适用于 MAC",
                        "forPC": "适用于电脑",
                        "UploadDocuments": "上传文件",
                        "ProofofID": "身份证明（护照首页 或 身份证正反面）",
                        "ProofofAddress": "地址证明",
                        "SourceofIncome": "收入来源",
                        "AdditionalDocuments": "其他文件",
                        "ProofofIdentity": "身份认证文件",
                        "CopyofPassport": "护照复印件",
                        "CopyofGovernmentIssuedID": "政府签发的身份证复印件",
                        "ProofofResidentialAddress": "居住地址证明",
                        "UtilityBill": "水电账单",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "当前租赁合同/租房协议作为收入来源",
                        "Recentbankstatementshowingsalary": "近期显示工资的银行对账单",
                        "Payslip": "工资单",
                        "EmploymentContracttoshowyourincomefunds": "显示收入来源的雇佣合同",
                        "NoteDocuments": "注意：文件必须在最近3个日历月内签发",
                        "Title": "标题",
                        "UploadedAt": "上传时间",
                        "KYCDocuments": "KYC 文件",
                        "OPENANEWDEMOACCOUNT": "开设新的模拟账户",
                        "OPENANEWLIVEACCOUNT": "开设新的真实账户",
                        "File": "文件",
                        "WhishMoneyInstructions": "使用 Wish Money 应用转账，请按照以下步骤操作：",
                        "StepByStepInstructions": "详细步骤说明",
                        "Step1": "步骤1：下载并安装 Wish Money 应用：",
                        "Step1Details": "访问",
                        "Step1Details1": "Wish Money 应用下载页面。",
                        "Step1Details2": "在您的手机上下载并安装该应用。",
                        "Step2": "步骤2：登录 Wish Money 应用：",
                        "Step2Details": "打开该应用。",
                        "Step2Details1": "输入您的账户信息以登录。",
                        "Step3": "步骤3：进入金融分类：",
                        "Step3Details": "登录后，在菜单中选择“金融”分类。",
                        "Step4": "步骤4：输入收款人手机号：",
                        "Step4Details": "在指定字段中输入收款人手机号码：71180175。",
                        "Step5": "步骤5：指定转账金额：",
                        "Step5Details": "输入您想要转账的美元金额。",
                        "Step6": "步骤6：备注交易账户信息：",
                        "Step6Details": "在备注栏中输入交易账户号码及 GoDoCM Dubai。",
                        "Step6Details1": "示例：12345678 - GoDoCM Dubai。",
                        "Step7": "步骤7：完成交易：",
                        "Step7Details": "请仔细检查所有信息是否正确。",
                        "Steps7Details1": "点击“发送”按钮完成交易。",
                        "CryptoCurrency": "加密货币",
                        "Network": "网络",
                        "Address": "地址",
                        "PleaseNoteMinimumWithdrawal": "请注意最低提款金额为10美元",
                        "AddWallet": "添加钱包",
                        "Wallet": "钱包",
                        "AddNewWallet": "添加新钱包",
                        "Add": "添加",
                        "OpenPosition": "开仓",
                        "ClosePosition": "平仓",
                        "Profit": "利润",
                        "Platform": "平台",
                        "Iran": "伊朗",
                        "DealId": "交易编号",
                        "Entry": "入场",
                        "PositionId": "仓位编号",
                        "OpenTimeStamp": "开仓时间戳",
                        "CloseTimeStamp": "平仓时间戳",
                        "EntryPrice": "入场价格",
                        "ClosePrice": "平仓价格",
                        "Direction": "方向",
                        "Commission": "佣金",
                        "Swap": "掉期",
                        "usedMargin": "已用保证金",
                        "forIso": "适用于 iOS",
                        "Iraq": "伊拉克",
                        "Turkey": "土耳其",
                        "Jordan": "约旦",
                        "Pakistan": "巴基斯坦",
                        "India": "印度",
                        "PayPal": "PayPal",
                        "Russia": "俄罗斯",
                        "mexapay": "MexaPay",
                        "InstructionsforTransferringFundsUsingWhishMoney": "使用 Wish Money 转账说明",
                        "AccesstheWhishMoneyApp": "访问 Wish Money 应用：",
                        "AccessTheWhishMoneyApp": "在手机上打开 Wish Money 应用。",
                        "CompleteTheTransfer": "完成转账",
                        "RecipientsPhoneNumber": "输入收款人手机号码：70809031。",
                        "TransferAmount": "输入转账金额（美元）。",
                        "Fee": "重要提示：请在转账金额中加入 1% 的手续费。",
                        "Example": "示例：若要转账 100 美元，请转 101 美元。",
                        "SendAReceiptImage": "完成交易后，拍摄收据照片并通过 WhatsApp 发送至",
                        "SendaReceipt": "发送收据图片：",
                        "ConfirmtheInfo": "步骤4：确认信息：",
                        "ConfirmTheInformation": "确保输入的所有信息都正确。",
                        "InstructionsforTransferringFundsUsingOMT": "使用 OMT 转账说明",
                        "AccesstheOMT": "访问 OMT 应用：",
                        "AccessTheOMTApp": "在手机上打开 OMT 应用。",
                        "CompleteTransfer": "完成转账",
                        "RecipientsPhoneNumberOMT": "输入收款人手机号码：70809031。",
                        "TransferAmountOMT": "输入转账金额（美元）。",
                        "SendAReceiptImageOMT": "完成交易后，拍摄收据照片并通过 WhatsApp 发送至",
                        "ConfirmtheInfoOMT": "确认信息：",
                        "ProfitWithdrawalProcedures": "盈利提款流程",
                        "RequestAWithdrawal": "请求提款：",
                        "ProfitWithdrawalRequest": "通过 WhatsApp 发送盈利提款请求至，",
                        "ProfitWithdrawalRequest2": "并注明要提款的金额。",
                        "CompleteTheProcess": "完成流程：",
                        "WithdrawalProcess": "审核信息无误后将处理提款请求。",
                        "InstructionsforDepositingFundsviaInstaPay": "通过 InstaPay 存款说明",
                        "OpenInstaPayApp": "打开 InstaPay 应用",
                        "LaunchtheInstaPayapponyourphone": "在手机上启动 InstaPay 应用。",
                        "TransferDetails": "转账详情",
                        "EnterRecipientAccountNumber": "输入收款账户邮箱：mglamie@instapay",
                        "Thetransferrate": "汇率：",
                        "TransferRate": "1 美元 = 49 埃镑",
                        "ExampleDeposit": "示例：若要存入 100 美元，请转 4900 埃镑",
                        "CompleteTransaction": "完成交易",
                        "Confirmthedetailsandfinalizethetransfer": "确认详情并完成转账。",
                        "SaveTransactionReceipt": "保存交易收据",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "截图或记下交易编号以备后用。",
                        "InstaPay": "InstaPay",
                        "JordanPay": "约旦支付",
                        "RusiaPay": "俄罗斯支付",
                        "MobiPay": "MobiPay",
                        "TurkeyPay": "土耳其支付",
                        "IraqPay": "伊拉克支付",
                        "UploadReceipt": "上传收据",
                        "UploadPaymentReceipt": "上传支付凭证",
                        "OrderId": "订单编号",
                        "NetSettle": "净结算",
                        "EndTime": "到期时间",
                        "GTNType": "类型",
                        "Exchange": "交易所",
                        "ISINCode": "ISIN代码",
                        "Channel": "渠道",
                        "DownloadsForGTN": "GTN 下载",
                        "ImportantNote": "重要提示",
                        "ToChangePassword": "要更改 GTN 密码，请访问此链接",
                        "GTNLogin": "GTN 登录",
                        "LoginToGTN": "并登录到您的 GTN 帐户以更改密码",
                        "ChangingPassword": "在此更改密码只会更改客户端门户的密码，而不会更改GTN交易平台的密码",
                        "BankAccount": "银行账户",
                        "ReceiverName": "收款人姓名",
                        "SelectCreditBonus": "选择信用奖励",
                        "ReviewConditions": "在选择您的信用奖励之前，请点击下面的链接查看奖金条款和条件。:",
                        "BonusTermsConditions": "奖金条款和条件",
                        "bonus": "奖金",
                        "ClaimBonus": "🎁 申请奖金",
                        "PreferredBonus": "从下拉菜单中选择您偏好的奖金百分比和账户号码。",
                        "Acknowledgment": "✅ 确认",
                        "SubmitBonusRequest": "点击提交奖金申请，您确认：",
                        "AcceptedTerms": "您已阅读并接受奖金条款和条件。",
                        "AcceptedTerms1": "您了解奖金积分是促销性质的，受GODO内部政策约束。",
                        "AcceptedTerms2": "GODO保留随时修改或终止奖金的权利，无需事先通知或解释",
                        "request": "请求免隔夜利息账户",
                        "ImpNote": "重要说明",
                        "description": "如果您希望申请免隔夜利息（伊斯兰）交易账户，请阅读",
                        "terms": "条款",
                        "carefully": "请在提交您的申请前仔细阅读。",
                        "swapApproval": "免隔夜利息状态需经GODO风险团队批准。",
                        "swapRights": "GODO保留随时撤销或修改免隔夜利息状态的权利，恕不另行通知。",
                        "swapPurpose": "免隔夜利息账户严格为遵循伊斯兰金融原则的客户提供。"
                    }
                }
            },
            tr: {
                translation: {
                    description: {
                        "Dashboard": "Gösterge Paneli",
                        "Accounts": "Hesaplar",
                        "LiveAccounts": "Gerçek Hesaplar",
                        "DemoAccounts": "Demo Hesaplar",
                        "ChangePassword": "Şifre Değiştir",
                        "SwapFree": "Swap Yok",
                        "passwordType": "Şifre Türü",
                        "Deposit": "Para Yatırma",
                        "Withdrawals": "Para Çekme",
                        "Withdrawal": "Çekim",
                        "InternalTransfer": "Dahili Transfer",
                        "PaymentHistory": "Ödeme Geçmişi",
                        "TradeHistory": "Ticaret Geçmişi",
                        "Platforms": "Platformlar",
                        "Documents": "Belgeler",
                        "LiveUpdates": "Canlı Güncellemeler",
                        "MarketUpdates": "Piyasa Güncellemeleri",
                        "MarketOverview": "Piyasa Genel Görünümü",
                        "EconomyCalander": "Ekonomi Takvimi",
                        "Webinar": "Web Semineri",
                        "UpcomingWebinar": "Yaklaşan Web Semineri",
                        "Coaching": "Koçluk",
                        "KYCStatus": "KYC Durumu",
                        "Pending": "Beklemede",
                        "Approved": "Onaylandı",
                        "TradingStatus": "Ticaret Durumu",
                        "Disabled": "Devre Dışı",
                        "Enabled": "Etkin",
                        "Profile": "Profil",
                        "SignOut": "Çıkış Yap",
                        "BALANCE": "BAKİYE",
                        "EQUITY": "ÖZKAYNAK",
                        "DEPOSITS": "YATIRIMLAR",
                        "WITHDRAWAL": "ÇEKİM",
                        "TradingAccounts": "Ticaret Hesapları",
                        "TradingPlatform": "Ticaret Platformu",
                        "AccountNumber": "Hesap Numarası",
                        "Type": "Platform Türü",
                        "Balance": "Bakiye",
                        "Equity": "Özkaynak",
                        "Stopout": "Zarar Durdur",
                        "Leverage": "Kaldıraç",
                        "Action": "İşlem",
                        "Account": "Hesap",
                        "GoDo-Live": "GoDo-Gerçek",
                        "GoDo-Server": "GoDo-Sunucu",
                        "GoDo-Demo": "GoDo-Demo",
                        "Currency": "Para Birimi",
                        "FundNow": "Şimdi Fonla",
                        "CreateAccount": "Hesap Oluştur",
                        "NewPassword": "Yeni Şifre",
                        "ConfirmNewPassword": "Yeni Şifreyi Onayla",
                        "Submit": "Gönder",
                        "CardPayment": "Kart Ödemesi",
                        "BankTransfer": "Banka Transferi",
                        "CryptoDetails": "Kripto Detayları",
                        "PerfectMoney": "Perfect Money",
                        "SticPayment": "Stic Ödemesi",
                        "Skrill": "Skrill",
                        "Neteller": "Neteller",
                        "Africa": "Afrika",
                        "WishMoney": "Wish Money",
                        "LocalDeposit": "Yerel Yatırım",
                        "Morocco": "Fas",
                        "DepositCurrency": "Yatırım Para Birimi",
                        "AmountInUSD": "USD Olarak Tutar",
                        "AmountInMAD": "MAD Olarak Tutar",
                        "AmountInSYP": "SYP Olarak Tutar",
                        "Note": "Not",
                        "TradingAccount": "Ticaret Hesabı",
                        "AfrAsiaBankUSD": "AfrAsia Bank USD",
                        "AfrAsiaBankEUR": "AfrAsia Bank EUR",
                        "AfrAsiaBankAED": "AfrAsia Bank AED",
                        "CBDBank": "CBD Bank",
                        "EqualsMoney": "Equals Money",
                        "Currencies": "Para Birimleri",
                        "BeneficiaryName": "Lehdar Adı",
                        "BeneficiaryAccount": "Lehdar Hesabı",
                        "BeneficiaryAddress": "Lehdar Adresi",
                        "BankName": "Banka Adı",
                        "ID": "Kimlik",
                        "BankAddress": "Banka Adresi",
                        "IBANNumber": "IBAN Numarası",
                        "SwiftCode": "Swift Kodu",
                        "MinimumAmount": "Minimum Tutar",
                        "AccountForClient": "Müşteri Hesabı",
                        "AfrAsiaBankLtd": "AfrAsia Bank Ltd",
                        "GODOLTD-CLIENTACCOUNT": "GODO LTD - MÜŞTERİ HESABI",
                        "3rdFloor,StandardCharteredTower,Cybercity,Ebene,72201,Mauritius": "3. Kat, Standard Chartered Kulesi, Cybercity, Ebene, 72201, Mauritius",
                        "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius": "Bowen Square 10, Dr Ferriere Caddesi, Port Louis, Mauritius",
                        "OnlineFunding": "Çevrimiçi Fonlama",
                        "Pleasenotecrypto": "Lütfen ticaret bütünlüğünü korumak için kripto yatırımları yalnızca USDT ve USDC para birimlerinde kabul edildiğini unutmayın",
                        "The customer is responsible for any gas fees applied by the exchange": "Müşteri, borsa tarafından uygulanan tüm gas ücretlerinden sorumludur",
                        "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department": "Çekimler, uyum departmanımız tarafından hesap önceden temizlenmedikçe 15 gün süreyle bloklanacaktır",
                        "All funds to be returned to original funding source": "Tüm fonlar orijinal finansman kaynağına iade edilecektir",
                        "TradingAccountID": "Ticaret Hesabı ID",
                        "DepositAmountinUSD": "USD Olarak Yatırılan Tutar",
                        "WalletAddress": "Cüzdan Adresi",
                        "Iacceptthe": "Kabul ediyorum",
                        "TermsandConditionsforCreditCardDisclaimer": "Kredi Kartı Feragat Şartları ve Koşulları",
                        "Next": "İleri",
                        "PayeeAccount": "Alıcı Hesabı",
                        "SupportService": "Destek Servisi",
                        "Doyouhaveaquestion": "Yatırımla ilgili bir sorunuz mu var? Lütfen iletişime geçin",
                        "ourFinancialSupportService": "finansal destek servisimizle.",
                        "Information": "Bilgi",
                        "Exchangeratesandcommission": "Döviz kurları ve komisyon",
                        "Paymentagentcontacts": "Ödeme temsilcisi iletişimleri",
                        "AgentName": "Temsilci Adı",
                        "MoroccoPaymentAgent": "Fas Ödeme Temsilcisi",
                        "Website": "Web Sitesi",
                        "WorkingHours": "Çalışma Saatleri",
                        "WhishMoneyPaymentInstructions": "Whish Money Ödeme Talimatları",
                        "Step-by-Step Instructions1. Download and Install the Wish Money App": "Adım Adım Talimatlar 1. Wish Money Uygulamasını indirin ve yükleyin",
                        "Visit the Wish Money App download page.": "Wish Money Uygulama indirme sayfasını ziyaret edin.",
                        "Download and install the app on your mobile device.": "Uygulamayı mobil cihazınıza indirin ve yükleyin.",
                        "Login to the Wish Money App": "Wish Money Uygulamasına Giriş Yapın",
                        "Open the app.": "Uygulamayı açın.",
                        "Enter your login credentials to access your account.": "Hesabınıza erişmek için giriş bilgilerinizi girin.",
                        "Navigate to the Finance Category": "Finans Kategorisine Gidin",
                        "After logging in, choose the 'Finance' category from the menu options.": "Giriş yaptıktan sonra menüden \"Finans\" kategorisini seçin.",
                        "Enter the Receiver's Phone Number": "Alıcının Telefon Numarasını Girin",
                        "In the designated field, input the receiver's phone number: 71180175.": "Belirtilen alana alıcının telefon numarasını girin: 71180175.",
                        "Specify the Transfer Amount": "Transfer Tutarını Belirtin",
                        "Enter the amount you wish to transfer in USD.": "Transfer etmek istediğiniz tutarı USD olarak girin.",
                        "Add a Note with Your Trading Account Details": "Ticaret Hesabı Detaylarınızı Not Olarak Ekleyin",
                        "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.": "Not alanına ticaret hesap numaranızı - GoDoCM Dubai olarak girin. Örnek: 12345678 - GoDoCM Dubai.",
                        "Complete the Transaction": "İşlemi Tamamla",
                        "Review all the details to ensure accuracy.": "Doğruluğu sağlamak için tüm detayları gözden geçirin.",
                        "Click the 'Send' button to complete the transaction.": "\"Gönder\" düğmesine tıklayarak işlemi tamamlayın.",
                        "WithdrawalMethod": "Çekim Yöntemi",
                        "Amount": "Tutar",
                        "ImportantInformation": "Önemli Bilgi",
                        "Allfunds": "Tüm fonlar orijinal finansman kaynağına iade edilecektir.",
                        "Youareentitled": "Ayda bir ücretsiz çekim hakkınız vardır; sonrası için standart 25$ çekim ücreti uygulanır.",
                        "FromAccount": "Hesaptan",
                        "ToAccount": "Hesaba",
                        "ReportType": "Rapor Türü",
                        "DateFrom": "Başlangıç Tarihi",
                        "DateTo": "Bitiş Tarihi",
                        "Search": "Ara",
                        "Time": "Saat",
                        "Status": "Durum",
                        "PENDING": "BEKLEYEN",
                        "REJECTED": "REDDEDİLDİ",
                        "APPROVED": "ONAYLANDI",
                        "AccountType": "Hesap Türü",
                        "PROCEED": "İLERLE",
                        "ViewTrades": "İşlemleri Görüntüle",
                        "Open Position": "Pozisyon Aç",
                        "Close Position": "Pozisyon Kapat",
                        "Symbol": "Sembol",
                        "Ticket": "Bilet",
                        "DealType": "İşlem Türü",
                        "Volume": "Hacim",
                        "Price": "Fiyat",
                        "PriceOpen": "Açılış Fiyatı",
                        "PriceSI": "SL Fiyatı",
                        "PriceTP": "TP Fiyatı",
                        "PriceCurrent": "Mevcut Fiyat",
                        "Login": "Giriş",
                        "NoData": "Veri Yok",
                        "DownloadsForMT5": "MT5 İndirmeler",
                        "DownloadsForMT4": "MT4 İndirmeler",
                        "DownloadsForCTrader": "CTrader İndirmeler",
                        "DownloadNow": "Şimdi İndir",
                        "forAndroid": "Android için",
                        "forWindow": "Windows için",
                        "forMAC": "MAC için",
                        "forPC": "PC için",
                        "UploadDocuments": "Belgeleri Yükle",
                        "ProofofID": "Kimlik Belgesi (Pasaport Ön Sayfası veya Kimliğin Ön ve Arka Yüzü)",
                        "ProofofAddress": "Adres Belgesi",
                        "SourceofIncome": "Gelir Kaynağı",
                        "AdditionalDocuments": "Ek Belgeler",
                        "ProofofIdentity": "Kimlik Belgesi",
                        "CopyofPassport": "Pasaport Fotokopisi",
                        "CopyofGovernmentIssuedID": "Devlet Tarafından Verilen Kimlik Fotokopisi",
                        "ProofofResidentialAddress": "İkametgah Belgesi",
                        "UtilityBill": "Fatura",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "Güncel Kira/Tenancy Sözleşmesi Gelir Kaynağı",
                        "Recentbankstatementshowingsalary": "Maaşınızı Gösteren Son Banka Hesap Özeti",
                        "Payslip": "Maaş Bordrosu",
                        "EmploymentContracttoshowyourincomefunds": "Gelirinizi Gösteren İş Sözleşmesi",
                        "NoteDocuments": "Not: Belgeler son 3 takvim ayı içinde düzenlenmiş olmalıdır",
                        "Title": "Başlık",
                        "UploadedAt": "Yüklenme Tarihi",
                        "KYCDocuments": "KYC Belgeleri",
                        "OPENANEWDEMOACCOUNT": "YENİ BİR DEMO HESAP AÇIN",
                        "OPENANEWLIVEACCOUNT": "YENİ BİR GERÇEK HESAP AÇIN",
                        "File": "Dosya",
                        "WhishMoneyInstructions": "Whish Money Uygulamasını kullanarak fon transferi yapmak için lütfen aşağıdaki adımları izleyin:",
                        "StepByStepInstructions": "Adım Adım Talimatlar",
                        "Step1": "1. Whish Money Uygulamasını İndirin ve Yükleyin:",
                        "Step1Details": "Ziyaret edin.",
                        "Step1Details1": "Whish Money Uygulama indirme sayfasını.",
                        "Step1Details2": "Uygulamayı cihazınıza indirin ve yükleyin.",
                        "Step2": "2. Whish Money Uygulamasına Giriş Yapın:",
                        "Step2Details": "Uygulamayı açın.",
                        "Step2Details1": "Hesabınıza erişmek için giriş bilgilerinizi girin.",
                        "Step3": "3. Finans Kategorisine Gidin:",
                        "Step3Details": "Giriş yaptıktan sonra menüden \"Finans\" kategorisini seçin.",
                        "Step4": "4. Alıcının Telefon Numarasını Girin:",
                        "Step4Details": "Belirtilen alana alıcının telefon numarasını girin: 71180175.",
                        "Step5": "5. Transfer Tutarını Belirtin:",
                        "Step5Details": "Transfer etmek istediğiniz tutarı USD olarak girin.",
                        "Step6": "6. Ticaret Hesabı Detaylarınızı Not Olarak Ekleyin:",
                        "Step6Details": "Not alanına ticaret hesap numaranızı - GoDoCM Dubai olarak girin.",
                        "Step6Details1": "Örnek: 12345678 - GoDoCM Dubai.",
                        "Step7": "7. İşlemi Tamamlayın:",
                        "Step7Details": "Doğruluğu sağlamak için tüm detayları gözden geçirin.",
                        "Steps7Details1": "\"Gönder\" düğmesine tıklayarak işlemi tamamlayın.",
                        "CryptoCurrency": "Kripto Para Birimi",
                        "Network": "Ağ",
                        "Address": "Adres",
                        "PleaseNoteMinimumWithdrawal": "Lütfen minimum çekim tutarının 10$ olduğunu unutmayın",
                        "AddWallet": "Cüzdan Ekle",
                        "Wallet": "Cüzdan",
                        "AddNewWallet": "Yeni Cüzdan Ekle",
                        "Add": "Ekle",
                        "OpenPosition": "Pozisyon Aç",
                        "ClosePosition": "Pozisyon Kapat",
                        "Profit": "Kar",
                        "Platform": "Platform",
                        "Iran": "İran",
                        "DealId": "İşlem ID",
                        "Entry": "Giriş",
                        "PositionId": "Pozisyon ID",
                        "OpenTimeStamp": "Açılış Zaman Damgası",
                        "CloseTimeStamp": "Kapanış Zaman Damgası",
                        "EntryPrice": "Giriş Fiyatı",
                        "ClosePrice": "Kapanış Fiyatı",
                        "Direction": "Yön",
                        "Commission": "Komisyon",
                        "Swap": "Swap",
                        "usedMargin": "Kullanılan Marjin",
                        "forIso": "iOS için",
                        "Iraq": "Irak",
                        "Turkey": "Türkiye",
                        "Jordan": "Ürdün",
                        "Pakistan": "Pakistan",
                        "India": "Hindistan",
                        "PayPal": "PayPal",
                        "Russia": "Rusya",
                        "mexapay": "MexaPay",
                        "InstructionsforTransferringFundsUsingWhishMoney": "Whish Money ile Fon Transferi Talimatları",
                        "AccesstheWhishMoneyApp": "Whish Money Uygulamasına Erişim:",
                        "AccessTheWhishMoneyApp": "Telefonunuzda Whish Money uygulamasını açın.",
                        "CompleteTheTransfer": "Transferi Tamamla",
                        "RecipientsPhoneNumber": "Alıcının telefon numarasını girin: 70809031.",
                        "TransferAmount": "Transfer miktarını USD olarak girin.",
                        "Fee": "Önemli Not: Transfer tutarına %1 ücret ekleyin.",
                        "Example": "Örnek: 100$ göndermek istiyorsanız, 101$ gönderin.",
                        "SendAReceiptImage": "İşlem tamamlandıktan sonra, fişin net bir fotoğrafını çekip WhatsApp üzerinden gönderin",
                        "SendaReceipt": "Fiş Görüntüsü Gönder:",
                        "ConfirmtheInfo": "4. Bilgileri Onaylayın:",
                        "ConfirmTheInformation": "Girilen tüm bilgilerin doğru olduğundan emin olun.",
                        "InstructionsforTransferringFundsUsingOMT": "OMT Kullanarak Fon Transferi Talimatları",
                        "AccesstheOMT": "OMT Uygulamasına Erişin:",
                        "AccessTheOMTApp": "Telefonunuzda OMT uygulamasını açın.",
                        "CompleteTransfer": "Transferi Tamamlayın",
                        "RecipientsPhoneNumberOMT": "Alıcının telefon numarasını girin: 70809031.",
                        "TransferAmountOMT": "Transfer miktarını USD olarak girin.",
                        "SendAReceiptImageOMT": "İşlem tamamlandıktan sonra, fişin net bir fotoğrafını çekip WhatsApp üzerinden gönderin",
                        "ConfirmtheInfoOMT": "Bilgileri Onaylayın:",
                        "ProfitWithdrawalProcedures": "Kar Çekme Prosedürleri",
                        "RequestAWithdrawal": "Çekim Talebi Gönder:",
                        "ProfitWithdrawalRequest": "WhatsApp üzerinden kar çekme talebi gönderin,",
                        "ProfitWithdrawalRequest2": "çekilecek tutarı belirterek.",
                        "CompleteTheProcess": "İşlemi Tamamlayın:",
                        "WithdrawalProcess": "Talep, detaylar incelenip işleme alınacaktır.",
                        "InstructionsforDepositingFundsviaInstaPay": "InstaPay ile Fon Yatırma Talimatları",
                        "OpenInstaPayApp": "InstaPay Uygulamasını Açın",
                        "LaunchtheInstaPayapponyourphone": "Telefonunuzda InstaPay uygulamasını başlatın.",
                        "TransferDetails": "Transfer Detayları",
                        "EnterRecipientAccountNumber": "Alıcının hesap e‑postasını girin: mglamie@instapay",
                        "Thetransferrate": "Transfer oranı:",
                        "TransferRate": "1 USD = 49 EGP",
                        "ExampleDeposit": "Örnek: 100$ yatırmak için 4900 EGP gönderin",
                        "CompleteTransaction": "İşlemi Tamamlayın",
                        "Confirmthedetailsandfinalizethetransfer": "Detayları onaylayın ve transferi tamamlayın.",
                        "SaveTransactionReceipt": "İşlem Makbuzunu Kaydedin",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "İleride referans için ekran görüntüsü alın veya işlem ID’sini not edin.",
                        "InstaPay": "InstaPay",
                        "JordanPay": "Ürdün",
                        "RusiaPay": "Rusya",
                        "DuitPay": "Duit Now",
                        "TurkeyPay": "Türkiye",
                        "IraqPay": "Irak",
                        "UploadReceipt": "Fiş Yükle",
                        "UploadPaymentReceipt": "Ödeme Fişi Yükle",
                        "OrderId": "Sipariş ID",
                        "NetSettle": "Net Tahsilat",
                        "EndTime": "Sona Erme Zamanı",
                        "TouchNGo": "Touch N Go",
                        "FPXPay": "FPX Ödeme",
                        "GTNType": "Tür",
                        "Exchange": "Borsa",
                        "ISINCode": "ISIN Kodu",
                        "Channel": "Kanal",
                        "DownloadsForGTN": "GTN İndirmeler",
                        "ImportantNote": "Önemli Not",
                        "ToChangePassword": "GTN şifresini değiştirmek için bu linki ziyaret edin",
                        "GTNLogin": "GTN Giriş",
                        "LoginToGTN": "şifrenizi değiştirmek için GTN hesabınıza giriş yapın",
                        "ChangingPassword": "Burada şifre değiştirmek yalnızca müşteri portal şifresini değiştirir, GTN ticaret platform şifresini değil",
                        "BankAccount": "Banka Hesabı",
                        "ReceiverName": "Alıcı Adı",
                        "SelectCreditBonus": "Kredi Bonusu Seçin",
                        "ReviewConditions": "Kredi bonusunuzu seçmeden önce lütfen",
                        "BonusTermsConditions": "Bonus Şartlar ve Koşullarını",
                        "Carefully": "dikkatlice okuyun.",
                        "Bonus": "Bonus",
                        "ClaimBonus": "🎁 Bonus Talep Et",
                        "PreferredBonus": "Hesap numaranı içeren açılır listeden tercih ettiğiniz bonus yüzdesini seçin.",
                        "Acknowledgment": "✅ Kabul",
                        "SubmitBonusRequest": "Bonus Talebini Gönder'e tıklayarak şunları kabul etmiş olursunuz:",
                        "AcceptedTerms": "Bonus Şartlar ve Koşullarını okudunuz ve kabul ettiniz.",
                        "AcceptedTerms1": "Bonus kredilerinin promosyon amaçlı olduğunu ve GODO'nun dahili politikalarına tabi olduğunu anlıyorsunuz.",
                        "AcceptedTerms2": "GODO, bonusu önceden haber vermeksizin veya açıklama yapmaksızın değiştirme veya sonlandırma hakkını saklı tutar.",
                        "request": "Swap'sız Hesap Talebi",
                        "ImpNote": "Önemli Notlar",
                        "description": "Swap'sız (İslami) işlem hesabı talep etmek istiyorsanız, lütfen",
                        "terms": "şartları",
                        "carefully": "dikkatlice talebinizi göndermeden önce.",
                        "swapApproval": "Swap'sız statüsü GODO Risk Ekibi'nin onayına tabidir.",
                        "swapRights": "GODO, Swap'sız statüsünü herhangi bir zamanda önceden bildirimde bulunmadan iptal etme veya değiştirme hakkını saklı tutar.",
                        "swapPurpose": "Swap'sız hesaplar, sadece İslami finans prensiplerine uyan müşteriler için tasarlanmıştır."
                    }
                }
            },
            id: {
                translation: {
                    description: {
                        "Dashboard": "Dasbor",
                        "Accounts": "Akun",
                        "LiveAccounts": "Akun Live",
                        "DemoAccounts": "Akun Demo",
                        "ChangePassword": "Ubah Kata Sandi",
                        "SwapFree": "Bebas Swap",
                        "passwordType": "Jenis Kata Sandi",
                        "Deposit": "Setoran",
                        "Withdrawals": "Penarikan",
                        "Withdrawal": "Penarikan",
                        "InternalTransfer": "Transfer Internal",
                        "PaymentHistory": "Riwayat Pembayaran",
                        "TradeHistory": "Riwayat Perdagangan",
                        "Platforms": "Platform",
                        "Documents": "Dokumen",
                        "LiveUpdates": "Pembaruan Langsung",
                        "MarketUpdates": "Pembaruan Pasar",
                        "MarketOverview": "Ikhtisar Pasar",
                        "EconomyCalander": "Kalender Ekonomi",
                        "Webinar": "Webinar",
                        "UpcomingWebinar": "Webinar Mendatang",
                        "Coaching": "Pelatihan",
                        "KYCStatus": "Status KYC",
                        "Pending": "Menunggu",
                        "Approved": "Disetujui",
                        "TradingStatus": "Status Perdagangan",
                        "Disabled": "Nonaktif",
                        "Enabled": "Aktif",
                        "Profile": "Profil",
                        "SignOut": "Keluar",
                        "BALANCE": "SALDO",
                        "EQUITY": "EKUITAS",
                        "DEPOSITS": "SETORAN",
                        "WITHDRAWAL": "PENARIKAN",
                        "TradingAccounts": "Akun Perdagangan",
                        "TradingPlatform": "Platform Perdagangan",
                        "AccountNumber": "Nomor Akun",
                        "Type": "Jenis Platform",
                        "Balance": "Saldo",
                        "Equity": "Ekuitas",
                        "Stopout": "Stop Out",
                        "Leverage": "Leverage",
                        "Action": "Tindakan",
                        "Account": "Akun",
                        "GoDo-Live": "GoDo-Live",
                        "GoDo-Server": "GoDo-Server",
                        "GoDo-Demo": "GoDo-Demo",
                        "Currency": "Mata Uang",
                        "FundNow": "Danai Sekarang",
                        "CreateAccount": "Buat Akun",
                        "NewPassword": "Kata Sandi Baru",
                        "ConfirmNewPassword": "Konfirmasi Kata Sandi Baru",
                        "Submit": "Kirim",
                        "CardPayment": "Pembayaran Kartu",
                        "BankTransfer": "Transfer Bank",
                        "CryptoDetails": "Detail Kripto",
                        "PerfectMoney": "Perfect Money",
                        "SticPayment": "Pembayaran Stic",
                        "Skrill": "Skrill",
                        "Neteller": "Neteller",
                        "Africa": "Afrika",
                        "WishMoney": "Wish Money",
                        "LocalDeposit": "Setoran Lokal",
                        "Morocco": "Maroko",
                        "DepositCurrency": "Mata Uang Setoran",
                        "AmountInUSD": "Jumlah dalam USD",
                        "AmountInMAD": "Jumlah dalam MAD",
                        "AmountInSYP": "Jumlah dalam SYP",
                        "Note": "Catatan",
                        "TradingAccount": "Akun Perdagangan",
                        "AfrAsiaBankUSD": "AfrAsia Bank USD",
                        "AfrAsiaBankEUR": "AfrAsia Bank EUR",
                        "AfrAsiaBankAED": "AfrAsia Bank AED",
                        "CBDBank": "Bank CBD",
                        "EqualsMoney": "Equals Money",
                        "Currencies": "Mata Uang",
                        "BeneficiaryName": "Nama Penerima",
                        "BeneficiaryAccount": "Akun Penerima",
                        "BeneficiaryAddress": "Alamat Penerima",
                        "BankName": "Nama Bank",
                        "ID": "ID",
                        "BankAddress": "Alamat Bank",
                        "IBANNumber": "Nomor IBAN",
                        "SwiftCode": "Kode SWIFT",
                        "MinimumAmount": "Jumlah Minimum",
                        "AccountForClient": "Akun untuk Klien",
                        "AfrAsiaBankLtd": "AfrAsia Bank Ltd",
                        "GODOLTD-CLIENTACCOUNT": "GODO LTD - AKUN KLIEN",
                        "3rdFloor,StandardCharteredTower,Cybercity,Ebene,72201,Mauritius": "Lantai 3, Menara Standard Chartered, Cybercity, Ebene, 72201, Mauritius",
                        "Bowen Square 10, Dr Ferriere Street, Port Louis, Mauritius": "Bowen Square 10, Jalan Dr Ferriere, Port Louis, Mauritius",
                        "OnlineFunding": "Pendanaan Online",
                        "Pleasenotecrypto": "Harap dicatat bahwa setoran kripto hanya diterima dalam mata uang USDT dan USDC dengan ketentuan berikut untuk melindungi integritas transaksi",
                        "The customer is responsible for any gas fees applied by the exchange": "Pelanggan bertanggung jawab atas biaya gas yang dikenakan oleh bursa",
                        "Withdrawals will be blocked for a period of 15 days unless the account has been cleared earlier by our Compliance department": "Penarikan akan diblokir selama 15 hari kecuali akun telah disetujui lebih awal oleh departemen Kepatuhan kami",
                        "All funds to be returned to original funding source": "Semua dana akan dikembalikan ke sumber pendanaan asal",
                        "TradingAccountID": "ID Akun Perdagangan",
                        "DepositAmountinUSD": "Jumlah Setoran dalam USD",
                        "WalletAddress": "Alamat Dompet",
                        "Iacceptthe": "Saya menyetujui",
                        "TermsandConditionsforCreditCardDisclaimer": "Syarat dan Ketentuan untuk Penafian Kartu Kredit",
                        "Next": "Berikutnya",
                        "PayeeAccount": "Akun Penerima",
                        "SupportService": "Layanan Dukungan",
                        "Doyouhaveaquestion": "Apakah Anda memiliki pertanyaan tentang setoran? Silakan hubungi",
                        "ourFinancialSupportService": "Layanan Dukungan Keuangan kami.",
                        "Information": "Informasi",
                        "Exchangeratesandcommission": "Kurs dan Komisi",
                        "Paymentagentcontacts": "Kontak Agen Pembayaran",
                        "AgentName": "Nama Agen",
                        "MoroccoPaymentAgent": "Agen Pembayaran Maroko",
                        "Website": "Situs Web",
                        "WorkingHours": "Jam Kerja",
                        "WhishMoneyPaymentInstructions": "Instruksi Pembayaran Whish Money",
                        "Step-by-Step Instructions1. Download and Install the Wish Money App": "Instruksi Langkah-demi-Langkah 1. Unduh dan Instal Aplikasi Wish Money",
                        "Visit the Wish Money App download page.": "Kunjungi halaman unduhan Aplikasi Wish Money.",
                        "Download and install the app on your mobile device.": "Unduh dan instal aplikasi di perangkat seluler Anda.",
                        "Login to the Wish Money App": "Masuk ke Aplikasi Wish Money",
                        "Open the app.": "Buka aplikasinya.",
                        "Enter your login credentials to access your account.": "Masukkan data login Anda untuk mengakses akun Anda.",
                        "Navigate to the Finance Category": "Arahkan ke Kategori Keuangan",
                        "After logging in, choose the 'Finance' category from the menu options.": "Setelah masuk, pilih kategori 'Keuangan' dari menu.",
                        "Enter the Receiver's Phone Number": "Masukkan Nomor Telepon Penerima",
                        "In the designated field, input the receiver's phone number: 71180175.": "Di kolom yang disediakan, masukkan nomor telepon penerima: 71180175.",
                        "Specify the Transfer Amount": "Tentukan Jumlah Transfer",
                        "Enter the amount you wish to transfer in USD.": "Masukkan jumlah yang ingin Anda transfer dalam USD.",
                        "Add a Note with Your Trading Account Details": "Tambahkan Catatan dengan Detail Akun Trading Anda",
                        "In the note field, enter your trading account number followed by - GoDoCM Dubai. Example: 12345678 - GoDoCM Dubai.": "Di kolom catatan, masukkan nomor akun trading Anda diikuti dengan - GoDoCM Dubai. Contoh: 12345678 - GoDoCM Dubai.",
                        "Complete the Transaction": "Selesaikan Transaksi",
                        "Review all the details to ensure accuracy.": "Tinjau semua detail untuk memastikan keakuratan.",
                        "Click the 'Send' button to complete the transaction.": "Klik tombol 'Kirim' untuk menyelesaikan transaksi.",
                        "WithdrawalMethod": "Metode Penarikan",
                        "Amount": "Jumlah",
                        "ImportantInformation": "Informasi Penting",
                        "Allfunds": "Semua dana akan dikembalikan ke sumber pendanaan asal.",
                        "Youareentitled": "Anda berhak atas satu penarikan gratis per bulan; setelah itu, biaya penarikan standar sebesar $25 akan dikenakan.",
                        "FromAccount": "Dari Akun",
                        "ToAccount": "Ke Akun",
                        "ReportType": "Jenis Laporan",
                        "DateFrom": "Tanggal Dari",
                        "DateTo": "Tanggal Sampai",
                        "Search": "Cari",
                        "Time": "Waktu",
                        "Status": "Status",
                        "PENDING": "MENUNGGU",
                        "REJECTED": "DITOLAK",
                        "APPROVED": "DISETUJUI",
                        "AccountType": "Jenis Akun",
                        "PROCEED": "LANJUTKAN",
                        "ViewTrades": "Lihat Transaksi",
                        "Open Position": "Buka Posisi",
                        "Close Position": "Tutup Posisi",
                        "Symbol": "Simbol",
                        "Ticket": "Tiket",
                        "DealType": "Jenis Transaksi",
                        "Volume": "Volume",
                        "Price": "Harga",
                        "PriceOpen": "Harga Buka",
                        "PriceSI": "Harga SL",
                        "PriceTP": "Harga TP",
                        "PriceCurrent": "Harga Saat Ini",
                        "Login": "Masuk",
                        "NoData": "Tidak Ada Data",
                        "DownloadsForMT5": "Unduhan untuk MT5",
                        "DownloadsForMT4": "Unduhan untuk MT4",
                        "DownloadsForCTrader": "Unduhan untuk CTrader",
                        "DownloadNow": "Unduh Sekarang",
                        "forAndroid": "untuk Android",
                        "forWindow": "untuk Windows",
                        "forMAC": "untuk MAC",
                        "forPC": "untuk PC",
                        "UploadDocuments": "Unggah Dokumen",
                        "ProofofID": "Bukti Identitas (Halaman depan paspor ATAU sisi depan dan belakang KTP)",
                        "ProofofAddress": "Bukti Alamat",
                        "SourceofIncome": "Sumber Penghasilan",
                        "AdditionalDocuments": "Dokumen Tambahan",
                        "ProofofIdentity": "Bukti Identitas",
                        "CopyofPassport": "Salinan Paspor",
                        "CopyofGovernmentIssuedID": "Salinan KTP yang Dikeluarkan Pemerintah",
                        "ProofofResidentialAddress": "Bukti Alamat Tempat Tinggal",
                        "UtilityBill": "Tagihan Utilitas",
                        "CurrentLease/TenancyAgreementSourceOfIncome": "Perjanjian Sewa Saat Ini / Sumber Penghasilan",
                        "Recentbankstatementshowingsalary": "Rekening koran terbaru yang menunjukkan gaji",
                        "Payslip": "Slip Gaji",
                        "EmploymentContracttoshowyourincomefunds": "Kontrak Kerja untuk menunjukkan sumber dana penghasilan",
                        "NoteDocuments": "Catatan: Dokumen harus diterbitkan dalam 3 bulan kalender terakhir",
                        "Title": "Judul",
                        "UploadedAt": "Diupload Pada",
                        "KYCDocuments": "Dokumen KYC",
                        "OPENANEWDEMOACCOUNT": "BUKA AKUN DEMO BARU",
                        "OPENANEWLIVEACCOUNT": "BUKA AKUN LIVE BARU",
                        "File": "Berkas",
                        "WhishMoneyInstructions": "Untuk mentransfer dana menggunakan Aplikasi Whish Money, silakan ikuti langkah-langkah berikut:",
                        "StepByStepInstructions": "Instruksi Langkah-demi-Langkah",
                        "Step1": "1. Unduh dan Instal Aplikasi Whish Money:",
                        "Step1Details": "Kunjungi.",
                        "Step1Details1": "halaman unduh Aplikasi Whish Money.",
                        "Step1Details2": "Unduh dan instal aplikasi di perangkat seluler Anda.",
                        "Step2": "2. Masuk ke Aplikasi Whish Money:",
                        "Step2Details": "Buka aplikasi.",
                        "Step2Details1": "Masukkan kredensial login Anda untuk mengakses akun Anda.",
                        "Step3": "3. Arahkan ke Kategori Keuangan:",
                        "Step3Details": "Setelah masuk, pilih kategori 'Keuangan' dari menu.",
                        "Step4": "4. Masukkan Nomor Telepon Penerima:",
                        "Step4Details": "Di kolom yang disediakan, masukkan nomor telepon penerima: 71180175.",
                        "Step5": "5. Tentukan Jumlah Transfer:",
                        "Step5Details": "Masukkan jumlah yang ingin Anda transfer dalam USD.",
                        "Step6": "6. Tambahkan Catatan dengan Detail Akun Trading Anda:",
                        "Step6Details": "Di kolom catatan, masukkan nomor akun trading Anda diikuti dengan - GoDoCM Dubai.",
                        "Step6Details1": "Contoh: 12345678 - GoDoCM Dubai.",
                        "Step7": "7. Selesaikan Transaksi:",
                        "Step7Details": "Tinjau semua detail untuk memastikan keakuratan.",
                        "Steps7Details1": "Klik tombol 'Kirim' untuk menyelesaikan transaksi.",
                        "CryptoCurrency": "Mata Uang Kripto",
                        "Network": "Jaringan",
                        "Address": "Alamat",
                        "PleaseNoteMinimumWithdrawal": "Harap diperhatikan jumlah penarikan minimum adalah $10",
                        "AddWallet": "Tambah Dompet",
                        "Wallet": "Dompet",
                        "AddNewWallet": "Tambah Dompet Baru",
                        "Add": "Tambah",
                        "OpenPosition": "Posisi Terbuka",
                        "ClosePosition": "Posisi Tertutup",
                        "Profit": "Keuntungan",
                        "Platform": "Platform",
                        "Iran": "Iran",
                        "DealId": "ID Transaksi",
                        "Entry": "Masuk",
                        "PositionId": "ID Posisi",
                        "OpenTimeStamp": "Waktu Buka",
                        "CloseTimeStamp": "Waktu Tutup",
                        "EntryPrice": "Harga Masuk",
                        "ClosePrice": "Harga Tutup",
                        "Direction": "Arah",
                        "Commission": "Komisi",
                        "Swap": "Swap",
                        "usedMargin": "Margin Digunakan",
                        "forIso": "untuk iOS",
                        "Iraq": "Irak",
                        "Turkey": "Turki",
                        "Jordan": "Yordania",
                        "Pakistan": "Pakistan",
                        "India": "India",
                        "PayPal": "PayPal",
                        "Russia": "Rusia",
                        "mexapay": "MexaPay",
                        "InstructionsforTransferringFundsUsingWhishMoney": "Instruksi untuk Mentransfer Dana Menggunakan Whish Money",
                        "AccesstheWhishMoneyApp": "Akses Aplikasi Whish Money:",
                        "AccessTheWhishMoneyApp": "Buka aplikasi Whish Money di ponsel Anda.",
                        "CompleteTheTransfer": "Selesaikan Transfer",
                        "RecipientsPhoneNumber": "Masukkan nomor telepon penerima: 70809031.",
                        "TransferAmount": "Masukkan jumlah transfer dalam USD.",
                        "Fee": "Catatan Penting: Tambahkan biaya 1% ke jumlah transfer.",
                        "Example": "Contoh Jika Anda ingin mentransfer $100, kirim $101.",
                        "SendAReceiptImage": "Setelah menyelesaikan transaksi, ambil foto jelas struk dan kirim via WhatsApp ke",
                        "SendaReceipt": "Kirim Gambar Struk:",
                        "ConfirmtheInfo": "4. Konfirmasi Informasi:",
                        "ConfirmTheInformation": "Pastikan semua detail yang dimasukkan sudah benar.",
                        "InstructionsforTransferringFundsUsingOMT": "Instruksi untuk Mentransfer Dana Menggunakan OMT",
                        "AccesstheOMT": "Akses Aplikasi OMT:",
                        "AccessTheOMTApp": "Buka aplikasi OMT di ponsel Anda.",
                        "CompleteTransfer": "Selesaikan Transfer",
                        "RecipientsPhoneNumberOMT": "Masukkan nomor telepon penerima: 70809031.",
                        "TransferAmountOMT": "Masukkan jumlah transfer dalam USD.",
                        "SendAReceiptImageOMT": "Setelah menyelesaikan transaksi, ambil foto jelas struk dan kirim via WhatsApp ke",
                        "ConfirmtheInfoOMT": "Konfirmasi Informasi:",
                        "ProfitWithdrawalProcedures": "Prosedur Penarikan Keuntungan",
                        "RequestAWithdrawal": "Ajukan Permintaan Penarikan:",
                        "ProfitWithdrawalRequest": "Kirim permintaan penarikan keuntungan melalui WhatsApp ke,",
                        "ProfitWithdrawalRequest2": "dengan menyebutkan jumlah yang akan ditarik.",
                        "CompleteTheProcess": "Selesaikan Proses:",
                        "WithdrawalProcess": "Permintaan akan diproses setelah detail diperiksa.",
                        "InstructionsforDepositingFundsviaInstaPay": "Instruksi untuk Menyetor Dana melalui InstaPay",
                        "OpenInstaPayApp": "Buka Aplikasi InstaPay",
                        "LaunchtheInstaPayapponyourphone": "Jalankan aplikasi InstaPay di ponsel Anda.",
                        "TransferDetails": "Detail Transfer",
                        "EnterRecipientAccountNumber": "Masukkan email akun penerima: mglamie@instapay",
                        "Thetransferrate": "Kurs transfer: ",
                        "TransferRate": "1 USD = 49 EGP",
                        "ExampleDeposit": "Contoh: Untuk menyetor $100, kirim 4900 EGP",
                        "CompleteTransaction": "Selesaikan Transaksi",
                        "Confirmthedetailsandfinalizethetransfer": "Konfirmasi detail dan selesaikan transfer.",
                        "SaveTransactionReceipt": "Simpan Bukti Transaksi",
                        "TakeascreenshotornotedownthetransactionIDforfuturereference": "Ambil tangkapan layar atau catat ID transaksi untuk referensi di masa depan.",
                        "InstaPay": "InstaPay",
                        "JordanPay": "Yordania",
                        "RusiaPay": "Rusia",
                        "DuitPay": "Duit Now",
                        "TurkeyPay": "Turki",
                        "IraqPay": "Irak",
                        "UploadReceipt": "Unggah Bukti Pembayaran",
                        "UploadPaymentReceipt": "Unggah Bukti Pembayaran",
                        "OrderId": "ID Pesanan",
                        "NetSettle": "Penyelesaian Bersih",
                        "EndTime": "Waktu Kedaluwarsa",
                        "TouchNGo": "Touch N Go",
                        "FPXPay": "FPX Pay",
                        "GTNType": "Jenis",
                        "Exchange": "Tukar",
                        "ISINCode": "Kode ISIN",
                        "Channel": "Saluran",
                        "DownloadsForGTN": "Unduhan untuk GTN",
                        "ImportantNote": "Catatan Penting",
                        "ToChangePassword": "Untuk mengganti kata sandi GTN, kunjungi tautan ini",
                        "GTNLogin": "Masuk ke GTN",
                        "LoginToGTN": "dan masuk ke akun GTN Anda untuk mengganti kata sandi",
                        "ChangingPassword": "Mengganti kata sandi di sini hanya akan mengganti kata sandi portal klien, bukan kata sandi platform perdagangan GTN",
                        "BankAccount": "Rekening Bank",
                        "ReceiverName": "Nama Penerima",
                        "SelectCreditBonus": "Pilih Bonus Kredit Anda",
                        "ReviewConditions": "Sebelum memilih bonus kredit Anda, harap baca",
                        "BonusTermsConditions": "Syarat & Ketentuan Bonus",
                        "Carefully": "dengan seksama.",
                        "Bonus": "Bonus",
                        "ClaimBonus": "🎁 Klaim Bonus",
                        "PreferredBonus": "Pilih persentase bonus yang Anda inginkan dari dropdown dengan nomor akun.",
                        "Acknowledgment": "✅ Pengakuan",
                        "SubmitBonusRequest": "Dengan mengklik Kirim Permintaan Bonus, Anda mengakui bahwa:",
                        "AcceptedTerms": "Anda telah membaca dan menerima Syarat & Ketentuan Bonus.",
                        "AcceptedTerms1": "Anda memahami bahwa kredit bonus adalah promosi dan tunduk pada kebijakan internal GODO.",
                        "AcceptedTerms2": "GODO berhak memodifikasi atau menghentikan bonus kapan saja, tanpa pemberitahuan atau penjelasan sebelumnya.",
                        "request": "Permintaan Akun Bebas Swap",
                        "ImpNote": "Catatan Penting",
                        "description": "Jika Anda ingin meminta akun trading Bebas Swap (Islam), harap baca",
                        "terms": "syarat",
                        "carefully": "dengan cermat sebelum mengajukan permintaan Anda.",
                        "swapApproval": "Status Bebas Swap tunduk pada persetujuan Tim Risiko GODO.",
                        "swapRights": "GODO berhak mencabut atau mengubah status Bebas Swap kapan saja tanpa pemberitahuan sebelumnya.",
                        "swapPurpose": "Akun Bebas Swap ditujukan secara ketat untuk klien yang mengikuti prinsip keuangan Islam."
                    }
                }
            }
        }
    });

export default i18n; 